import { HttpClient, HttpEventType, HttpHeaders } from "@angular/common/http";
import { ThrowStmt } from "@angular/compiler";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { ElementRef, EventEmitter, Injectable, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Router , ActivatedRoute} from "@angular/router";
import { NotifierService } from "angular-notifier";
import { Observable, ReplaySubject } from "rxjs";
import { error, keys } from "highcharts";
import { InsightsService } from "src/app/shared/insights/service/insights.service";
import { SharedataService } from "src/app/shared/share/service/sharedata.service";
import { environment } from "src/environments/environment";
import { InsightApiService } from "src/app/shared/insights/service/insight-api.service";
import { HomeService } from "src/app/shared/services/home.service";
import { RoleService } from "src/app/shared/services/role-service/role.service";
import { ApiRequestService } from "src/app/services/api-request/api-request.service";
import { MatDialog } from "@angular/material/dialog";
import { RowClassRules } from "ag-grid-community";
import { SigTestModalComponent } from '../significance-testing/sig-test-modal/sig-test-modal.component';
import { SidePanelService } from "src/app/shared/services/side-pannel/side-pannel.service";
import { Result } from "src/app/project/model/project/project.model";
import { typeUploadFileDropdown, typeUploadTranslateFileConfig } from "./types";
import { DialogContainerComponent } from "../dialog-container/dialog-container.component";
import { map } from "rxjs/operators";
import { J, O } from "@angular/cdk/keycodes";
import { AdvancedSearchService } from "src/app/shared/advanced-search/advanced-search.service";
import { AdvancedFilterService } from "src/app/shared/advanced-filter/advanced-filter.service";

export class Credit{
  total:number = 0;
  locked:number= 0;
}

export class Item {
  fileObj: any;
  file_type: string;
  fileName: string;
  vi_index?: boolean;
  language?:string
  translation_config?: translation_config;
  isAudiotranslator?: boolean;
  translate_numeric?: boolean;
  translate_numeric_to_numeric?: boolean;
  audiotranslation_config?:audiotranslation_config
  translator_lang?: string;
  zip_file_operation?: string | boolean;

  // translator_lang?:string;
  // translator_file?:string;
}

export interface translation_config {
  type: string;
  languageColumnMap?: any[];
}



export interface audiotranslation_config{
  file_name:string;
  fileObj:any;
  translator_lang?: string;
}

export class FileDetails {
  name: string = '';
  date: string = '';
  comment: string = '';
  description: string = '';
}
export class ReportDetails {
  title: string = '';
  uploaded_by?: string = '';
  upload_date?: string = '';
  terget_audience?: string = '';
  sample_size?: string = '';
  source?: string = '';
  completion_date?: string = '';
  report?: string = '';
  project?: string = '';
  description: string = '';
  type?: string = '';
  tags?: string = '';
  interviews?: any[] = [];
  edit: boolean = false;
  files = Array<FileDetails>();
  file_type: string = '';
  project_name?: string = '';
  research_details?= null;
  study_summary?: any ={};
  job_id:string = '';
  objective:string = '';
  bu_code?:string = '';
  api_survey_id?:string = '';
  offline_survey_translation_cost?:string= '';

}

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  public tableExtrationData:any=[];
  public tableExtrationUpperCuts:any=[];
  public tableExtrationLowerCuts:any=[];
  public sidecutV2:any = [];
  public topcutV2:any = [];
  public crosstabOptions:any = {};
  public savedFilters:any = [];
  public viewFormateSelected = 1;
  public selectedCut:any = {};
  public selectedCut1:any = {};
  public file_id:string = '';
  public isFileFound:boolean = false;
  public videoTokenUUid:any = '';
  // public analyzerStauts:boolean = false;
  public videoAnalyzer:any = {};
  public commentCount:number = 0;
  public filterLevels: any = {};
  public totalReportsPage : number = 0;
  public totalFilePage : number = 0;
  public crossTable = new FormGroup({
    "uppercut": new FormControl([]),
    "undercut": new FormControl([])
  })
  // public uppercut = new FormControl();
  // public undercut = new FormControl();
  public dataSource: any = [];
  public formData: FormGroup;
  public jsonData: any = [];
  public jsonDataForGrid: any = [];
  public mainJsonData: any = [];
  public mainClubReq: any = {};
  public isViewFile:boolean;
  public currentFilter : any;
  public abspct:string = 'abs'
  public otherChecks : any = {
    "dataValue":'',
    "viewFormate":'',
    "trendAnalysis":false
  };
  public crossTabReq: any;
  public fileLanguages: any[] = [];
  public fileURL: string = '';
  public fileName: string = '';
  public fileType: string = '';
  public fileCategory: string = '';
  public detailsUUID: string = '';
  public fileUUID: string = '';
  public isUpload: boolean = false;
  public isViSummary: boolean = false;
  public isGroupSummary: boolean = false;
  private initSidePanelTriggered: boolean = false;
  private currentRepoUUID: string = '';
  private lastInsightListFileUUID: string = '';
  private lastFileURLUUID: string = '';
  public isExtractionFilter: boolean = false;
  public isExtractionFilterSave: boolean = false;
  public isExtractionClub: boolean = false;
  public isMoveAllFileOpen: boolean = false;
  public isMoveToNewStudy: boolean = false;
  public selectedStudyIDForMove: string = '';
  public currentFileSource: string = '';
  public projectDetails: any = {};
  public groupList:any[] = [];
  public allGroupList:any[] = [];
  public reportDetailFiles: any[] = [];
  public allRepoFiles: any[] = [];
  public allSelectedFiles: any = [];
  public reportDetails = new ReportDetails();
  public uploadReport = new ReportDetails();
  public isShowStudySummary: boolean = false;
  public researchDetails: any = {};
  public isLoading: boolean = true;
  public isDisableBtn: boolean = false;
  public extensionToMIME: any = [];
  public uploadedFiles: any = [];
  public selectedCuts: string = '';
  public filter_name: string = '';
  public isQual: boolean = false;
  public isReport : boolean = false;
  public isData:boolean = false;
  public isSaveTabs:boolean = false;
  public dataTableOption:any ={};
  public studyId : string = '';
  public isEdit:boolean=false;
  public projectList = [];
  public interviewDetailsQual;
  public shouldKPIExpandedVisible: boolean = false;
  public isMethodology: boolean = false;
  public trackerSessionId = 0;
  public isFileConversionDone:boolean = true;
  public isUiWaitForApiDone:boolean = false;
  public previousRoute: string = '';
  public types = [{ "type": "Qual" }, { "type": "Quant" }];
  public bu_Codes = [
    { bu_code: "32201 - BHT_India Mumbai-1" },
    { bu_code: "32222 - Observer_Mumbai" },
    { bu_code: "532240 - Observer_Delhi" },
    { bu_code: "532241 - Observer_Bengaluru" },
    { bu_code: "532258 - Operations-(Observer IC)" },
    { bu_code: "532255 - INN India UL PT Hub Mumbai-3" },
    { bu_code: "32219 - Ipsos UU_Delhi" },
    { bu_code: "532225 - MSU_Delhi" },
    { bu_code: "32205 - Public Affairs_Delhi" },
    { bu_code: "532243 - Public Affairs_Mumbai" },
    { bu_code: "532245 - Public Affairs_Chennai" },
    { bu_code: "32224 - Health - Mumbai-IPSOS" },
    { bu_code: "32225 - Health - Bangalore-IPSOS" },
    { bu_code: "32226 - Health - Gurgaon-IPSOS" },
    { bu_code: "32220 - Ipsos UU_Bengaluru" },
    { bu_code: "32221 - Ipsos UU_Mumbai" },
    { bu_code: "32212 - Strategy3 India Gurgaon" },
    { bu_code: "32215 - Strategy3 India Mumbai" },
    { bu_code: "532256 - Innovation_Bengaluru" },
    { bu_code: "532273 - Crownit India" }
  ]


  public httpPostOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params: {}
  };
  public isFullFileUploadComponent: string = 'yes';
  public isFullRequestFileComponent: boolean = true;
  //Header Authentication for file type request
  httpPostOptionsFile = {
    withCredentials: true
  };
  public videoTokenDetails: any = {};
  public isAudioFile: boolean = false;
  public isVideoFile: boolean = false;
  // public fileDeletionEvent = new EventEmitter<string>();
  public isRequestFile: boolean = false;
  public isUploadFile: boolean = false;
  public fieldSelectedArr: any = ['Report', 'Questionnaire', 'Data Table - ABS', 'Data Table - PCT', 'Report - KPI View', 'Image', 'Video', 'Audio','Zip',"Translation"];
  public defaultMatSelectFile: typeUploadFileDropdown = { file_type: "", value: "", vi_index : false, language:"", translateConfig: { currType: "", headers: [], customHeaders: [{source: "",destination: "",langCode: ""}], }, zipConfig: { operation: "" } };
  public MatSelectFileArray: typeUploadFileDropdown[] = [];
  public uploadFileContainer: any = [];
  public replaceFileObj: any = {};
  public tempFileDublicateCheckObj: any = {};
  public translateFileUploadedEvent = new EventEmitter<boolean>();
  public uploadMultipleFileContainer: any = [];
  public sharingEmails: any = [];
  public isUploadFileInput: boolean = false;
  public isStudyCreated: boolean = false;
  public copy_file_id :string = '';
  public createdUUID: string = '';
  public inviteEmailMessage: string = "";
  public addStudySubmitProgress: string = '';
  public isFileUploaded: boolean = false;
  public isInviteFileRequested: boolean = false;
  public externalFileUploadToken: string = '';
  public externalFileUploadedEvent = new EventEmitter<string>();
  public initSideDrawerEvent = new EventEmitter<string>();
  public redirectUnAuthorizedEvent = new EventEmitter<string>();
  public initFileView = new EventEmitter<string>();
  public emitSigResultClick = new EventEmitter<any>();
  public emitFileDetails = new EventEmitter<any>();
  public emitSigCellCoordinates = new EventEmitter<any>();
  public emitFileUploadPogress = new EventEmitter<any>();
  public emitFileUploadPogressV2 = new EventEmitter<any>();
  public emitFileUploadRepoResponse = new EventEmitter<any>();
  public emitFileUpdateUploadRepoResponse = new EventEmitter<any>();
  public externalFileUploadMaxAllowedSize: number = 2 * 1024 * 1024 * 1024;
  // public externalFileUploadMaxAllowedSize: number = 200 * 1024 * 1024;
  public ahref:HTMLElement;
  public isSignificanceTest:boolean = false;
  public initionalTopcutId:any = 0;
  public lastRequest:any = {};
  public uploadFileProgrespercent = 0;
  public searchText:string = '';
  public isFileUpdatePanelOpen : boolean = false;
  public file_repo_id : string = '';
  public isCurrentOpenFileTranslation:boolean = false;
  public accessRoles:any;
  public hasVocViewAccess:boolean = false;
  
  public dataTreeJSON:any = [];
  public sigDataTreeJSON:any = [];
  public clubDataTreeJSON:any = [];
  public sidecutTreeJSON:any = [];
  public clubbedOptions:any ={column:[],rows:{}}
  public treeItems:any = {};
  public clubTreeItems:any = [];
  // public sigTreeItems:any = [];
  public sigTreeItemsForWithRespect:any = [];
  public sigTreeItemsFortoColumn:any = [];
  public sigFullTreeItemsForWithRespect:any = [];
  public sigFullTreeItemsFortoColumn:any = [];
  public sidecutTreeitems:any = {};
  public sidecutTreeitemsCopy:any = {};
  public isTopcutLoaded:boolean = false;
  public isSidecutLoaded:boolean = false;

  public agGridData: any = [];
  public headGroupJson: any = [];
  public headEntryJson: any = [];
  public headParents: any = [];
  public headParentPath: any = [];
  public gridBodyJson: any = [];
  public fileTypeStored:string = "";
  public globalvalueformatersigtest:any;
  public mainJsonDataForSig:any;
  public sigConfidenceLevel: Number = 95;
  public sigConfidenceLevelCopy: Number;
  public sigTestingOn: string = 'FullCrosstab';
  public sigBase: string = 'Base (wgt)';
  public sigComparetype: string = 'AmongColumn';
  public sigComparetypeCopy:string = '';
  public sigfromAmongarr: any = [{ withRespect: '', toColumn: [] }];
  public sigsubmitForm: any = {};
  public sigSubmitFormFlag:boolean = false;
  public isSignificanceResult:boolean = false;
  public sigResultArr:any = [];
  public sigCalculationSave:boolean = false;
  public sigbuttonLoader:boolean = false;
  public sigSmallBaseToggleButton:boolean = false;
  public sigSaveResultToggleButton:boolean = false;
  public sigResultTabOpen:boolean=false;
  public sigresultbordersidecut:string;
  public sigresultbordersidekey:string;
  public sigresultborderIndex:number = 0;
  public sigresultsidecutIndex:number = 0;
  public sigresultsidekeyIndex:number = 0;
  public sigresultiterateIndex:number = 0;
  public sigresultsidecutIndexContainer:any = [0];
  public sigHighlightsResultIterateIndex:number = 0;
  public sigHighlightsResulSidecutIndex:number;
  public hasSigTestAccess:boolean = false;
  public hasBetaSigTestAccess:boolean = false;
  public SigTestStudyLevelAccess:boolean = false;
  public isMovingFileComponent:boolean = false;
  public movingToplineFileDetails:any;

  public sigTestingtype:string = "";
  public allStudies:any[] = [];
  public allStudiesCopy:any[] = [];
  // @ViewChild('.border-result-link'):FocusResult:

  public isCallRecording:boolean = false;
  public callRecordingDataContainer:[] = [];
  public callDispositionContainer:[] = [];
  public callRecordingApiSurveyId:number;

  public isDownloadAllFiles:boolean = false;
  public downloadableFileList:any[] = [];
  public isDownloadableFileProcessing:boolean = false;
  public isHideFileListForSpecificStudies:boolean = false;
  public allFileListOfRepo:any[] = [];
  public allFileListOfRepoBackup:any[] = [];
  public isScroleComleted:boolean = false;
  public selectedFileForSummary:any
  public studySummaryInnerHtml:string
  public studySummarySafeInnerHtml:SafeHtml
  public summaryInnerHtml:string
  public isInvalidTranscript:boolean = false
  public summarySafeInnerHtml:SafeHtml
  public showPogress:boolean = false;
  public isRepoSearch:boolean = false;
  public isRepoDetailsSearch:boolean = false;
  public repoDetailsSearchEventEmit:EventEmitter<string> = new EventEmitter<string>();
  public ZipTranslationDownloadOptions:any = [];
  public isMultipleZipDownloadTranslationFiles:boolean = false;
  public total_data_in_list: number = 0;


  


  // public sigResultExpand:boolean = false;
  // public gridExpand:boolean = false;

  public rowClassRules: RowClassRules = {
    'haseDescription':(params) =>( params.node.data['isDescription'])
  };
  // public getRowHeight = (params) => params.node.data['isDescription']? null : null;
  public getRowHeight = (params) => params.node.data['isDescription'] ? 
  params.node.data['isDescriptionAutoHeight'] ? 20 : 20 : null;
  // public getRowHeight = (params) => params.node.data['isDescriptionAutoHeight']? null : null;

  

  constructor(
    private http:HttpClient,
    public notifier: NotifierService, 
    public router:Router,
    public route: ActivatedRoute,
    public iService:InsightsService,
    public homeService: HomeService,
    public sService: SharedataService,
    private formBuilder: FormBuilder,
    public roleService: RoleService,
    public sanitizer:DomSanitizer,
    public notify:NotifierService,
    private apiRequest: ApiRequestService,
    private dialoge:MatDialog,
    public aSearchservice:AdvancedSearchService,
    public aFilterService: AdvancedFilterService
    // private sidePanelService:SidePanelService
    ) {
    this.fileURL = '';
    this.fileLanguages = [];
    this.checkVocAccess();
    this.checkSignTestUserLevelAccess();
    this.dataTableOption = {
      "total_table": 0,
      "total_topcut": 0,
      "total_sidecut": 0
    }
    this.extensionToMIME = this.initEXTtoMIME();

    if (this.router.url.includes('qual')) {
      this.isQual = true;

    } else {
      this.isQual = false;
    }

    if(!this.MatSelectFileArray.length) {
      // console.log("this.defaultMatSelectFile ====> ",this.defaultMatSelectFile)
      this.MatSelectFileArray.push(JSON.parse(JSON.stringify(this.defaultMatSelectFile)));
    }
    
  }

  checkVocAccess() {
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    // this.accessRoles = this.roleService.getRoles();
    if(this.accessRoles && this.accessRoles.access_rules && this.accessRoles.access_rules.repository && this.accessRoles.access_rules.repository.voc && this.accessRoles.access_rules.repository.voc.view){
      this.hasVocViewAccess = true;
    }
  }
  checkSignTestUserLevelAccess(){
    if( this.accessRoles && this.accessRoles.access_rules && this.accessRoles.access_rules.repository && this.accessRoles.access_rules.repository.significance){
      this.hasSigTestAccess = true;
    }
    if( this.accessRoles && this.accessRoles.access_rules && this.accessRoles.access_rules.repository && this.accessRoles.access_rules.repository.beta_features && this.accessRoles.access_rules.repository.beta_features.significance){
      this.hasBetaSigTestAccess = true;
    }
  }
 

   refreshGridJson(){
    this.jsonDataForGrid = JSON.parse(JSON.stringify(this.mainJsonData));
    this.parseResultToGridJson()
   }

   parseResultToGridJson() {
      this.agGridData = [];
      Object.keys(this.jsonDataForGrid['sidecut']).forEach((sideKey, index) => {
          this.headGroupJson = [];
          this.headParents = [];
          this.headParentPath = [];
          this.gridBodyJson = [];
          this.headEntryJson = this.headGroupJson;
          this.headEntryJson.push({ 
            headerName: '', 
            children: [{ field: 'rows', 
            headerName: '', 
            resizable: true, 
            pinned: 'left', 
            tooltipField: 'rows', 
            minWidth: 150, 
            suppressMovable: true,
          }],
           });
          Object.keys(this.jsonDataForGrid['sidecut'][sideKey]).forEach(sKey => {
              if (sKey.includes('overall')) {
                  this.headEntryJson.push({ 
                    headerName: sKey, 
                    headerTooltip: sKey, 
                    children: [{ field: sKey, headerName: '', resizable: true, autoHeight: true, wrapText: true, tooltipField: sKey, minWidth: 60, suppressMovable: true,
                   }],
                   });
              }
          })
          this.headerTraverser(this.jsonDataForGrid['sidecut'][sideKey]['topcut']);
          this.abspct = this.formData.value.dataValue == 'absolute' ? 'abs' : this.formData.value.dataValue == 'percentage' ? 'pct' : 'both';
          this.gridBodyJson = this.gridBodyParser(this.jsonDataForGrid['sidecut'][sideKey], this.abspct);
          // this.agGridData.push({ "headers": this.headGroupJson, "data": {}, "sideCut": sideKey, "isData": true, "gridExpand":index == 0 ? true:false, "sigResultExpand":false});
          let sigHighlightResult = [];
          if(this.sigResultArr.length > 0)
          {
            let sigHighlightResultfind = this.sigResultArr.find((k2:any) => (k2['sidecutUUID'] === sideKey));
            if(sigHighlightResultfind)
            {
              sigHighlightResult = sigHighlightResultfind['sigHighlightResult'];
            }
          }
          this.agGridData.push({ "headers": this.headGroupJson, "data": this.gridBodyJson, "sideCutKey_UUID": sideKey, "sideCut": this.jsonDataForGrid['sidecut'][sideKey]["name"], "isData": this.gridBodyJson.length ? true:false, "gridExpand":index == 0 ? true:false, "sigResultExpand":false,'sigHighlightResult':sigHighlightResult,'IterationSigHighResult':0});
          // this.agGridData.push({ "headers": this.headGroupJson, "data": this.gridBodyJson, "sideCut": sideKey, "isData": this.gridBodyJson.length ? true:false, "gridExpand":index == 0 ? true:false, "sigResultExpand":false,'sigHighlightResult':sigHighlightResult,'IterationSigHighResult':0});
          // console.log("this.agGridData ======>>> ",this.agGridData);
      })
  }

  generateAgGridDataBlueprint(selectedSideKey?:string) {
    this.agGridData = [];
    Object.keys(this.jsonDataForGrid['sidecut']).forEach((sideKey, index) => {
        let sigHighlightResult = [];
        if(this.sigResultArr.length > 0)
        {
          let sigHighlightResultfind = this.sigResultArr.find((k2:any) => (k2['sidecutUUID'] === sideKey));
          if(sigHighlightResultfind)
          {
            sigHighlightResult = sigHighlightResultfind['sigHighlightResult'];
          }
        }
        this.agGridData.push({ "headers": [], "data": [], "sideCutKey_UUID": sideKey, "sideCut": this.jsonDataForGrid['sidecut'][sideKey]["name"], "isData": false, "gridExpand":false, "gridExpandLoading":false, "sigResultExpand":false,'sigHighlightResult':sigHighlightResult,'IterationSigHighResult':0});
        // console.log("this.agGridData ======>>> ",this.agGridData);
    })
    if (selectedSideKey && selectedSideKey != "") {
      this.parseSidecutToGridJson(selectedSideKey)
    }else{
      this.parseSidecutToGridJson(Object.keys(this.jsonDataForGrid['sidecut'])[0])
    }
}

  parseSidecutToGridJson(sideKey,expandTab?:boolean) {
    // console.log("start in parse grid json ===>>> ",Date.now())
    // console.log(" ************ parseSidecutToGridJson called *********** ")
    let tempAgGridData = this.agGridData.find(grid =>{return grid.sideCutKey_UUID == sideKey});
    // console.log(" this.jsonDataForGrid ====>", this.jsonDataForGrid)
        this.headGroupJson = [];
        this.headParents = [];
        this.headParentPath = [];
        this.gridBodyJson = [];
        this.headEntryJson = this.headGroupJson;
        this.headEntryJson.push({ 
          headerName: '', 
          children: [{ field: 'rows', 
          headerName: '', 
          resizable: true, 
          pinned: 'left', 
          tooltipField: 'rows', 
          minWidth: 150, 
          suppressMovable: true,
        }],
         });
        Object.keys(this.jsonDataForGrid['sidecut'][sideKey]).forEach(sKey => {
            if (sKey.includes('overall')) {
                this.headEntryJson.push({ 
                  headerName: sKey, 
                  headerTooltip: sKey, 
                  children: [{ field: sKey, headerName: '', resizable: true, autoHeight: true, wrapText: true, tooltipField: sKey, minWidth: 60, suppressMovable: true,
                 }],
                 });
            }
        })
        this.headerTraverser(this.jsonDataForGrid['sidecut'][sideKey]['topcut']);
        this.abspct = this.formData.value.dataValue == 'absolute' ? 'abs' : this.formData.value.dataValue == 'percentage' ? 'pct' : 'both';
        this.gridBodyJson = this.gridBodyParser(this.jsonDataForGrid['sidecut'][sideKey], this.abspct);
        // this.agGridData.push({ "headers": this.headGroupJson, "data": {}, "sideCut": sideKey, "isData": true, "gridExpand":index == 0 ? true:false, "sigResultExpand":false});
        let sigHighlightResult = [];
        if(this.sigResultArr.length > 0)
        {
          let sigHighlightResultfind = this.sigResultArr.find((k2:any) => (k2['sidecutUUID'] === sideKey));
          if(sigHighlightResultfind)
          {
            sigHighlightResult = sigHighlightResultfind['sigHighlightResult'];
          }
        }
        // tempAgGridData["gridExpandLoading"] = true;
        tempAgGridData["headers"] = this.headGroupJson;
        tempAgGridData["data"] = this.gridBodyJson;
        tempAgGridData["isData"] = this.gridBodyJson.length ? true:false;
        if (!expandTab) {
          tempAgGridData["gridExpand"] = true;
        }
        // if(tempAgGridData["isData"]){
        //   tempAgGridData["gridExpandLoading"] = false;
        // }else{
        //   setTimeout(() => {
        //     tempAgGridData["gridExpandLoading"] = false;
        //   }, 50);
        // }
        // this.agGridData.push({ "headers": this.headGroupJson, "data": this.gridBodyJson, "sideCutKey_UUID": sideKey, "sideCut": this.jsonDataForGrid['sidecut'][sideKey]["name"], "isData": this.gridBodyJson.length ? true:false, "gridExpand":true, "sigResultExpand":false,'sigHighlightResult':sigHighlightResult,'IterationSigHighResult':0});
        // console.log("this.agGridData ======>>> ",this.agGridData);
}

  headerTraverser(obj: any) {
      var item = {};
      // var 
      Object.keys(obj).forEach(element => {
          item = obj[element];
          if (item['type'] && item['type'] == 'topcut') {
              let temp = {
                  headerKey: element,
                  headerName: item['name'],
                  headerTooltip: item['name'],
                  children: []
              }
              if (!(item['options'][Object.keys(item['options'])[0]].type == 'option'))
                  this.headParents.push(element);
              this.headParentPath.push(element);
              this.headEntryJson.push(temp);
              this.headEntryJson = this.headEntryJson[this.headEntryJson.length - 1].children;
              this.headerTraverser(item['options'])
          } else {
            if (!(item['show'] == false)) {
              let pPath = '';
              this.headParentPath.forEach(path => {
                  pPath += path + '$'
              });
              pPath += element;
              pPath = pPath.replace(/[\])}.[{(]/g, '');
              this.globalvalueformatersigtest = pPath;
              this.headEntryJson.push({ 
                field: pPath, 
                headerKey: element,
                headerName: item['name'], 
                headerTooltip: item['name'], 
                resizable: true, 
                autoHeight: true,
                wrapText: false,
                // cellRenderer: this.cellDetailsRenderer,
                minWidth: 90, 
                tooltipField:pPath + ' toolTip',
                suppressMovable: true,
                cellStyle: (params) => {
                  return this.addCellStyleDynamically(params,pPath);
                },
               
              })
              
              // this.headEntryJson.push({ field: pPath, headerName: element, headerTooltip: element, resizable: true, wrapText:true, autoHeight:true, tooltipField: pPath, suppressMovable: true })
            }
          }
      });
      this.headEntryJson = this.headGroupJson;
      if (item['type'] == 'topcut') {
          this.headParents.pop();
          this.headParentPath = JSON.parse(JSON.stringify(this.headParents));
      } else {
          this.headParentPath.pop();
      }
      for (let i = 0; i < this.headParents.length; i++) {
          let parent = this.headEntryJson.find(pitem => pitem.headerKey == this.headParents[i]);
          // let parent = this.headEntryJson.find(pitem => pitem.headerName == this.headParents[i]);
          if (parent) {
              this.headEntryJson = parent.children;
          }
      }
      return;
  }
  // isFullWidth(data) {
  //   // return ['Peru', 'France', 'Italy'].indexOf(data.name) >= 0;
  // }

  addCellStyleDynamically(params,pPath){
    let style ={};
    if(params.node.data[pPath + ' C'] && params.node.data[pPath + ' C'] !== ''){
      style['background-color'] = params.node.data[pPath + ' C'];
      style['color'] = 'white'
    }
    if(params.node.data[pPath + ' text'] && params.node.data[pPath + ' text'] !== ''){
      style['border'] = '1px dashed #4949a1';
    }
    if(params.node.data[pPath + ' ftc'] && params.node.data[pPath + ' ftc'] !== ''){
      style['color'] = params.node.data[pPath + ' ftc'];
    }
    return style;

  }

  gridBodyParser(sideCut, dataType) {
      let arr = []
      let lastParent = ''
      sideCut.rows.forEach((row, index) => {
        let isHiddenRow = ""
        if (sideCut.hiddenRows && sideCut.hiddenRows.length) {
          isHiddenRow = sideCut.hiddenRows.find(item =>{return item == row["v"]});
          if (isHiddenRow && isHiddenRow != "") {
            return;
          }
        }
          let data = { 'rows': row["v"] }
          let blankRowData = {}
          Object.keys(sideCut).forEach(sKey => {
              if (sKey.includes('overall')) {

                  // data[sKey] = dataType == 'abs' ? sideCut[sKey][index].v :
                  //     dataType == 'pct' ? `${sideCut[sKey][index].p}%`
                  //         : `${sideCut[sKey][index].v}(${sideCut[sKey][index].p}%)`

                  data[sKey] = dataType == 'abs' ? sideCut[sKey][index].v :
                  dataType == 'pct' ? (sideCut[sKey][index].np ? `${sideCut[sKey][index].p}` : `${sideCut[sKey][index].p}%`)
                      : (sideCut[sKey][index].np ? `${sideCut[sKey][index].v}` : `${sideCut[sKey][index].v}(${sideCut[sKey][index].p}%)`)
              }
          })
          arr.push(data)
          let parents = [];
          let djson = sideCut.topcut
          recursive(sideCut.topcut)
          function recursive(obj) {
              for (let key in obj) {
                  var item = obj[key];
                    if (item.type == 'topcut') {
                        djson = djson.options ? djson.options[key] : djson[key];
                        if (djson) {
                            lastParent = key
                            if (!(item.options[Object.keys(item.options)[0]].type == 'option'))
                                parents.push(key);
                            recursive(item.options);
                        }
                        else {
                            djson = { ...sideCut.topcut };
                            parents = []
                            return
                        }
                    }
                    else {
                      if (!(item.show == false)) {
                          let arr_index = djson.options[key].index;
                          let name = '';
                          parents.map((p, i) => {
                              name += i == 0 || name == '' ? p : '$' + p
                          })
                          name += name == '' ? lastParent : '$' + lastParent 
                          name += name == '' ? key :'$' + key
                          name = name.replace(/[\])}.[{(]/g, '');
                          let color = name + ' C';
                          let tooltip = name + ' toolTip';
                          let text = name + ' text';
                          let _ftc_text = name + ' ftc';
                          arr[arr.length -  1][color] = '';
                          arr[arr.length - 1 ][text] = '';
                          arr[arr.length - 1 ][_ftc_text] = '';
                          
                        //   if(sideCut.data[arr_index][index].v == '16'){
                        //     arr[arr.length - 1][name + ' T']= "test case 123456"
                        //     // arr[arr.length - 1]['cell-$-description']= true
                        // }
                          
                         
                          // arr[arr.length - 1][name] = dataType == 'abs' ? sideCut.data[arr_index][index].v :
                          // dataType == 'pct' ? `${sideCut.data[arr_index][index].p}%`
                          //     : `${sideCut.data[arr_index][index].v}(${sideCut.data[arr_index][index].p}%)`
                          // arr[arr.length - 1][color] = 1;
                          // real working table''
                          arr[arr.length - 1][name] = dataType == 'abs' ? sideCut.data[arr_index][index].v :
                          dataType == 'pct' ? (sideCut.data[arr_index][index].np ? `${sideCut.data[arr_index][index].p}` : `${sideCut.data[arr_index][index].p}%`)
                              : (sideCut.data[arr_index][index].np ? `${sideCut.data[arr_index][index].v}` : `${sideCut.data[arr_index][index].v}(${sideCut.data[arr_index][index].p}%)`)
                          arr[arr.length -  1][tooltip] = arr[arr.length - 1][name];
                          if(sideCut.data[arr_index][index].tooltip && sideCut.data[arr_index][index].tooltip != '')
                          {
                            arr[arr.length -  1][tooltip] = `Value = ${arr[arr.length - 1][name]}, Result = ${sideCut.data[arr_index][index].tooltip}`;
                          }
          
                          if(sideCut.data[arr_index][index]['ftc'] && sideCut.data[arr_index][index]['ftc'] != ''){
                            arr[arr.length -  1][_ftc_text] = sideCut.data[arr_index][index]['ftc'] ;
                          }
                          if(sideCut.data[arr_index][index]['c'] && sideCut.data[arr_index][index]['c'] != ''){
                            arr[arr.length -  1][color] = sideCut.data[arr_index][index]['c'] ;
                          }
                          if((sideCut.data[arr_index][index]['text'] && sideCut.data[arr_index][index]['text'] != '')){
                            blankRowData[name] = '';
                            blankRowData[text] = '';
                            blankRowData[text] = sideCut.data[arr_index][index]['text'];
                            blankRowData[name] = sideCut.data[arr_index][index]['text'];
                            blankRowData[name+ ' toolTip'] = sideCut.data[arr_index][index]['text'];
                            blankRowData['isDescription'] = true;
                            if (blankRowData[name].length>10) {
                              blankRowData['isDescriptionAutoHeight'] = true;
                            }
                          }
                        }
                    }
              }
              djson = { ...sideCut.topcut };
              if (item.type == 'topcut')
                  parents.pop()

              parents.map(p => {
                  djson = djson.options ? djson.options[p] : djson[p];
              })
              return
          }

          if (Object.keys(blankRowData) && Object.keys(blankRowData).length) {
            arr.push(blankRowData)
          }
      })

      return arr
  }


   assignLength(){
    let isData = false;
    this.isSaveTabs = false;
    Object.keys(this.jsonData['sidecut']).forEach((sideKey,index) => {
      this.filterLevels = {};
      this.jsonData['sidecut'][sideKey]['topLen'] = {};
      this.jsonData['sidecut'][sideKey]['topCutLevel'] = {};
      this.jsonData['sidecut'][sideKey]['topCutLevelLen'] = {};
      this.jsonData['sidecut'][sideKey]['topLen']['dataValue'] = this.formData.value.dataValue;
      this.jsonData['sidecut'][sideKey]['topLen']['topcutLength'] = '';
      this.jsonData['sidecut'][sideKey]['topLen']['colSpan'] = [];
      this.jsonData['sidecut'][sideKey]['topLen']['rawtext']  = []
      this.jsonData['sidecut'][sideKey]['topLen']['overallLength'] = 0;
      this.jsonData['sidecut'][sideKey]['topLen']['overallHeadTop'] = '';
      this.jsonData['sidecut'][sideKey]['topLen']['dataLength'] = Object.keys(this.jsonData['sidecut'][sideKey]['data']).length + 1;
      isData = this.jsonData['sidecut'][sideKey]['rows'].length ?true:false;
      if (isData) {
        this.isData = true;
      }
      // this.isData = true;
      this.deepCount(this.jsonData['sidecut'][sideKey]['topcut'],0);

      this.jsonData['sidecut'][sideKey]['rows'].forEach((row,index) => {
        this.jsonData['sidecut'][sideKey]['data'].forEach(data =>{
          if (data[index] && data[index]['text']) {
            let checkDublicate = this.jsonData['sidecut'][sideKey]['topLen']['rawtext'].find(item =>{return item == row});
            if (!checkDublicate) {
              this.jsonData['sidecut'][sideKey]['topLen']['rawtext'].push(row)
            }
          }
        })
      })

      Object.keys(this.jsonData['sidecut'][sideKey]).forEach(sKey => {
        if (sKey.includes('overall')) {
          this.jsonData['sidecut'][sideKey]['topLen']['dataLength'] = this.jsonData['sidecut'][sideKey]['topLen']['dataLength'] + 1;
          this.jsonData['sidecut'][sideKey]['topLen']['overallLength'] += 1;
          this.jsonData['sidecut'][sideKey]['topLen']['overallHeadTop'] += 'minmax(' + 1 * 60 + 'px, ' + 1 + 'fr) ';
        }
      })
      this.jsonData['sidecut'][sideKey]['topLen']['headerTopLength'] = 'minmax(' + (this.jsonData['sidecut'][sideKey]['topLen']['overallLength'] + 1 ) * 60 + 'px, '+ (this.jsonData['sidecut'][sideKey]['topLen']['overallLength'] + 1 )+'fr)';
      

      this.levelTraverser(this.jsonData['sidecut'][sideKey]['topcut'],1);
        Object.keys(this.filterLevels).forEach(element => {
          let item = this.filterLevels[element]
          if(item && item.length > 0 && element != 'option'){
              let option_counter = 0;
              item.forEach(it => {
                  if(it.type == 'option'){
                      option_counter++;
                  } 
              });
              if(option_counter == item.length){
                  delete this.filterLevels[element];
              }
          }
      });
      let length = Object.keys(this.filterLevels).length;
      this.filterLevels["level "+length] = [];
      this.filterLevels["level "+length] = this.filterLevels['option']
      delete this.filterLevels['option'];
      this.jsonData['sidecut'][sideKey]['topCutLevel'] = this.filterLevels;
      Object.keys(this.jsonData['sidecut'][sideKey]['topCutLevel']).forEach(lKey =>{
        
        this.jsonData['sidecut'][sideKey]['topCutLevelLen'][lKey] = {};
        this.jsonData['sidecut'][sideKey]['topCutLevelLen'][lKey]['headTopLength'] = 'minmax(' + 2 * 60 + 'px, ' + 1 + 'fr) '+  this.jsonData['sidecut'][sideKey]['topLen']['overallHeadTop'] + ' '
        this.jsonData['sidecut'][sideKey]['topCutLevel'][lKey].forEach(levelItem => {
          let levlLen = levelItem.total ? levelItem.total : 1;
          this.jsonData['sidecut'][sideKey]['topCutLevelLen'][lKey]['headTopLength'] += 'minmax(' + levlLen * 60 + 'px, ' + levlLen + 'fr) '
        });
      })
      this.jsonData['sidecut'][sideKey]['topLen']['totalLevels'] = Object.keys(this.jsonData['sidecut'][sideKey]['topCutLevel']).length;
      Object.keys(this.jsonData['sidecut'][sideKey]['topcut']).forEach((key, index) => {
        let len = Object.keys(this.jsonData['sidecut'][sideKey]['topcut'][key]['options']).length;
        this.jsonData['sidecut'][sideKey]['topLen']['headerTopLength'] = this.jsonData['sidecut'][sideKey]['topLen']['headerTopLength'] + ' minmax(' + len * 60 + 'px, ' + len + 'fr)';
        this.jsonData['sidecut'][sideKey]['topLen']['colSpan'].push(len - 1);
        if (index == 0) {
          len = len + (this.jsonData['sidecut'][sideKey]['topLen']['overallLength'] + 1);
        }
        this.jsonData['sidecut'][sideKey]['topLen']['topcutLength'] = this.jsonData['sidecut'][sideKey]['topLen']['topcutLength'] + ' minmax(' + len * 60 + 'px, ' + len + 'fr)';
      });
    })
    // console.log("sidecut data ",this.jsonData['sidecut']);
   }

   levelTraverser(obj:any,level){
    if(!this.filterLevels["level "+level]){
      this.filterLevels["level "+level] = [];
    }
    if(!this.filterLevels["option"]){
      this.filterLevels["option"] = [];
    }
    let nextLevel = level+1;
    Object.keys(obj).forEach(element => {
        let item = obj[element];
        // item.name = element;
        if (obj[element]['options']) {
          item.length = Object.keys(obj[element]['options']).length;
        }
        if(item.type == 'option'){
          this.filterLevels["option"].push(item);
            let copy_item = Object.assign({}, item); ;
            copy_item.name = "";
            this.filterLevels["level "+level].push(copy_item);
        }
        else{
          this.filterLevels["level "+level].push(item);
        }
        if(item.options && Object.keys(item.options).length > 0){
          this.levelTraverser(item.options,nextLevel);
        }
    });  
  }

  deepCount(obj,count){
    Object.keys(obj).forEach(element => {
        let actual_count = 0
        let options = obj[element];
        let nextLevel = options.options[Object.keys(options.options)[0]]
        if(options && options.options && Object.keys(options.options).length > 0 && (nextLevel.options)){
            let deepC = this.deepCount(options.options,actual_count);
            actual_count = deepC;
        }
        else{
            actual_count = Object.keys(options.options).length
        }
        options.total = actual_count;
        count = count+actual_count;        
    })
    return count;
  }

   crossTableReset(){
    this.tableExtrationData=[];
    this.tableExtrationUpperCuts=[];
    this.tableExtrationLowerCuts=[];
    this.crossTable.reset();
  }

  onSearchChange(value) {
    this.searchRepo(value)
      .subscribe(result => {
        if (result["status"] == 1) {
          this.dataSource = result["data"];
        }
      }, error => {
        // console.error(error);
      })


    // if (this.router.url.includes('repo/all-files')) {
    //   this.getAllRepositoryFilesPagination({"page":1, "search": value});
    // }else{
    //   this.searchRepo(value)
    //     .subscribe(result => {
    //       if (result["status"] == 1) {
    //         this.dataSource = result["data"];
    //       }
    //     }, error => {
    //       // console.error(error);
    //     })
    // }
  }



  getFileURL(fileDetails, type?:string){
    // Skip if we already fetched URL for this file (prevents duplicate API calls)
    const currentFileUUID = fileDetails['file_uuid'] || this.fileUUID;
    if (this.lastFileURLUUID === currentFileUUID) {
      return;
    }
    this.lastFileURLUUID = currentFileUUID;
    
    if (type === "qual") {
      this.openQualFile( {"uuid":fileDetails['uuid']}).subscribe(result =>{
        if (result['status'] == 1) {
          this.fileURL = result['url'][0];
          this.fileLanguages = result['video_translator'] ? result['video_translator'] : [];
          this.trackerSessionId = result['session_id'];
          this.iService.current_file_uuid = fileDetails['file_uuid'];
          result['uuid'] = this.route.snapshot.params['uuid'];
          if(result['multi_file_download'].length){
            this.ZipTranslationDownloadOptions = result['multi_file_download'];
            this.isMultipleZipDownloadTranslationFiles = true;
          }else{
            this.isMultipleZipDownloadTranslationFiles = false;
          }
          this.setupVocOnFileOpenQual(result,true);
          this.studyId = result['studyId'];
          // this.setClubVocOnFileOpen(result,true);
          this.router.navigate(['/qual/reports/file-view/',this.studyId]);
          // this.router.navigate(['/home/qual/reports/file-view/',this.studyId]);
          this.isLoading = true;
          // this.analyzerStauts = result['analyzer_status'] ? true:false;
          this.videoAnalyzer['status'] = result['analyzer_status'] ? result['analyzer_status']:0;
          if (this.videoAnalyzer['status'] == 2) {
            this.videoAnalyzer['percentage'] = result['percentage'];
          }
          this.assignFileType(result['url'])
        }
     
      },error =>{
        console.error(error);
        this.isLoading = false;
      })
    }else{
        this.openFile({"uuid":this.detailsUUID}).subscribe(result =>{
          // this.openFile({"uuid":this.fileUUID}).subscribe(result =>{
          if (result['status'] == 1) {
            this.fileURL = result['url'][0];
            this.fileLanguages = result['video_translator'] ? result['video_translator'] : [];
            this.trackerSessionId = result['session_id'];
            if(result['multi_file_download'] && result['multi_file_download'].length){
              this.ZipTranslationDownloadOptions = result['multi_file_download'];
              this.isMultipleZipDownloadTranslationFiles = true;
            }else{
              this.ZipTranslationDownloadOptions = [];
              this.isMultipleZipDownloadTranslationFiles = false;
            }
            this.studyId = result['studyId'];
            result['uuid'] = this.route.snapshot.params['uuid'];
            this.iService.current_file_uuid = fileDetails['file_uuid'];
            this.setupVocOnFileOpen(result,false);
            if (this.router.url.includes('file-view')) {
              this.initFileView.emit();
            }else{
              this.router.navigate(['/repo/file-view/',fileDetails['file_uuid']]);
              // this.router.navigate(['/home/repository-report/file-view/',fileDetails['file_uuid']]);
            }
            this.isLoading = true;
            // this.analyzerStauts = result['analyzer_status'] ? true:false;
            this.videoAnalyzer['status'] = result['analyzer_status'] ? result['analyzer_status']:0;
            if (this.videoAnalyzer['status'] == 2) {
              this.videoAnalyzer['percentage'] = result['percentage'];
            }
            this.assignFileType(result['url'])
          }
          else if (result['status'] == 4) {
            // this.isLoading = false;
            this.notifier.notify("error",result['message']);
            this.redirectUnAuthorizedEvent.emit('unauthorized');
            // this.side.afterLoginNavigate();
          }
        },error =>{
          console.error(error);
          this.isLoading = false;
        })
    }
  }
  
  
  assignFileType = (res:any) =>
  {
    // console.log("res",res);
    if(res.length == 1)
    {
      this.isVideoFile = res[0];
    }
    else if (res.length > 1) {
      this.isVideoFile = res[0];
      this.isAudioFile = res[1];
    }

  }

  setupVocOnFileOpen(result,isQual){
    if(this.fileCategory == 'video' || this.fileCategory == 'audio'){
      if(result['voc_files'] && result['voc_files'].length>0){
        this.formatVOCsData(result['voc_files'],isQual,1);
        setTimeout(()=>{
          this.addFileCategoriesToVoc(this.reportDetails,'file');
        },1000);
      }
      else {
        this.iService.VOCList = [];
      }
    }
  }

  setupVocOnFileOpenQual(result,isQual){
    if(this.fileCategory == 'video' || this.fileCategory == 'audio'){
      if(result['voc_files'] && result['voc_files'].length>0){
        this.formatVOCsData(result['voc_files'],isQual,1);
        setTimeout(()=>{
          this.addFileCategoriesToVocQual(this.interviewDetailsQual);
        }, 1000);
      }
      else {
        this.iService.VOCList = [];
      }
    }
  }

  // setClubVocOnFileOpen(result,isQual) {
  //   this.iService.VOCClubList = [];
  //   if(result['clubbed_files'] && result['clubbed_files'].length>0) {
  //     result['clubbed_files'].forEach((club) => {
  //       club['isHoverd'] = false;
  //       if(isQual) {
  //         club['isQual'] = true;
  //       }
  //       else{
  //         club['isQual'] = false;
  //       }
  //       club['media_type'] = 'video';
  //       this.iService.VOCClubList.push(club);
  //     })
  //   }
  // }

  getClubbedVocList(type: string){
    if(type == 'study'){
      if (this.router.url.includes("qual")) {

      }
      else{
        
      }
    }
    else{
      if (this.router.url.includes("qual")) {
        this.openQualFile( {"uuid":this.fileUUID}).subscribe(result =>{
          if (result['status'] == 1) {
  
          }
        },error =>{
          console.error(error);
          this.isLoading = false;
        })
      }else{
          this.openFile({"uuid":this.detailsUUID}).subscribe(result =>{
            if (result['status'] == 1) {
              
            }
            else if (result['status'] == 4) {
              this.notifier.notify('error',result['message']);
              this.redirectUnAuthorizedEvent.emit('unauthorized');
            }
          },error =>{
            console.error(error);
            this.isLoading = false;
          })
      }
    }
  }

  getVocList(){
    if (this.router.url.includes("qual")) {
      this.openQualFile({ "uuid": this.fileUUID }).subscribe(result => {
        if (result['status'] == 1) {
          this.iService.current_file_uuid = this.fileUUID;
          this.setupVocOnFileOpenQual(result, true);
          this.isLoading = true;
        }
      }, error => {
        console.error(error);
        this.isLoading = false;
      })
    } else {
      this.openFile({ "uuid": this.detailsUUID }).subscribe(result => {
        if (result['status'] == 1) {
          this.iService.current_file_uuid = this.fileUUID;
          this.setupVocOnFileOpen(result, false);
          this.isLoading = true;
        }
        else if(result['status'] == 4){
          // this.isLoading = false;
          this.notifier.notify('error',result['message']);
          this.redirectUnAuthorizedEvent.emit('unauthorized');
        }
      }, error => {
        console.error(error);
        this.isLoading = false;
      })
    }
  }

  formatVOCsData(voc_files,isQual,flag=0){
    if(flag === 1)
    {
      this.iService.VOCList = [];
      let colorLoopCount=0;
      voc_files.forEach((voc,index)=> {
        const background = this.vocIconColors()[colorLoopCount];
        // const misc = (voc.misc && typeof voc.misc=='string') ? JSON.parse(voc.misc) : voc.misc;
        const misc = voc.misc;
        let newObj = {...voc,time_range:`${voc.start_time}-${voc.end_time}`,misc:misc,background:background,isQual:isQual};
        this.iService.VOCList.push(newObj);
        colorLoopCount = colorLoopCount == this.vocIconColors().length-1 ? 0 : colorLoopCount+1;
      })
    }
    else
    {
      this.iService.vocStudyLevelArray = [];
      voc_files.forEach((voc,index:number)=> {
        let colorLoopCount=0;
        let arr = [];
        voc['vocs'].forEach((item,index1:number) =>
        {
          
          const misc = item.misc;
          const background = this.vocIconColors()[colorLoopCount];
          let newObj = {...item,time_range:`${item.start_time}-${item.end_time}`,misc:misc,background:background,isQual:isQual};
          arr.push(newObj);
          colorLoopCount = colorLoopCount == this.vocIconColors().length-1 ? 0 : colorLoopCount+1;
        })
        let newobj1 = {file_name:voc['fileName'],video_id:voc['video_id'],vocs:arr};
        this.iService.vocStudyLevelArray.push(newobj1);
      })
    }
  }

  vocIconColors() {
    return ['#6c5ce7', '#0984e3', '#40cdae', '#ff7675', '#ffc553', '#67bdff'];
  }

  addFileCategoriesToVoc(reportDetails,type?){
    if(reportDetails && reportDetails['files'] && reportDetails['files'].length > 0){
      if(type === 'file')
      {
        this.iService.VOCList.forEach((voc,index)=> {
          let myObj = reportDetails['files'].find((file)=> file.file_uuid==voc.video_id);
          if(myObj){
            let MIME = this.extensionToMIME.find(code => code[0].toLowerCase() == '.'+myObj['type'].toLowerCase());
            let fileType = MIME[1];
            let fileCategory = fileType.split("/")[0];
            this.iService.VOCList[index].media_type=fileCategory;
          }
        })
      }
      else
      {
        this.iService.vocStudyLevelArray.forEach((voc,index1) =>
        {
          voc['vocs'].forEach((val,index2) =>
          {
            let myObj = reportDetails['files'].find((file)=> file.file_uuid==val.video_id);
            if(myObj){
              let MIME = this.extensionToMIME.find(code => code[0].toLowerCase() == '.'+myObj['type'].toLowerCase());
              let fileType = MIME[1];
              let fileCategory = fileType.split("/")[0];
              this.iService.vocStudyLevelArray[index1]['vocs'][index2]['media_type']=fileCategory;
            }
          })
        })
      }
      
    }
  }

  formatVocQual(interviewDetails, isQual) {
    this.interviewDetailsQual = interviewDetails;
    if (interviewDetails.voc_files && interviewDetails.voc_files.length > 0) {
      // this.iService.formatVOCsData(result[0].voc_files);
      this.formatVOCsData(interviewDetails.voc_files, isQual);
      setTimeout(() => {
        // this.addFileCategoriesToVoc(this.reportDetails);
        this.addFileCategoriesToVocQual(interviewDetails);
      }, 1000);
    }
    else {
      this.iService.VOCList = null;
    }
  }

  addFileCategoriesToVocQual(interviewDetails) {
    interviewDetails['interviews'].forEach(item => {
      if (item['files'] && item['files'].length > 0) {
        this.iService.VOCList.forEach((voc, index) => {
          let myObj = item['files'].find((file) => file.file_uuid == voc.video_id);
          if (myObj) {
            let MIME = this.extensionToMIME.find(code => code[0].toLowerCase() == '.' + myObj['type'].toLowerCase());
            let fileType = MIME[1];
            let fileCategory = fileType.split("/")[0];
            this.iService.VOCList[index].media_type = fileCategory;
          }
        })
      }
    })
    let output = this.iService.VOCList.filter((voc) => {
      return !voc.media_type
    })
  }

  sideNavViewFilter(cut, filter_name, file) {
    this.pickFilter(cut, filter_name)
    this.viewFile(file)
  }

  viewFile(fileDetails, type?:string,option?:any){
    this.previousRoute = option && option['previousRoute'] ? option['previousRoute'] : '';
    this.iService.close();
    this.sService.close();
    this.isFileFound = false;
    this.isCurrentOpenFileTranslation = false;
    if(fileDetails  && fileDetails['file_type'] == "Translation"){
      this.isCurrentOpenFileTranslation = true;
    }
    if (fileDetails.dataTable && fileDetails.dataTableStatus == 'failed') {
      this.notifier.notify('info', 'This file can not be opened as Cross Tab currently!!!')
    }
    if (fileDetails.kpiViewerStatus == 'failed') {
      this.notifier.notify('info', 'This file can not be opened as Topline Report currently!!!')
    }
    if ((fileDetails.dataTable && fileDetails.dataTableStatus == 'pending') || fileDetails.kpiViewerStatus == 'pending' || fileDetails.translation_processing) {
      return;
    }
    this.isLoading = true;
    this.currentFileSource = fileDetails['resource'];
    this.fileName = fileDetails['name'];
    let MIME = this.extensionToMIME.find(code => code[0].toLowerCase() == '.'+fileDetails['type'].toLowerCase());
    // console.log("MIME ====>",MIME)
    this.fileType = MIME[1];
    this.detailsUUID = fileDetails['uuid'];
    this.fileUUID = fileDetails['file_uuid'];
    this.fileCategory = this.fileType.split("/")[0];
    this.fileURL = '';
    this.fileLanguages = [];
    this.getComments(this.fileUUID, 'file');
    setTimeout(() => {
      this.isFileFound = true;
    },1000)
    // this.isFileLevel = false;

      if (type === 'qual' && !(fileDetails['dataTable'] && (fileDetails['type'] == 'csv' || fileDetails['type'] == 'xlsx'))) {
        this.detailsUUID = fileDetails['uuid'];
        this.router.navigate(['/qual/reports/file-view/',fileDetails['file_uuid']]);
        // this.router.navigate(['/home/qual/reports/file-view/',fileDetails['file_uuid']]);
        this.getFileURL(fileDetails,type);
      }else if (fileDetails['dataTable'] && fileDetails['dataTableStatus'] != 'failed' && (fileDetails['type'] == 'csv' || fileDetails['type'] == 'xlsx')) {
        this.detailsUUID = fileDetails['uuid'];
        this.getExtrationCuts(fileDetails);
      }else if((fileDetails['file_type'] == 'kpiViewer' || fileDetails['file_type'] == 'Topline Report') && fileDetails.kpiViewerStatus != 'failed'){
        localStorage.setItem('excelfile',JSON.stringify(fileDetails));
        this.router.navigate(['topline/excel-view/',this.fileUUID])
        // this.router.navigate(['home/repository-report/excel-view/',this.fileUUID])
      }else{
        this.detailsUUID = fileDetails['file_uuid'];
        this.getFileURL(fileDetails);
        this.router.navigate(['/repo/file-view/',fileDetails['file_uuid']]);
        // this.router.navigate(['/home/repository-report/file-view/',fileDetails['file_uuid']]);
      }

      // Only emit side drawer event if not already triggered
      if (!this.initSidePanelTriggered) {
        this.initSidePanelTriggered = true;
        this.initSideDrawerEvent.emit('repo');
      }





    
    // if(this.isFileLevel) {
    //   this.isFileLevel = false;
    //   this.fileUUID
    //   if(this.router.url.includes('file-view')) {
    //     this.currentFileSet(option['getFileResult'])
    //   }
    //   else if(this.router.url.includes('table-extraction')) {
    //     this.setCutData(option['getFileResult']);
    //   }
    //   else if(this.router.url.includes('excel-view')) {
    //     this.setExcelViewData(fileDetails,option['getFileResult']);
    //   }
    // }
    // else {
    //   // let url = '';
    //   // url += window.location.origin; 
    //   if (type === 'qual' && !(fileDetails['dataTable'] && (fileDetails['type'] == 'csv' || fileDetails['type'] == 'xlsx'))) {
    //     this.detailsUUID = fileDetails['uuid'];
    //     // url+= `/home/qual/reports/file-view/${fileDetails['file_uuid']}`
    //     this.router.navigate(['/home/qual/reports/file-view/',fileDetails['file_uuid']]);
    //     // this.getFileURL(fileDetails,type);
    //   }else if (fileDetails['dataTable'] && fileDetails['dataTableStatus'] != 'failed' && (fileDetails['type'] == 'csv' || fileDetails['type'] == 'xlsx')) {
  
    //     this.detailsUUID = fileDetails['uuid'];
    //     this.getExtrationCuts(fileDetails);
    //   }else if((fileDetails['file_type'] == 'kpiViewer' || fileDetails['file_type'] == 'Topline Report') && fileDetails.kpiViewerStatus != 'failed'){
    //     localStorage.setItem('excelfile',JSON.stringify(fileDetails));
    //     // url+= `/home/repository-report/excel-view/${this.fileUUID}`
    //     this.router.navigate(['home/repository-report/excel-view/',this.fileUUID])
    //   }else{
    //     this.detailsUUID = fileDetails['file_uuid'];
    //     this.getFileURL(fileDetails);
    //     // url+= `/home/repository-report/file-view/${fileDetails['file_uuid']}`
    //     this.router.navigate(['/home/repository-report/file-view/',fileDetails['file_uuid']]);
        
    //   }
    //   // console.log('url',url)
    //   // this.reloadCurrentRoute(url);
    // }
       

  }

  reloadCurrentRoute(url) {
    // const currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate([url]);
    });
  }

  currentFileSet(result) {
    this.fileURL = result['url'][0];
    this.fileLanguages = result['video_translator'] ? result['video_translator'] : [];
    this.trackerSessionId = result['session_id'];
    this.iService.current_file_uuid = result['uuid'];
    this.setupVocOnFileOpen(result,false);
    this.isLoading = true;
    // this.analyzerStauts = result['analyzer_status'] ? true:false;
    this.videoAnalyzer['status'] = result['analyzer_status'] ? result['analyzer_status']:0;
    if (this.videoAnalyzer['status'] == 2) {
      this.videoAnalyzer['percentage'] = result['percentage'];
    }
    this.assignFileType(result['url'])
    this.initFileView.emit();
    this.openSubSideDrower();
  }

  closeFile(){
    if (this.previousRoute && this.previousRoute != '') {
      this.router.navigate([this.previousRoute]);
    } else {
      if (this.studyId && this.studyId != '') {
        if (this.isQual) {
          // this.router.navigate(['home/qual/report/', this.studyId]);
          this.router.navigate(['qual/report/', this.studyId]);
        } else {
          this.router.navigate(['repo/details/', this.studyId]);
          // this.router.navigate(['home/repository-report/details/', this.studyId]);
        }
      } else {
        this.router.navigate(['repo']);
        // this.router.navigate(['home/repository-report']);
      }
    }
  }

  getRepos(query1?:any){
    this.isLoading = true;
    let query = {};
    if (query1) {
      query = query1;
    }
    // if (query) {
    //   this.httpPostOptions.params = {"page":query.page,"page_size":20}
    // } 
    // console.log(query,'QueryPage');
    this.getUploadData(query).subscribe((res:any)=>{
      if(res['status'] == 1){
        this.dataSource = [...this.dataSource, ...res.data];
        this.totalReportsPage = res.total_page
        this.isLoading = false;
      }
      if(res['status'] == 4){
        this.notifier.notify("error",res['message']);
        this.redirectUnAuthorizedEvent.emit('unauthorized');
      }
    });
  }

  uploadMultipleFileExternalApi(data): Observable<any>{
    let opt = {};
    opt['httpOptions'] = this.httpPostOptionsFile;
    return this.apiRequest.request('POST','/v2/repo/linkFileUpload',data,opt);
  }
  inviteMultipleEmail(data): Observable<any>{
    return this.apiRequest.request('POST','/v2/repo/uploadInviteEmail',data);
  }

  getUploadData(query?:any,type?:any){
    // console.log(query,'QueryPage');
    let opt = {};
    if(type){
      opt['query'] = query;
    }
    if (!type && query && Object.keys(query).length) {
      opt['query'] = {"page":query.page,"page_size":20}
    } 
    return this.apiRequest.request('GET','/v2/repo/getrepo',{},opt);
    // return get(environment.apiUrl + '/v2/repo/getrepo', this.httpPostOptions);
  }

  getAllStudyForDropdown(){
    let query = {no_pagination :true};
    this.getUploadData(query,'allstudy').subscribe((res:any)=>{
      this.allStudies = res.data;
      this.allStudiesCopy = JSON.parse(JSON.stringify(res.data));
    });

  }

  openUpload() {
    this.isFullFileUploadComponent = 'create';
    this.isFullRequestFileComponent = false;
    this.isUpload = true;
  }

  openExtrationFilter() {
    this.isExtractionFilter = true;
  }

  openExtrationFilterSave() {
    this.isExtractionFilterSave = true;
  }
  
  openExtrationClub(sidecutKey,sigkey=0){
    if(sigkey == 1)
    {
      this.selectedCut = {}
      this.selectedCut['key'] = sidecutKey;
      this.selectedCut['value'] = JSON.parse(JSON.stringify(this.mainJsonData['sidecut'][sidecutKey]));
      let topcutObj = {
        "id":1,
        "topcut":this.selectedCut['value']['topcut']
      }
      this.createClubTreeObj(topcutObj);
    }
    else
    {
      this.isExtractionClub = true;
      this.selectedCut = {}
      this.selectedCut['key'] = sidecutKey;
      this.selectedCut['value'] = JSON.parse(JSON.stringify(this.mainJsonData['sidecut'][sidecutKey]));
      let topcutObj = {
        "id":1,
        "topcut":this.selectedCut['value']['topcut']
      }
      this.createClubTreeObj(topcutObj);
    }
   
  }

  changeDataValue(sidecutKey){
    this.abspct = this.abspct == 'abs' ? 'pct' : 'abs';
    let data = this.gridBodyParser(this.jsonDataForGrid['sidecut'][sidecutKey], this.abspct)
    this.agGridData.map(item =>{
      if (item.sideCutKey_UUID == sidecutKey) {
        item['data'] = data
      }
    })
          // if (this.jsonData['sidecut'][sidecutKey]['topLen']['dataValue'].toLowerCase() == 'absolute') {
    //   this.jsonData['sidecut'][sidecutKey]['topLen']['dataValue'] = 'percentage';
    // }else{
    //   this.jsonData['sidecut'][sidecutKey]['topLen']['dataValue'] = 'absolute';
    // }
      
  }

  openViSummary(file){
    // this.summaryInnerHtml = '<div style="text-align: center;height: 100%;display: flex;align-items: center;">The video transcription is too small for generating a summary (less than 1000 characters). Summary is generated on longer transcripts</div>';
    // file['invalid_transcript'] = true
    this.summaryInnerHtml = file.invalid_transcript ? '' : file.summary;
    this.selectedFileForSummary = file
    this.initSummaryCustomCSS();
    this.isViSummary = true;
  }
  openGroupSummary(){
    this.isGroupSummary = true;
  }
  closeGroupSummary(){
    this.isGroupSummary = false;
  }

  close() {
    this.isFullFileUploadComponent = 'yes';
    this.isFullRequestFileComponent = true;
    this.isUpload = false;
    this.isViSummary = false;
    // this.isGroupSummary = false;
    this.isExtractionFilter = false;
    this.isExtractionFilterSave = false;
    this.isExtractionClub = false;
    this.isStudyCreated = false;
    this.createdUUID = '';
    this.addStudySubmitProgress = '';
    this.isInviteFileRequested = false;
    this.isFileUploaded = false;
    this.isUploadFile = false;
    this.replaceFileObj = {};
    this.MatSelectFileArray = [JSON.parse(JSON.stringify(this.defaultMatSelectFile))];
    this.uploadFileContainer = [];
    this.uploadMultipleFileContainer = [];
    this.isRequestFile = false;
    this.sharingEmails = [];
    this.inviteEmailMessage = "";
    this.uploadFileProgrespercent = 0;
    this.isMoveToNewStudy = false;

  }
  

  CloseUploadPanel = () =>
    {
      if (this.showPogress) {
        this.notify.notify('warning','Please wait while the file is being uploaded.');
      }else{
        this.isUploadFile = false;
        this.replaceFileObj = {};
        this.resetFileToDefault();
        this.uploadMultipleFileContainer = [];
      }
    }

  closeUpdateFilePanel(){
    this.isFileUpdatePanelOpen = false;
  }

  openSameFileUploadNotificationModel(isValidation?: boolean){
    this.dialoge.open(DialogContainerComponent, {
      width: isValidation ? '480px' : '500px',
      height: isValidation ? 'auto' : "200px",
      disableClose: true,
      data: { method: isValidation ? "translation_error_warning" : 'notifySameFile' ,details:this.tempFileDublicateCheckObj}
    });
  }
  uploadMultipleFile(uuid,cond?) {
    let d = this.MatSelectFileArray.find((va: any) => !va.value);
    const {job_id='',objective=''} = cond || {};
    if (!d) {
      this.tempFileDublicateCheckObj = {"study_uuid":uuid,"job_id":job_id};
      let data = new FormData();
      let file_type = this.getFileTypeArr(this.uploadFileContainer);
      let vi_index = this.uploadFileContainer.map(ob => {return ob.vi_index;});
      let languages = this.uploadFileContainer.map(ob => {return ob.language;});
      let translation_config = this.uploadFileContainer.map(ob => {return ob.translation_config;});
      let isAudiotranslator = this.uploadFileContainer.map(ob => {return ob.isAudiotranslator;});
      let translate_numeric = this.uploadFileContainer.map(ob => {return ob.translate_numeric;});
      let translate_numeric_to_numeric = this.uploadFileContainer.map(ob => {return ob.translate_numeric_to_numeric;});
      let zip_file_operation = this.uploadFileContainer.map(ob => {return ob.zip_file_operation || false;});

      data.append('file_type', JSON.stringify(file_type));
      data.append('vi_index', JSON.stringify(vi_index));
      data.append('translator_lang', JSON.stringify(this.uploadFileContainer.map(ob => {return ob.translator_lang})));
      data.append('isAudiotranslator', JSON.stringify(isAudiotranslator));
      data.append('translate_numeric', JSON.stringify(translate_numeric));
      data.append('translate_numeric_to_numeric', JSON.stringify(translate_numeric_to_numeric));
      data.append('zip_file_operation', JSON.stringify(zip_file_operation));
      let audiotranslation_config = this.uploadFileContainer.map(ob => {return ob.audiotranslation_config;}) || [];
      if(audiotranslation_config && audiotranslation_config.length > 0){
        let audiotranslation_file_config = [];
        audiotranslation_config.forEach((item) => {
          if(item){
            audiotranslation_file_config.push({name : item.fileObj.name,'size' : item.fileObj.size})
          }
        });

        data.append('audio_translation_file_details', JSON.stringify(audiotranslation_file_config));
      }
      data.append('languages', JSON.stringify(languages));
      data.append('translation_config', JSON.stringify(translation_config));

      if (this.replaceFileObj && this.replaceFileObj.file_uuid  && this.replaceFileObj.file_uuid != '') {
        data.append('file_uuid', this.replaceFileObj.file_uuid);
        data.append('replace', 'true');
      }

      this.uploadFileContainer.forEach((element, index) => {
        if (element.fileObj) {
          data.append('file', element.fileObj, element.fileObj['name']);
        }
      })

      audiotranslation_config.forEach((element, index) => {
        if (element && element.fileObj) {
          data.append('file', element.fileObj, element.fileObj['name']);
        }
      })




   

      // let files = this.uploadFileContainer.map((va) => va.fileObj).concat(audiotranslation_config.map((va) => va.fileObj));
      // files.forEach((element, index) => {
      //   data.append('file', element, element['name']);
      // });
      
      

      
      if (this.isFullFileUploadComponent == 'external') {
        data.append('uuid', uuid);
        this.uploadMultipleFileExternalApiFunc(data);
      }
      else {
        data.append('study_uuid', uuid);
        if(job_id != '') data.append('job_id', job_id);
        if(objective != '') data.append('objective', objective);
        this.uploadMultipleFileApiFunc(data, uuid);
      }
      // this.isUploadFile = false;
      // console.log("data ===> ",data)
      // this.MatSelectFileArray = [JSON.parse(JSON.stringify(this.defaultMatSelectFile))];
      // this.uploadFileContainer = [];
    }
    else {
      this.notify.notify('error', 'Please fill all field');
    }
    // this.uploadFileContainer = [];
  }

  resetFileToDefault(){
    this.MatSelectFileArray = [JSON.parse(JSON.stringify(this.defaultMatSelectFile))];
    this.uploadFileContainer = [];
    this.copy_file_id="";
  }

  // uploadMultipleFileApiFunc(data, uuid) {
  //   this.isLoading = true;
  //   console.log("data ===> ",data)
  //   this.uploadMultipleFileApi(data).subscribe((result: any) => {
  //     if (result['status'] == 1) {
  //       if (this.isFullFileUploadComponent == 'yes') {
  //         this.getRepositoryDetail(uuid);
  //         let query = {"page":1,"page_size":20}
  //         this.getRepositoryFilesPagination(uuid,query);
  //       }
  //       if (this.isFullFileUploadComponent == 'create') {
  //         this.isFileUploaded = true;
  //         if (this.addStudySubmitProgress == 'upload') {
  //           this.notify.notify('success', 'Study successfully created');
  //           this.close();
  //         }
  //         else this.addStudySubmitProgress = 'request';
  //       }
  //       else this.notify.notify('success', 'File uploaded successfully');
  //       this.isLoading = false;
  //     }
  //     else {
  //       this.notify.notify('error', result['message']);
  //       this.isLoading = false;
  //     }
  //   }, error => {
  //     this.notify.notify('error', 'Internet connectivity issue. Please check your connection & try again.');
  //     this.isLoading = false;
  //   })
  // }


  uploadMultipleFileApiFunc(data, uuid) {
    let options: any = {};
    options['method'] = 'POST';
    // options['relativeUrl'] = '/v2/repo/uploadFiles';
    options['relativeUrl'] = (this.copy_file_id && this.copy_file_id !="") ?'/v2/repo/uploadFiles?copy_file_id='+this.copy_file_id : '/v2/repo/uploadFiles';
    options['body'] = data ? data : {};
    options['options'] = {}; 
    options['options']['httpOptions'] = this.httpPostOptionsFile;
    options['options']['httpOptions']['reportProgress'] = true;
    options['options']['httpOptions']['observe'] = "events";
    this.showPogress = true;
    if (this.isFullFileUploadComponent != 'create') {
      this.notify.notify('warning', "File upload in progress. Please do not refresh the page");
    }
    this.apiRequest.httpCallForFileUpload(options, (response) => {
      if (response.progress !== undefined) {
        // console.log("pogress in api ===> ",response.progress)
        this.emitFileUploadPogress.emit({progress: response.progress })
      } else if (response.response) {
        let result = response.response;
        // console.log("result in api ===> ",result)
        if (result['status'] == 1) {
          this.tempFileDublicateCheckObj = {};
          if (this.isFullFileUploadComponent == 'yes') {
            this.getRepositoryDetail(uuid);
            let query = {"page":1,"page_size":20}
            this.getRepositoryFilesPagination(uuid,query);
          }
          if (this.isFullFileUploadComponent == 'create') {
            this.isFileUploaded = true;
            if (this.addStudySubmitProgress == 'upload') {
              this.notify.notify('success', 'Study successfully created');
              this.close();
            }
            else this.addStudySubmitProgress = 'request';
          }
          else this.notify.notify('success', 'File uploaded successfully');
          this.isLoading = false;
          this.resetFileToDefault();
          setTimeout(() => {
            this.showPogress = false;
            this.isUploadFile = false;
          }, 500);
        }else if (result['status'] == 2) {
          this.tempFileDublicateCheckObj["message"] = result['message'];
          this.copy_file_id=result['copyFileTranslation'] + "";
          this.openSameFileUploadNotificationModel();
        } else if (result['status'] == 3) {
          this.tempFileDublicateCheckObj["message"] = result['message'];
          this.isLoading = false;
          this.showPogress = false;
          this.resetFileToDefault();
          this.openSameFileUploadNotificationModel(true);
        }
        else {
          this.notify.notify('error', result['message']);
          this.resetFileToDefault();
          this.isLoading = false;
          this.showPogress = false;
          this.isUploadFile = false;
        }
      }else{
        if (response && response.error && response.error.status == 0) {
          this.notify.notify('error', response.error.message);
          this.close();
        }else{
          this.notify.notify('error', 'Internet connectivity issue. Please check your connection & try again.');
        }
        this.resetFileToDefault();
        this.isLoading = false;
        this.showPogress = false;
        this.isUploadFile = false;
      }
    });
  }

  uploadMultipleFileExternalApiFunc(data) {
    this.isLoading = true;
    // console.log("data external ===> ",data)
    this.uploadMultipleFileExternalApi(data).subscribe((result: any) => {
      if (result['status'] == 1) {
        this.externalFileUploadedEvent.emit(this.externalFileUploadToken);
        this.notify.notify('success', 'File uploaded successfully');
        this.resetFileToDefault();
        this.isLoading = false;
      }
      else {
        this.notify.notify('error', result['message']);
        this.resetFileToDefault();
        this.isLoading = false;
      }
    }, error => {
       if (error && error.error && error.error.status == 0) {
          this.notify.notify('error', error.error.message);
        }else{
          this.notify.notify('error', 'Internet connectivity issue. Please check your connection & try again.');
        }
      this.resetFileToDefault();
      this.isLoading = false;
    })
  }

  // uploadNewReport(body):Observable<any>{
  //   let input = new FormData();
  //   input.append("description",body.description);
  //   input.append("title",body.title);
  //   input.append("type",body.type);
  //   input.append("projectName",body.projectName);
  //   input.append("projectId",body.projectId);
  //   input.append("tag",body.tags);
  //   input.append("source",body.source);
  //   input.append("completion_date",body.completion_date);
  //   input.append("job_id",body.job_id);


  //   let opt = {};
  //   opt['httpOptions'] = this.httpPostOptionsFile;
  //   return this.apiRequest.request('POST','/v2/repo/uploadrepo',input,opt);
  //   // return post(environment.apiUrl + '/v2/repo/uploadrepo',input, this.httpPostOptionsFile);
  // }

  uploadNewReport(body){
    let options: any = {};
    let input = new FormData();
    input.append("description",body.description);
    input.append("title",body.title);
    input.append("type",body.type);
    input.append("projectName",body.projectName);
    input.append("projectId",body.projectId);
    input.append("tag",body.tags);
    input.append("source",body.source);
    input.append("completion_date",body.completion_date);
    input.append("job_id",body.job_id);
    if(body.bu_code && body.bu_code != ''){
      input.append("bu_code",body.bu_code);
    }
    input.append("objective",body.objective);
    options['method'] = 'POST';
    options['relativeUrl'] = '/v2/repo/uploadrepo';
    options['body'] = input ? input : {};
    options['options'] = {}; 
    options['options']['httpOptions'] = this.httpPostOptionsFile;
    options['options']['httpOptions']['reportProgress'] = true;
    options['options']['httpOptions']['observe'] = "events";
    this.showPogress = true;
    if (this.isFullFileUploadComponent != 'create') {
      this.notify.notify('warning', "File upload in progress. Please do not refresh the page");
    }
    this.apiRequest.httpCallForFileUpload(options, (response) => {
      if (response.progress !== undefined) {
        // console.log("pogress in api ===> ",response.progress);
        this.emitFileUploadPogressV2.emit({progress: response.progress })
      } else if (response.response) {
        this.emitFileUploadRepoResponse.emit({result: response.response });
      }else{
        this.notify.notify('error', 'Internet connectivity issue. Please check your connection & try again.');
        this.isLoading = false;
        this.showPogress = false;
        this.isUploadFile = false;
      }
      
    });
  }


  uploadUpdateReport(body,id){
    let options: any = {};
    let input = new FormData();
    input.append("description",body.description);
    input.append("title",body.title);
    input.append("type",body.type);
    input.append("projectName",body.projectName);
    input.append("projectId",body.projectId);
    input.append("tag",body.tags);
    input.append("source",body.source);
    input.append("completion_date",body.completion_date);
    input.append("job_id",body.job_id);
    if(body.bu_code && body.bu_code != ''){
      input.append("bu_code",body.bu_code);
    }
    input.append("file_id", id);
    input.append("objective",body.objective);
    options['method'] = 'PUT';
    options['relativeUrl'] = '/v2/repo/uploadrepo';
    options['body'] = input ? input : {};
    options['options'] = {}; 
    options['options']['httpOptions'] = this.httpPostOptionsFile;
    options['options']['httpOptions']['reportProgress'] = true;
    options['options']['httpOptions']['observe'] = "events";
    this.apiRequest.httpCallForFileUpload(options, (response) => {
      if(response.response){
        this.emitFileUpdateUploadRepoResponse.emit({result: response.response });
      }
    });
  }

  // createNewStudyAndMoveFiles(body){
  //   let selectedFiles = this.getSelectedFilesId();
  //   if(selectedFiles.length == 0){
  //     this.notify.notify('error', 'Please select files to move');
  //     return;
  //   }
  //   let options: any = {};
  //   let input = new FormData();
  //   input.append("description",body.description);
  //   input.append("title",body.title);
  //   input.append("type",body.type);
  //   input.append("projectName",body.projectName);
  //   input.append("projectId",body.projectId);
  //   input.append("tag",body.tags);
  //   input.append("source",body.source);
  //   input.append("completion_date",body.completion_date);
  //   input.append("job_id",body.job_id);
  //   if(body.bu_code && body.bu_code != ''){
  //     input.append("bu_code",body.bu_code);
  //   }
  //   input.append("objective",body.objective);
  //   options['method'] = 'POST';
  //   options['relativeUrl'] = '/v2/repo/uploadrepo';
  //   options['body'] = input ? input : {};
  //   options['options'] = {}; 
  //   options['options']['httpOptions'] = this.httpPostOptionsFile;
  //   options['options']['httpOptions']['reportProgress'] = true;
  //   options['options']['httpOptions']['observe'] = "events";
  //   this.apiRequest.httpCallForFileUpload(options, (response) => {
  //     if (response.response) {
  //       this.createdUUID = response.response['uuid'];

  //       let body = {
  //           "study_id": this.createdUUID,
  //           "file_id": selectedFiles,
  //           "keep_original":true
  //         }
  //       console.log("body ====> ",body);
  //       this.moveAllFiles(body).subscribe((res:any) => {
  //         if(res['status'] == 1){
  //           this.isMoveAllFileOpen = false;
  //           this.close();
  //           this.allSelectedFiles = [];
  //           this.notify.notify('success', 'Files moved successfully');
  //         } 
  //       });
  //     }else{
  //       this.notify.notify('error', 'Internet connectivity issue. Please check your connection & try again.');
  //       this.isLoading = false;
  //     }
  //   });
  // }

  getSelectedFilesId(){
    if(this.allSelectedFiles && this.allSelectedFiles.length > 0){
      return this.allSelectedFiles.map((file:any) => file.file_uuid);
    }else{
      return [];
    }
  }

  // moveAllFiles(body){
  //   console.log("body at /v2/repo/move-all ====> ",body);
  //   return this.apiRequest.request('POST','/v2/repo/move-all',body);
  // }

  getAllDownloadableFilesOfRepository(body){
    return this.apiRequest.request('POST','/v2/repo/download-all/download',body);
    // return this.apiRequest.request('POST','/v2/repo/files-zip/download',body);
  }

  getAllFileListOfRepository(body){
    return this.apiRequest.request('POST','/v2/repo/download-all/files',body);
  }

  setQueueForDownloadAll(body){
    return this.apiRequest.request('POST','/v2/repo/download-all/queue',body);
  }


  updateFileOfVideoAnalyzerApiCall(body,id){
    return this.apiRequest.request('PUT',`/v2/repo/updateFileVideoAnalyzer/${id}`,body);
  }

  getRepositoryDetails(uuid,query ?: any){
    let pathUrl = '/v2/repo/getrepo/'+uuid;
    let opt = {};
    opt['query'] = query;
    if (query) {
      return this.apiRequest.request('GET',pathUrl,{},opt);
    }else{
      return this.apiRequest.request('GET',pathUrl);
    }
    // return this.http.get(environment.apiUrl + '/v2/repo/getrepo/'+uuid, this.httpPostOptions);
  }

  getRepoFilesDetails(uuid,query ?: any){
    let pathUrl = '/v2/repo/getrepofiles/'+uuid;
    let opt = {};
    opt['query'] = query;
    return this.apiRequest.request('GET',pathUrl,{},opt);
    // if (query) {
    // }else{
    //   return this.apiRequest.request('GET',pathUrl);
    // }
    // return this.http.get(environment.apiUrl + '/v2/repo/getrepo/'+uuid, this.httpPostOptions);
  }

  getAllRepoFiles(uuid,query ?: any){
    let pathUrl = '/v2/repo/getrepofiles/'+uuid;
    let opt = {};
    opt['query'] = query;
    return this.apiRequest.request('GET',pathUrl,{},opt);
  }

  getRepositoryDetailsByFile(uuid){
    let pathUrl = '/v2/repo/getfilerepo/'+uuid;
    return this.apiRequest.request('GET',pathUrl);
  }

  openQualFile(body){
    return this.apiRequest.request('POST','/v2/api/getQualFileUrl',body);
    // return this.http.post(environment.apiUrl + '/v2/api/getQualFileUrl', body, this.httpPostOptions);
  }

  generateStudyAISummary(uuid,body?:any){
    let reqBody = body ? body : {};
    return this.apiRequest.request('POST','/v2/api/vi-genrate-summary/study/'+uuid,reqBody);
  }

  pinGroupSummary(uuid){
    return this.apiRequest.request('GET','/v2/api/vi/study-summary/pin/'+uuid);
  }

  deleteGroupSummary(uuid){
    return this.apiRequest.request('GET','/v2/api/vi/study-summary/delete/'+uuid);
  }


  getVideoAccessToken(){
    let pathUrl = '/v2/repo/getVideoAcessToken/' + this.detailsUUID;
    return this.apiRequest.request('GET',pathUrl);
    // return this.http.get(environment.apiUrl + '/v2/repo/getVideoAcessToken/' + this.detailsUUID, this.httpPostOptions);
  }


  openFile(body){
    return this.apiRequest.request('POST','/v2/repo/getfileurlview',body);
    // return this.http.post(environment.apiUrl + '/v2/repo/getfileurlview', body, this.httpPostOptions);
  }

  // openNewFile(body){
  //   let options = this.apiRequest.getOptions('POST','v2/repo/getfileurlview',body);
  //   return this.apiRequest.request(options);
  // }
  
  // downloadFile(){
  //   let body = {"uuid":this.detailsUUID}
  //   return this.apiRequest.request('POST','/v2/repo/getfileurldownload',body);
  //   // return this.http.post(environment.apiUrl + '/v2/repo/getfileurldownload/', body, this.httpPostOptions);
  // }
  downloadFile(type?) {
    let body = {};
    body['uuid'] = this.detailsUUID;
    if(type === 'abs'|| type === 'pct' || type === 'both'){
      body['dataTable_type'] = type;
    }else if (type === 'translation_original' || type === 'translated_combined' || type === 'translated_split' || type === 'translated_original'){
      body['translation_type'] = type;
    }else if (type === 'pdf' || type === 'word') {
      body['file_type'] = type;
    }else if(this.ZipTranslationDownloadOptions.some((option) => option.id === type)){
      body['survey_translation_type'] = type;
    }
    return this.apiRequest.request('POST','/v2/repo/getfileurldownload',body);
    // return this.http.post(environment.apiUrl + '/v2/repo/getfileurldownload/', body, this.httpPostOptions);
  }

  downloadCurrentCrosstab(body) {
    return this.apiRequest.request('POST','/v2/tableextraction/getDownloadFile',body);
  }

  downloadQualFile(type) {
    let body = {};
    body['uuid'] = this.detailsUUID;
    if(type === 'abs'|| type === 'pct' || type === 'both'){
      body['dataTable_type'] = type;
    }else if (type === 'translation_original' || type === 'translated_combined' || type === 'translated_split' || type === 'translated_original'){
      body['translation_type'] = type;
    }else if (type === 'pdf' || type === 'word') {
      body['file_type'] = type;
    }else if(this.ZipTranslationDownloadOptions.some((option) => option.id === type)){
      body['survey_translation_type'] = type;
    }
    
    return this.apiRequest.request('POST','/v2/api/getQualFileUrlDownload',body);
  }

  downloadICVTranscriptApi(type) {
    let body = {};
    // body['uuid'] = this.detailsUUID;
    body['file_type'] = type;
    return this.apiRequest.request('POST','/v2/vi/transcript/download/'+this.detailsUUID,body);
  }

  download(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob'
    })
  }

  searchRepo(title){
    let opt = {};
    opt['query'] = {"title":title}
    return this.apiRequest.request('GET','/v2/repo/getrepo',{},opt);
  }

  
  public process(data): any {
    let result = [];
    result = data.map((item) => {
      return this.toTreeNode(item);
    });
    return result;
  }

  private toTreeNode(node, parent = null) {
    if (node && node.children) {
      node.children.map((item) => {
        return this.toTreeNode(item, node);
      });
    }
    return node;
  }

  createClubTreeObj(topcutObj){
    // console.log(topcutObj,'TopCut');
    this.clubDataTreeJSON = [];
    this.recurciveTreeObj(topcutObj['topcut'], 'root', 'root', 'root', topcutObj['id']+'-', topcutObj['id'], this.clubDataTreeJSON);
    setTimeout(()=>{
      this.clubTreeItems = this.process(this.clubDataTreeJSON);
    },2000)
  }
 

  // createSigTreeObj(cut){
  //   // console.log(cut,'SigTree');
  //   let topcutObj = {}
  //   Object.keys(cut).forEach(skey =>{
  //     if (skey.includes('overall')) {
  //       topcutObj[skey] = {"type": "option"}
  //     }
  //   })
  //   Object.keys(cut['topcut']).forEach(key =>{
  //     topcutObj[key] = cut['topcut'][key]
  //   })
  //   this.sigDataTreeJSON = [];
  //   this.recurciveTreeObj(topcutObj, 'root', this.initionalTopcutId+'-', this.sigDataTreeJSON);
  //   setTimeout(()=>{
  //     this.sigTreeItems = this.process(this.sigDataTreeJSON);
  //   },20)
  // }

  locateCell(coordinates){
    this.emitSigCellCoordinates.emit(coordinates)
  }
  createSigTreeObjForWithRespect(cut)
  {
    // console.log(cut,'SigTreewith');
    let topcutObj = {}
    Object.keys(cut).forEach(skey =>{
      if (skey.includes('overall')) {
        topcutObj[skey] = {"type": "option","name":skey}
      }
    })
    Object.keys(cut['topcut']).forEach(key =>{
      topcutObj[key] = cut['topcut'][key]
    })
    this.sigDataTreeJSON = [];
    this.recurciveTreeObj(topcutObj, 'root', 'root', 'root', this.initionalTopcutId+'-', this.initionalTopcutId, this.sigDataTreeJSON);
    this.sigTreeItemsForWithRespect = this.process(this.sigDataTreeJSON);
    // console.log('this.sigTreeItemsForWithRespect ===> ',this.sigTreeItemsForWithRespect);
    // setTimeout(()=>{
    //   this.sigTreeItemsForWithRespect = this.process(this.sigDataTreeJSON);
    // },500)
  }

  createSigTreeObjForToColumn(cut)
  {
    // console.log(cut,'SigTreeto');
    let topcutObj = {}
    Object.keys(cut['topcut']).forEach(key =>{
      topcutObj[key] = cut['topcut'][key]
    })
      
    let newTopcutObj = {"Select All": {
      "type": "topcut",
      "sType":"All",
      "name":"Select All",
      "options":topcutObj
    }}
    this.sigDataTreeJSON = [];
    this.recurciveTreeObj(newTopcutObj, 'root', 'root', 'root', this.initionalTopcutId+'-', this.initionalTopcutId, this.sigDataTreeJSON);
    this.sigTreeItemsFortoColumn = this.process(this.sigDataTreeJSON);
    // console.log('this.sigTreeItemsFortoColumn ====> ',this.sigTreeItemsFortoColumn);
    // setTimeout(()=>{
    //   this.sigTreeItemsFortoColumn = this.process(this.sigDataTreeJSON);
    // },1000)
  }

  createSigTreeForFullCrosstab(){
    this.sigFullTreeItemsForWithRespect = JSON.parse(JSON.stringify(this.treeItems[this.fileUUID][0]["children"]))
    this.sigFullTreeItemsFortoColumn = JSON.parse(JSON.stringify(this.treeItems[this.fileUUID]))
    // console.log("this.sigFullTreeItemsForWithRespect =====> ",this.sigFullTreeItemsForWithRespect)
  }
  createTreeObj(topcutObj,file_uuid){
    this.isTopcutLoaded = false;
    let newTopcutObj = [{id:0,topcut:{"Select All": {
      "type": "option",
      "index": 0,
      "sType":"All",
      "name":"Select All"
    }}}]
    topcutObj.forEach(topcut =>{
      newTopcutObj.push(topcut)
    })
    this.treeItems[file_uuid] = [];
    // console.log("newTopcutObj +_+_++_+_+_+> ",newTopcutObj);
    newTopcutObj.forEach((topcut, index) => {
      this.recurciveTreeObj(topcut['topcut'], 'root', 'root', 'root', topcut['id']+'-', topcut['id'], this.dataTreeJSON);
    });
    setTimeout(()=>{
      let treeArray = this.process(this.dataTreeJSON)
      let treeObj = treeArray[0];
      treeObj['children'] = [];
      treeArray.forEach((item, index) => {
        if (index > 0) {
          treeObj['children'].push(item);
        }
      });
      this.treeItems[file_uuid].push(treeObj);
      this.isTopcutLoaded = true;
    },100)
    // console.log("this.treeItems +_+_++_+_+_+> ",this.treeItems);
  }

  createSidecutTreeObj(sidecutV2:any,file_uuid){
    // console.log("sidecutV2 =====> ",sidecutV2)
    this.isSidecutLoaded = false;
    let newSidecutObject = {};
    newSidecutObject['Select All'] = {"name":"Select All","options":[],"allowed_topcuts":[0],"sType":"All"};
    Object.keys(sidecutV2).forEach((key, i) =>{
      // newSidecutObject[sidecutV2[key]["name"]] = sidecutV2[key];
      // newSidecutObject[sidecutV2[key]["name"]]["pUUID"] = key;

      newSidecutObject[key] = sidecutV2[key];
      // newSidecutObject[key]["pUUID"] = key;
      // newSidecutObject[key]["pUUID"] = key+"-11111-uuid-"+i;
    })
    // console.log("newSidecutObject before = ",newSidecutObject)
    this.sidecutTreeitems[file_uuid] = [];
    Object.keys(newSidecutObject).forEach((key, index) =>{
      let obj = {};
      let sidecutObject = {};
      obj['type'] = index > 0 ?'topcut':"option";
      // obj['pUUID'] = newSidecutObject[key]['pUUID'];
      obj['v'] = newSidecutObject[key]['name'];
      obj['allowed_topcuts'] = newSidecutObject[key]['allowed_topcuts'][0];
      let obj1 = {};
      newSidecutObject[key]['options'].forEach((va,i) =>
      {
        // obj1[i] = va;
        obj1[va["label"]] = va;
      })
      obj['options'] = obj1;
      sidecutObject[key] = obj;
      // this.recurciveTreeObj(sidecutObject, 'root', sidecutObject[key]['allowed_topcuts']+'-', sidecutObject[key]['allowed_topcuts'], this.sidecutTreeJSON);
      this.recurciveSideTreeObj(sidecutObject, 'root', "root", "root", sidecutObject[key]['allowed_topcuts']+'-', sidecutObject[key]['allowed_topcuts'], this.sidecutTreeJSON);
    });
    setTimeout(()=>{
      
      let treeArray = this.process(this.sidecutTreeJSON)
      let treeObj = treeArray[0];
      treeObj['children'] = [];
      treeArray.forEach((item, index) => {
        if (index > 0) {
          treeObj['children'].push(item);
        }
      });
      this.sidecutTreeitems[file_uuid].push(treeObj);
      this.sidecutTreeitemsCopy = JSON.parse(JSON.stringify(this.sidecutTreeitems))
      this.isSidecutLoaded = true;
    },100)
    // console.log("this.sidecutTreeJSON) ====> ",this.sidecutTreeJSON);

  }

  // createSidecutTreeObj(sidecutV2:any,file_uuid){
  //   let sidecutObject = {};
  //   console.log("sidecuts are===>",sidecutV2)
  //   Object.keys(sidecutV2).forEach(key =>{
  //     let obj = {};
  //     obj['type'] = 'topcut';
  //     let obj1 = {};
  //     sidecutV2[key]['options'].forEach((va) =>
  //     {
  //       obj1[va] = va;
  //     })
  //     obj['options'] = obj1;
  //     sidecutObject[key] = obj;
  //   });
  //   let newSidecutObj = {"Select All": {
  //     "type": "topcut",
  //     "sType":"All",
  //     "options":sidecutObject
  //   }}
  //   this.recurciveTreeObj(newSidecutObj, 'root', this.initionalTopcutId+'-', this.initionalTopcutId, this.sidecutTreeJSON,);
  //   setTimeout(()=>{
  //     this.sidecutTreeitems[file_uuid] = this.process(this.sidecutTreeJSON);
  //     console.log(this.sidecutTreeitems[file_uuid]);
  //   },200)
  // }



  recurciveTreeObj(topcut, parent, parentName, parent_id, id, allowed_topcuts, treeJson){
    Object.keys(topcut).forEach((key, index)=>{
      let dataItem = {};
      // dataItem['id'] = id + '' + index;
      // dataItem['id'] = id + '' + parent + '---' + key;
      // dataItem['name'] = key;
      let cutName = topcut[key]["name"];
      dataItem['p'] = '';
      let parentId = parent_id;
      if (parentName.split('---').length > 1) {
        dataItem['p'] = parentName.split('---')[1];
        // parentId = parentId + "$$$" + parentName;
      }else{
        dataItem['p'] = cutName;
      }
      // dataItem['id'] = id + '' + parent + '---' + key + "$$$" + cutName;
      // dataItem['id'] = id + '' + parentId + '---' + key + "$$$" + cutName;
      parentId = parentId + '---' + key + "$$$" + cutName;
      dataItem['id'] = id + '' + parentId;
      dataItem['name'] = cutName;
      dataItem['parentName'] = parentName;
      dataItem['uuid'] = key;
      dataItem['parent'] = parent;
      dataItem['allowed_topcuts'] = allowed_topcuts
      dataItem['show'] = false;
      dataItem['n'] = topcut[key]['n'];
      if (topcut[key]['sType'] && topcut[key]['sType'] == 'All') {
        dataItem['sType'] = 'All'; 
      }
      // if (parent.split('---').length > 1) {
      //   dataItem['p'] = parent.split('---')[1];
      // }else{
      //   dataItem['p'] = key;
      // }
      if(topcut[key]['type'] == 'topcut'){
        dataItem['children'] = [];
        treeJson.push(dataItem);
        // this.recurciveTreeObj(topcut[key]['options'], parent+'---'+key, dataItem['id'], allowed_topcuts, dataItem['children']);
        if (dataItem['sType'] == 'All') {
          this.recurciveTreeObj(topcut[key]['options'], parent, parentName, parentId, id, allowed_topcuts, dataItem['children']);
        }else{
          this.recurciveTreeObj(topcut[key]['options'], parent+'---'+key, parentName+'---'+cutName, parentId, id, allowed_topcuts, dataItem['children']);
        }
      }else{
        treeJson.push(dataItem);
      }
    });
  }

  recurciveSideTreeObj(topcut, parent, parentName, parent_id, id, allowed_topcuts, treeJson, isJsonShortingArray?:boolean){
    Object.keys(topcut).forEach((key, index)=>{
      let dataItem = {};
      // let keyName = key
      let keyName = isJsonShortingArray ? topcut[key]["label"] : key;
      let cutName = topcut[key]["v"];
      let parentId = parent_id;
      dataItem['p'] = '';
      if (parentName.split('---').length > 1) {
        dataItem['p'] = parentName.split('---')[1];
        // parentId = parentId + "$$$" + parentName;
      }else{
        dataItem['p'] = cutName;
      }
      // let keyName = isJsonShortingArray ? topcut[key]["v"] : key
      // let keyName = isJsonShortingArray ? topcut[key] : key
      // dataItem['id'] = id + '' + parent + '---' + keyName + "$$$" + cutName;
      // dataItem['id'] = id + '' + parentId + '---' + keyName + "$$$" + cutName;
      parentId = parentId + '---' + keyName + "$$$" + cutName;
      dataItem['id'] = id + '' + parentId;
      dataItem['name'] = cutName;
      dataItem['uuid'] = keyName;
      // dataItem['name'] = keyName;
      dataItem['label'] = key;
      dataItem['parent'] = parent;
      // dataItem['parentUUID'] = pUUID;
      dataItem['allowed_topcuts'] = allowed_topcuts;
      dataItem['show'] = false;
      dataItem['sequence'] = index;
      // dataItem['n'] = topcut[key]['n'];
      if (topcut[key]['sType'] && topcut[key]['sType'] == 'All') {
        dataItem['sType'] = 'All'; 
      }
      
      if(topcut[key]['type'] == 'topcut'){
        dataItem['children'] = [];
        treeJson.push(dataItem);
        if (dataItem['sType'] == 'All') {
          this.recurciveSideTreeObj(topcut[key]['options'], parent, parentName, parentId, id, allowed_topcuts, dataItem['children']);
        }else{
          this.recurciveSideTreeObj(topcut[key]['options'], parent+'---'+key, parentName+'---'+cutName, parentId, id, allowed_topcuts, dataItem['children'],true);
        }
      }else{
        treeJson.push(dataItem);
      }
    });
  }

  getExtrationCuts(fileDetails){
    this.allfilesDetails();
    if (this.router.url.includes("table-extraction")) {
      this.sideTreeChangesDataTable();
    }
    if (this.isQual) {
      this.router.navigate(['home/qual/table-extraction',this.fileUUID]);
    }else{
      this.router.navigate(['repo/table-extraction',this.fileUUID]);
      // this.router.navigate(['home/repository-report/table-extraction',this.fileUUID]);
    }
    this.initionalTopcutId = 0;
    let body = {"uuid":fileDetails['file_uuid']};
    // this.isLoading = true;
    this.getCut(body).subscribe(
      data => {
        if (data['status'] == 1) {
          this.isLoading = false;
          this.isUiWaitForApiDone = true;
          this.isFileConversionDone = true;
          this.trackerSessionId =  data['result']['session_id'];
          this.sidecutV2 = data['result']['sidecut'];
          this.topcutV2 = data['result']['topcut'];
          this.crosstabOptions[fileDetails['file_uuid']] = {}
          this.crosstabOptions[fileDetails['file_uuid']] = {"topcut":this.topcutV2,"sidecut":this.sidecutV2}
          this.dataTreeJSON = [];
          this.sidecutTreeJSON = [];
          this.treeItems = {};
          // this.createTreeObj(data['result']['topcut'][0],fileDetails['file_uuid']);
          this.sidecutTreeitems = {};
          this.createTreeObj(data['result']['topcut'],fileDetails['file_uuid']);
          this.createSidecutTreeObj(this.sidecutV2,fileDetails['file_uuid']);
          
          this.dataTableOption['total_topcut'] = Object.keys(this.topcutV2).length
          this.dataTableOption['total_sidecut'] = Object.keys(this.sidecutV2).length
          // if (this.isQual) {
          //   this.router.navigate(['home/qual/table-extraction',this.studyId]);
          // }else{
          //   this.router.navigate(['home/repository-report/table-extraction',this.studyId]);
          // }

        }else if(data['status'] == 2){
          this.close();
          this.isFileConversionDone = false;
          this.notifier.notify('warning',data['message']);
          this.isUiWaitForApiDone = true;
        }else if(data['status'] == 4){
          this.notifier.notify('error',data['message']);
          this.redirectUnAuthorizedEvent.emit('unauthorized');
          // this.isLoading = false;
        }else{
          this.notifier.notify('error',data['errorMessage']);
          this.isLoading = false;
        }
      },
      error => {
        this.isLoading = false;
      }
    )
  }

  // getExtrationCuts(fileDetails){
  //   if (this.isQual) {
  //     this.router.navigate(['home/qual/table-extraction',fileDetails['file_uuid']]);
  //   }else{
  //     this.router.navigate(['home/repository-report/table-extraction',fileDetails['file_uuid']]);
  //   }
  //   // this.getCutData(fileDetails['file_uuid'])
  // }

  // getCutData(fileUUID) {
  //   let body = {"uuid" : fileUUID}
  //   this.getCut(body).subscribe(
  //     data =>{
  //       if (data['status'] == 1) {
  //         this.isLoading = false;
  //         // const study_id = data['studyId'] || '5aa3104c-631d-4ca7-993c-8977cf17990f';
  //         this.studyId= data['studyId'];
  //         // this.tableExtrationUpperCuts = result['uppercut'];
  //         // this.tableExtrationLowerCuts = result['undercut'];
  //         this.getRepositoryDetail(this.studyId,{fileView:'table-extraction',fileUUID:fileUUID, getFileResult:data});          
  //       }else{
  //         this.notifier.notify('error',data['errorMessage']);
  //         this.isLoading = false;
  //       }
  //     },
  //     error =>{
  //       this.isLoading = false;
  //     }
  //   )
  // }

  // setCutData(data) {
  //   this.trackerSessionId =  data['result']['session_id'];
  //   this.sidecutV2 = data['result']['sidecut'];
  //   this.topcutV2 = data['result']['topcut'];
  //   this.dataTreeJSON = [];
  //   this.treeItems = {};
  //   this.createTreeObj(data['result']['topcut'][0],this.fileUUID);
    
  //   this.dataTableOption['total_topcut'] = Object.keys(this.topcutV2).length
  //   this.dataTableOption['total_sidecut'] = Object.keys(this.sidecutV2).length
  // }

  // setExcelViewData(fileObj,data) {
  //   let _data = {fileObj:fileObj,data:data};
  //   this.setExcelFileViewerEvent.emit(_data);
  // }

  sideTreeChangesDataTable(){
    this.selectedCuts = '';
    this.filter_name = '';
    this.formData = null;
    this.mainJsonData = [];
    this.treeItems = {};
    this.clubTreeItems = [];
    this.isData = false;
    this.mainClubReq = {};
    this.otherChecks = {};
    this.clubbedOptions = {column:[],rows:{}};
    this.close();
    this.iService.close();
    this.sService.close();
    // this.openExtrationFilter();
  }

  allfilesDetails(){
    this.getprojectsFile().subscribe(data => {
      if(data['status'] == 1){
        this.projectList = data['result'];
        this.dataTableOption['total_table'] = this.projectList.length
      }else if(data['status'] == 4){
        this.notifier.notify("error",data['message']);
        this.redirectUnAuthorizedEvent.emit('unauthorized');
      }else{
        this.notifier.notify("error",'Something went wrong');
      }
    });
  }
  getDummyExtractionData(){
    return {"result":{"f0440b0c-bf84-4525-bacd-cc977b7e3b87":{"sidecut":{"city_uuid":{"name":"City","rows":[{"v":"Base Unweighted: All Respondents"},{"v":"Delhi NCR"},{"v":"Mumbai"}],"data":[[{"v":1121,"p":1121,"np":true},{"v":131,"p":11.69,"np":false},{"v":129,"p":11.51,"np":false}],[{"v":1413,"p":1413,"np":true},{"v":176,"p":12.43,"np":false},{"v":169,"p":11.98,"np":false}],[{"v":1405,"p":1405,"np":true},{"v":169,"p":12.01,"np":false},{"v":172,"p":12.23,"np":false}]],"hiddenRows":[],"topcut":{"Month":{"type":"topcut","options":{"Qtr2 AMJ 2020":{"type":"option","index":0,"show":true,"n":"Qtr2 AMJ 2020"},"Dec2022_Jan2023":{"type":"option","index":1,"show":true,"n":"Dec2022_Jan2023"},"Jan2023_Feb2023":{"type":"option","index":2,"show":true,"n":"Jan2023_Feb2023"}},"n":"Month"}}}}}},"status":1}
  }
  // getDummyExtractedTable(){
  //   let result = this.getDummyExtractionData();
  //   this.fileUUID = "f0440b0c-bf84-4525-bacd-cc977b7e3b87"
  //   if (result['status'] == 1) {
  //     this.mainJsonDataForSig = result['result'];
  //     this.jsonData = result['result'][this.fileUUID];
  //     this.jsonDataForGrid = result['result'][this.fileUUID];
  //     this.mainJsonData = JSON.parse(JSON.stringify(result['result'][this.fileUUID]));
  //     let cutkeys = Object.keys(this.jsonData['sidecut']);
  //     if (cutkeys && cutkeys.length) {
  //       this.createSigTreeObjForWithRespect(this.jsonData['sidecut'][cutkeys[0]])
  //       this.createSigTreeObjForToColumn(this.jsonData['sidecut'][cutkeys[0]])
  //     }
  //     setTimeout(()=>{
  //       if (Object.keys(this.mainClubReq).length) {
  //         let newClubReq = {};
  //         Object.keys(this.mainClubReq).forEach(cut => {
  //           if (Object.keys(this.jsonData['sidecut']).includes(cut)) {
  //             newClubReq[cut] = this.mainClubReq[cut]
  //           }
  //         });
  //         this.mainClubReq = JSON.parse(JSON.stringify(newClubReq))
  //         if (Object.keys(this.mainClubReq).length) {
  //           this.clubAllTables();
  //         }else{
  //           this.parseResultToGridJson();
  //           this.assignLength();
  //           this.isLoading = false;
  //         }
  //       }else{
  //         this.parseResultToGridJson();
  //         this.assignLength();
  //         this.isLoading = false;
  //       }
  //       this.sigSubmitFormFlag = false;
  //       this.sigResultArr = [];
  //       this.sigCalculationSave = false;
  //       this.onSignificanceReset();
  //     });
  //   } 
  //   this.close()
  // }
  resetLastRequest(){
    this.lastRequest = {}
  }

  getExtractedTable(request) {
    if (this.formData.value.dataValue == 'absolute') {
      this.viewFormateSelected = 2;
    } else if (this.formData.value.dataValue == 'percentage') {
      // check for percentage
      this.viewFormateSelected = 3;
    } else {
      this.viewFormateSelected = 4;
    }
    this.resetLastRequest();
    this.isData = false;
    this.tableExtrationData = [];
    this.isLoading = true;
    this.lastRequest["getData"] = request;
    // console.log("getData call time ===> ",Date.now())
    this.getExtractionData(request).subscribe(
      result => {
        if (result['status'] == 1) {
          // this.isLoading = false;
          this.mainJsonDataForSig = result['result'];
          this.jsonData = result['result'][this.fileUUID];
          this.jsonDataForGrid = result['result'][this.fileUUID];
          this.mainJsonData = JSON.parse(JSON.stringify(result['result'][this.fileUUID]));
          // this.mainJsonData = JSON.stringify(result['result'][this.fileUUID]);
          let cutkeys = Object.keys(this.jsonData['sidecut']);
          if (cutkeys && cutkeys.length) {
            // this.createSigTreeObj(this.jsonData['sidecut'][cutkeys[0]])
            this.createSigTreeObjForWithRespect(this.jsonData['sidecut'][cutkeys[0]])
            this.createSigTreeObjForToColumn(this.jsonData['sidecut'][cutkeys[0]])

          }
          setTimeout(()=>{
            if (Object.keys(this.mainClubReq).length) {
              let newClubReq = {};
              Object.keys(this.mainClubReq).forEach(cut => {
                if (Object.keys(this.jsonData['sidecut']).includes(cut)) {
                  newClubReq[cut] = this.mainClubReq[cut]
                }
              });
              this.mainClubReq = JSON.parse(JSON.stringify(newClubReq))
              if (Object.keys(this.mainClubReq).length) {
                this.clubAllTables();
              }else{
                // this.parseResultToGridJson();
                this.generateAgGridDataBlueprint();
                // this.parseSidecutToGridJson(Object.keys(this.jsonDataForGrid['sidecut'])[0]);
                this.assignLength();
                this.isLoading = false;
              }
            }else{
              // this.parseResultToGridJson();
              this.generateAgGridDataBlueprint();
              // this.parseSidecutToGridJson(Object.keys(this.jsonDataForGrid['sidecut'])[0]);
              this.assignLength();
              this.isLoading = false;
            }
            this.sigSubmitFormFlag = false;
            this.sigResultArr = [];
            this.sigCalculationSave = false;
            this.onSignificanceReset();
          });
        } else {
          this.notifier.notify('error', result['errorMessage'])
          this.isLoading = false;
          this.isData = false;
        }
      }, error => {
        this.isLoading = false;
        this.isData = false;
      }
    )
    this.close()
  }
  getSignificanceTable(body){
    // this.SigResultClearOnngDestroy();
    this.sigbuttonLoader = true;
    this.getSignificancetestData(body).subscribe(
      result =>{
        if (result['status'] == 1) {
          this.jsonData = result['data'][this.fileUUID];
          this.jsonDataForGrid = result['data'][this.fileUUID];
          this.mainJsonData = JSON.parse(JSON.stringify(result['data'][this.fileUUID]));
          let sigResultArrCopy = [];
          Object.keys(this.mainJsonData['sidecut']).forEach((va) => {
            let overallCount = 0;
            Object.keys(this.mainJsonData['sidecut'][va]).forEach(key =>{
              if (key.includes('overall')) {
                overallCount++
              }
            })
            if(this.mainJsonData['sidecut'][va]['result'] && Object.keys(this.mainJsonData['sidecut'][va]['result']).length > 0)
            {
              let arr = Object.entries(this.mainJsonData['sidecut'][va]['result']).sort();
              let copyarr = {};
              let sigHighlightResultArr = [];
              arr.forEach((va:any) =>
              {
                let key = va[0];
                let value = va[1];
                copyarr[key] = value;
                va[1].forEach((v2:any) => {
                  sigHighlightResultArr.push(v2);
                })
              })
              sigHighlightResultArr.sort((a:number,b:number) => {
                if(a['rowIndex'] ==  b['rowIndex'])
                {
                  return a['colIndex'] < b['colIndex'] ? -1 : a['colIndex'] > b['colIndex'] ? 1 : 0;
                }
                else
                {
                  return a['rowIndex'] < b['rowIndex'] ? -1 : a['rowIndex'] > b['rowIndex'] ? 1 : 0;
                }
              });
              // sigResultArrCopy.push({'sidecut':va,'result':this.mainJsonData['sidecut'][va]['result']});
              this.jsonData['sidecut'][va]['sortResult'] = {};
              this.jsonData['sidecut'][va]['sortResult'] = copyarr;
              sigResultArrCopy.push({'sidecut':this.mainJsonData['sidecut'][va]['name'], 'sidecutUUID':va,'result':copyarr,"overallLength":overallCount,'sigHighlightResult':sigHighlightResultArr});
            }
          })
          this.sigResultArr = sigResultArrCopy;
          if(this.sigResultArr.length > 0)
          {
            this.sigResultInit();
          }
          this.generateAgGridDataBlueprint();
          // this.parseSidecutToGridJson(Object.keys(this.jsonDataForGrid['sidecut'])[0]);
          // this.parseResultToGridJson();
          this.assignLength();
          this.dialoge.closeAll();
          this.notifier.notify('success','Significance calculation done successfully');
          this.sigCalculationSave = true;
          this.sigSubmitFormFlag = true;
          this.sigbuttonLoader = false;
          this.viewFormateSelected = 1;
        }else if (result['status'] == 2) {
          this.dialoge.closeAll();
          this.sigbuttonLoader = false;
          this.notifier.notify('success',result['message']);
        }else{
          this.sigbuttonLoader = false;
          this.notifier.notify('error',result['message'])
        }
      }
    )
  }


  getCut(body){
    let opt = {};
    // opt['httpOptions'] = this.httpPostOptionsFile
    return this.apiRequest.request('POST','/v2/tableextraction/getoptions',body,opt);
    // return this.http.post(environment.apiUrl + '/v2/tableextraction/getoptions',body, this.httpPostOptionsFile);
  }

  getExtractionData(body){
    let opt = {};
    opt['httpOptions'] = this.httpPostOptionsFile
    return this.apiRequest.request('POST','/v2/tableextraction/getData',body,opt);
    // return this.http.post(environment.apiUrl + '/v2/tableextraction/getData',body, this.httpPostOptionsFile);
  }

  getSignificancetestData(body)
  {
    let opt = {};
    opt['httpOptions'] = this.httpPostOptionsFile
    if(this.sigTestingtype && this.sigTestingtype == 'beta'){
      return this.apiRequest.request('POST','/v2/tableextraction/signtest/beta',body,opt);
    }else{
      return this.apiRequest.request('POST','/v2/tableextraction/signtest',body,opt);
    }
    // return this.http.post('http://eagle-dev.crownit.in' + '/v2/tableextraction/signtest',body, this.httpPostOptionsFile);

  }

  getSubStr(str, length, endLength?:number){
    if (!str) {
      return '';
    } else if (endLength) {
      if (str.length > (length + endLength)) {
        return str.substring(0, length) + '...' + str.substring(str.length - endLength);
      } else {
        return str;
      }
    } else if (str.length > length) {
      if (str.substring(0, 10) == '----------') {
        return str;
      } else {
        return str.substring(0, length) + '...';
      }
    } else {
      return str;
    }

  }

  showMatTooltip(str, length) {
    if (str && str.length > length) return str;
    return '';
  }

  showData() {
    let request = {};
    if (this.formData) {
      this.formData.value.cuts.forEach(cut => {
        request[cut.fileUUID] = {};
        request[cut.fileUUID]['sidecut'] = {};
        request[cut.fileUUID]['topcut'] = {};
        request[cut.fileUUID]['alias'] = cut.alias;
        request[cut.fileUUID]['seq'] = cut.seq;
        cut.sidecut.forEach(side => {
          request[cut.fileUUID]['sidecut'][side.name] = side.options;
        });
        cut.topcut.forEach(top => {
          request[cut.fileUUID]['topcut'][top.name] = top.options;
        });
      });
      let fileUUId = Object.keys(request);
      request = { "data": request }
      request['dataValue'] = this.formData.value.dataValue;
      request['viewFormate'] = this.formData.value.viewFormate;
      request['trendAnalysis'] = this.formData.value.trendAnalysis;
      this.otherChecks['dataValue'] = this.formData.value.dataValue;
      this.otherChecks['viewFormate'] = this.formData.value.viewFormate;
      this.otherChecks['trendAnalysis'] = this.formData.value.trendAnalysis;
      this.getExtractedTable(request);
      this.currentFilter = { "filter_data": this.formData.value.cuts, "uuid": fileUUId[0] };
    }

  }

  saveCrossTabs(name){
    let filter_data = {"filter":this.currentFilter['filter_data'],"club":this.mainClubReq,"otherChecks":this.otherChecks,"clubbedOptions":this.clubbedOptions}
    let body = {"filter_data":filter_data, "uuid":this.fileUUID, "name":name};
    // console.log("body ===> ",body)
    this.isLoading = true;
    this.postCrossTabs(body)
      .subscribe(result => {
        this.isLoading = false;
        if (result['status'] == 1) {
          this.notifier.notify('success', 'Cross tab saved successfully');
          this.close();
        } else {
          this.notifier.notify('error', 'Something went wrong.');
        }
      })
  }

  saveSigTabs(name){
    let sigSubmitData = {};
    sigSubmitData['type'] = this.sigComparetype;
    sigSubmitData['confidence'] = this.sigConfidenceLevel;
    sigSubmitData['sigTestingOn'] = this.sigTestingOn;
    sigSubmitData['sigBase'] = this.sigBase;
    
    // sigSubmitData['sigTestingOn'] = this.sigTestingOn === 'FullCrosstab' ? 'all' : 'crossTab';
    if (this.sigComparetype === 'FromColumn') {
      sigSubmitData['significanceValueArray'] = this.sigfromAmongarr;
    }
    let filter_data = {
      "filter":this.currentFilter['filter_data'],
      "club":this.mainClubReq,
      "otherChecks":this.otherChecks,
      "clubbedOptions":this.clubbedOptions,
      'significance_test':sigSubmitData,
      'data':this.mainJsonDataForSig,
      'request':this.lastRequest,
      // 'sigTreeItems':this.sigTreeItems
      'sigTreeItemsForWithRespect':this.sigTreeItemsForWithRespect,
      'sigTreeItemsFortoColumn':this.sigTreeItemsFortoColumn,
      'small_base':this.sigSmallBaseToggleButton,
      'isBeta':this.sigTestingtype === 'beta' ? true : false
    };
    let body = {"filter_data":filter_data,"uuid":this.fileUUID, "name":name};
    this.isLoading = true;
    this.postCrossTabs(body)
    .subscribe(result=>{
      this.isLoading = false;
      if (result['status']== 1) {
        this.notifier.notify('success','Significance calculation saved successfully');
        this.close();
      }else{
        this.notifier.notify('error','Something went wrong.');
      }
    })
  }

  postCrossTabs(body){
    let opt = {};
    opt['httpOptions'] = this.httpPostOptionsFile;
    return this.apiRequest.request('POST','/v2/repo/postfilterdata',body,opt);
    // return this.http.post(environment.apiUrl + '/v2/repo/postfilterdata',body, this.httpPostOptionsFile);
  }

  getSavedCrossTabs() {
    // this.isLoading = true;
    this.savedFilters = [];
    this.getSavedCrossTabList(this.fileUUID)
    .subscribe(result =>{
      this.isLoading = false;
      if (result["status"] == 1) {
        this.savedFilters = result["filter_data"];
      }
    })
  }

  getSavedCrossTabList(uuid){
    let pathUrl = '/v2/repo/getdatafilter/'+uuid
    return this.apiRequest.request('GET',pathUrl);
    // return this.http.get(environment.apiUrl + '/v2/repo/getdatafilter/'+uuid, this.httpPostOptions);
  }

  getprojectsFile(){
    const data = {file_id:this.fileUUID};
    return this.apiRequest.request('POST','/v2/tableextraction/getDataTableFiles',data);
    // return this.http.post(environment.apiUrl + '/v2/tableextraction/getDataTableFiles', data, this.httpPostOptions);
  }

  getLanguages(){
    return this.apiRequest.request('GET','/v2/api/vi-config');
  }

  getTranslationUploadConfig(query) {
    let opt = {};
    opt['query'] = query;
    return this.apiRequest.request('GET','/api/survey-translation/upload-config',{},opt);
  }

  pickFilter(workSpace, filter_name) {
    let cut = workSpace.filter;
    this.formData = new FormGroup({
      cuts: this.formBuilder.array([this.createCut(this.fileUUID)]),
      dataValue: new FormControl('absolute', [Validators.required]),
      viewFormate: new FormControl('tabular', [Validators.required]),
      trendAnalysis: new FormControl(false, [Validators.required]),
    });

    this.resetForm();
    for (let i = 0; i < cut.length; i++) {
      for (let j = 0; j < cut[i].topcut.length - 1; j++) {
        this.addTopcut(this.formData.get('cuts')['controls'][i]);
      }
      for (let k = 0; k < cut[i].sidecut.length - 1; k++) {
        this.addSideut(this.formData.get('cuts')['controls'][i]);
      }
      if (i < cut.length - 1) {
        this.addCut();
      }
    }
    if (cut.length > 1) {
      this.formData.patchValue({ "trendAnalysis": true });
    }
    setTimeout(() => {
      // this.crossTabForm.patchValue({"cuts":cut});
      this.formData.patchValue({ "cuts": cut });
      this.formData.patchValue({ "dataValue": workSpace.otherChecks['dataValue'] });
      this.filter_name = filter_name;
      this.mainClubReq = workSpace.club;
      this.clubbedOptions = workSpace.clubbedOptions ? workSpace.clubbedOptions : {};
      this.showData();
    }, 500)


  }

  createCut(fileUUID): FormGroup {
    let seq = 1;
    if (this.formData && this.formData.value.cuts.length) {
      seq = this.formData.value.cuts.length + 1;
    }

    return this.formBuilder.group({
      topcut: this.formBuilder.array([this.createTopcut()]),
      sidecut: this.formBuilder.array([this.createSideut()]),
      fileUUID: new FormControl(fileUUID),
      projectName: new FormControl('select', [Validators.required]),
      seq: new FormControl(seq, [Validators.required]),
      alias: new FormControl(''),
      sideOption: new FormControl({ 'select': 'select' }),
      topOption: new FormControl({ 'select': 'select' })
    });
  }

  resetForm() {
    this.formData = null;
    this.formData = new FormGroup({
      cuts: this.formBuilder.array([this.createCut(this.fileUUID)]),
      dataValue: new FormControl('absolute', [Validators.required]),
      viewFormate: new FormControl('tabular', [Validators.required]),
      trendAnalysis: new FormControl(false, [Validators.required]),
    })
  }

  createTopcut(): FormGroup {
    return this.formBuilder.group({
      name: new FormControl('', [Validators.required]),
      options: new FormControl([], [Validators.required]),
    });
  }

  createSideut(): FormGroup {
    return this.formBuilder.group({
      name: new FormControl('', [Validators.required]),
      options: new FormControl([], [Validators.required]),
    });
  }

  addTopcut(topcut: FormArray): void {
    let items = topcut.get('topcut') as FormArray;
    items.push(this.createTopcut());
  }

  addSideut(sidecut: FormArray): void {
    let items = sidecut.get('sidecut') as FormArray;
    items.push(this.createSideut());
  }

  addCut(): void {
    let items = this.formData.get('cuts') as FormArray;
    if ((items.length) <= this.projectList.length) {
      items.push(this.createCut(''));
    } else {
      this.notifier.notify('error', 'Maximum Project Found');
    }
  }

  getComments(uuid, type) {
    // Skip if we already loaded insights for this file UUID (prevents duplicate API calls)
    if (this.lastInsightListFileUUID === uuid && type === 'file') {
      return;
    }
    this.fileTypeStored = type;
    let body = { "uuid": uuid, "type": type };
    this.lastInsightListFileUUID = uuid;
    this.iService.getInsightList(body);
    this.commentCount = 0;
    setTimeout(() => {
      this.commentCount = this.iService.insightList ? this.iService.insightList.length : 0;
    }, 2000)
  }

  async clubAllTables(){
    this.clubbedOptions = {column:[],rows:{}}
    this.lastRequest["club"] = (this.lastRequest && this.lastRequest["club"]) ? this.lastRequest["club"] : {};
    // this.lastRequest["club"] = JSON.parse(JSON.stringify(this.mainClubReq));
    // console.log("Main club request ====> ",this.mainClubReq)
    Object.keys(this.mainClubReq).forEach(cut =>{
      this.mainClubReq[cut].columns.forEach(col => {
        col.values.forEach(val => {
            if (val.values_merged && val.values_merged.length>0 && Object.keys(val.values_merged[0])  && Object.keys(val.values_merged[0]).length>0) {
              val.values_merged.forEach(option => {
                let isDublicate = this.clubbedOptions['column'].find(item => {return (item.name == option.name && item.parent == option.parent)})
                if (!(isDublicate && isDublicate.name)) {
                  this.clubbedOptions['column'].push(option)
                }
              });
            }
        });
      });
      this.mainClubReq[cut].rows.forEach(row => {
        row.values.forEach(val => {
            if (val.values_merged && val.values_merged.length>0 && Object.keys(val.values_merged[0])  && Object.keys(val.values_merged[0]).length>0) {
              this.clubbedOptions['rows'][cut]=[]
              val.values_merged.forEach(option => {
                this.clubbedOptions['rows'][cut].push(option)
              });
            }
        });
      }); 
    })
    let keys = Object.keys(this.mainClubReq);
    for (let i = 0; i < keys.length; i++) {
      let clubData = this.mainClubReq[keys[i]];
      // this.lastRequest["club"][keys[i]]["data"] = {};
      // this.lastRequest["club"][keys[i]]["data"] = {"key":keys[i],"value":this.jsonData['sidecut'][keys[i]]};
      if (clubData.rows.length == 1 && clubData.rows[0].values.length == 1) {
        if (clubData.rows[0].values[0].values_merged.length == 0) {
          clubData.rows[0].values = [];
        }
      }

      if (clubData.columns.length == 1 && clubData.columns[0].values.length == 1) {
        if (clubData.columns[0].values[0].values_merged.length == 0) {
          clubData.columns[0].values = [];
        }
      }
      // let body = {"data":{
      //   "data":{"key":keys[i],"value":this.jsonData['sidecut'][keys[i]]},
      //   "clubData":clubData
      // }};
      let body = this.getClubReqJSON(keys[i]);
      body["data"]['clubData'] = clubData;
      // let body = {"data":{
      //   "clubData":clubData
      // }};
      // this.lastRequest["club"][keys[i]] = body;
      this.lastRequest["club"][keys[i]] = JSON.parse(JSON.stringify(body));
      delete this.lastRequest["club"][keys[i]]["data"]['request'];
      this.clubData(body)
        .then(
          result => {
            if (result['status'] == 1) {
              // let clubResult = result['data']['data']['sidecut'][keys[i]];
              let clubResult = result['data']['data']['value'];
              clubResult['clubFormData'] = this.mainClubReq[keys[i]];
              let temJsonData = JSON.parse(JSON.stringify(this.jsonData));
              this.jsonData = {};
              temJsonData['sidecut'][keys[i]] = clubResult;
              setTimeout(() => {
                this.jsonData = JSON.parse(JSON.stringify(temJsonData));
                this.jsonDataForGrid = JSON.parse(JSON.stringify(temJsonData));
                setTimeout(() => {
                  if (i == keys.length -1) {
                    this.parseResultToGridJson();
                  }
                  this.assignLength();
                }, 200);
              })
              this.close();
            } else {
              this.notifier.notify('error', 'Something went wrong');
              // i++
            }
            if (i == keys.length - 1) {
              setTimeout(() => {
                this.isLoading = false;
              }, 500)
            }
          }
        )
      
    }

  }

  // clubTable(body, clubFormData) {
  //   // console.log("club body ",body)

  //   // this.mainClubReq[body['data']['key']] = clubFormData;
  //   // console.log(this.mainClubReq)

  //   this.clubData(body)
  //     .then(
  //       result => {
  //         if (result['status'] == 1) {
  //           // let clubResult = result['data']['data']['sidecut'][keys[i]];
  //           let clubResult = result['data']['data']['key'] == keys[i] ? result['data']['data']['value'] :{};
  //           clubResult['clubFormData'] = this.mainClubReq[keys[i]];
  //           let temJsonData = JSON.parse(JSON.stringify(this.jsonData));
  //           let tempJsonDataForGrid = JSON.parse(JSON.stringify(this.jsonDataForGrid));
  //           this.jsonData = {};
  //           this.jsonDataForGrid = [];
  //           temJsonData['sidecut'][keys[i]] = clubResult;
  //           tempJsonDataForGrid['sidecut'][keys[i]] = clubResult;
  //           setTimeout(()=>{
  //             this.jsonData = JSON.parse(JSON.stringify(temJsonData));
  //             this.jsonDataForGrid = JSON.parse(JSON.stringify(tempJsonDataForGrid));
  //             setTimeout(()=>{
  //               this.parseResultToGridJson();
  //               this.assignLength();
  //             }, 200);
  //           })
  //           this.close();
  //         } else {
  //           this.notifier.notify('error', 'Something went wrong');
  //         }
  //       }
  //     )
  // }

  clubTable(body,clubFormData,tableId){
    // this.lastRequest["club"] = {}
    this.lastRequest["club"] = (this.lastRequest && this.lastRequest["club"]) ? this.lastRequest["club"] : {};
    // this.mainClubReq[body['data']['key']] = clubFormData;
    this.clubbedOptions = {column:[],rows:{}}
    Object.keys(this.mainClubReq).forEach(cut =>{
      this.mainClubReq[cut].columns.forEach(col => {
        col.values.forEach(val => {
            if (val.values_merged && val.values_merged.length>0 && Object.keys(val.values_merged[0])  && Object.keys(val.values_merged[0]).length>0) {
              val.values_merged.forEach(option => {
                let isDublicate = this.clubbedOptions['column'].find(item => {return (item.name == option.name && item.parent == option.parent)})
                if (!(isDublicate && isDublicate.name)) {
                  this.clubbedOptions['column'].push(option)
                }
              });
            }
        });
      });
      this.mainClubReq[cut].rows.forEach(row => {
        row.values.forEach(val => {
            if (val.values_merged && val.values_merged.length>0 && Object.keys(val.values_merged[0])  && Object.keys(val.values_merged[0]).length>0) {
              this.clubbedOptions['rows'][cut]=[]
              val.values_merged.forEach(option => {
                this.clubbedOptions['rows'][cut].push(option)
              });
            }
        });
      }); 
    })
    // this.lastRequest["club"] = JSON.parse(JSON.stringify(this.mainClubReq));
    // this.lastRequest["club"][body["data"]["data"]["key"]]["data"] = {};
    // this.lastRequest["club"][body["data"]["data"]["key"]]["data"] = body["data"]["data"];
    let clubData = JSON.parse(JSON.stringify(body["data"]['clubData'])); 
    body = this.getClubReqJSON(tableId);
    body["data"]['clubData'] = clubData;
    
    // console.log("this.jsonData ====> ",this.jsonData["sidecut"][tableId]["defination_table"])
    // console.log("getDataReqOfTable ====> ",getDataReqOfTable)
    this.lastRequest["club"][tableId] = {};
    this.lastRequest["club"][tableId] = JSON.parse(JSON.stringify(body));
    delete this.lastRequest["club"][tableId]["data"]['request'];


    // this.lastRequest["club"][body["data"]["data"]["key"]] = {};
    // this.lastRequest["club"][body["data"]["data"]["key"]] = body;

    // console.log("this.mainClubReq",this.mainClubReq)
    // console.log("clubReq",body)
    // console.log("this.lastRequest",this.lastRequest)
    this.clubData(body)
    .then(
      result =>{
        if (result['status'] == 1) {
          // let clubResult = result['data']['data']['sidecut'][this.selectedCut.key];
          let clubResult = result['data']['data']['key'] == this.selectedCut.key ? result['data']['data']['value'] :{};
          clubResult['clubFormData'] = clubFormData;
          // console.log("clubResult ====> ",clubResult)
          let temJsonData = JSON.parse(JSON.stringify(this.jsonData));
          let tempJsonDataForGrid = JSON.parse(JSON.stringify(this.jsonDataForGrid));
          this.jsonData = {};
          this.jsonDataForGrid = [];
          temJsonData['sidecut'][this.selectedCut.key] = clubResult;
          tempJsonDataForGrid['sidecut'][this.selectedCut.key] = clubResult;
          // console.log("tempJsonDataForGrid ====> ",tempJsonDataForGrid)
          setTimeout(()=>{
            this.jsonData = JSON.parse(JSON.stringify(temJsonData));
            this.jsonDataForGrid = JSON.parse(JSON.stringify(tempJsonDataForGrid));
            // console.log("jsonDataForGrid 11 ====> ",this.jsonDataForGrid)

            setTimeout(()=>{
              // this.parseSidecutToGridJson(this.selectedCut.key);
              this.generateAgGridDataBlueprint(this.selectedCut.key)
              // this.parseResultToGridJson();
              this.assignLength();
            }, 200);
          })
          this.close();
        }else{
          this.notifier.notify('error','Something went wrong');
        }
      }
    )
  }

  getClubReqJSON(tableId){
    let body = {"data":{}}
    let getDataReqOfTable = JSON.parse(JSON.stringify(this.lastRequest["getData"]));
    let allowedTopcutId = [];
    let allowedTopcuts = [];
    // Object.keys(getDataReqOfTable['data'][this.fileUUID]["sidecut"]).forEach(sidecutKey => {
    //   if (tableId == sidecutKey) {
    //     allowedTopcutId = getDataReqOfTable['data'][this.fileUUID]["sidecut"][sidecutKey]["allowed_topcuts"]
    //   }else{
    //     delete getDataReqOfTable['data'][this.fileUUID]["sidecut"][sidecutKey]

    //   }
    // });

    getDataReqOfTable['data'][this.fileUUID]["sidecut"] = {};
    getDataReqOfTable['data'][this.fileUUID]["sidecut"][tableId] = {};
    getDataReqOfTable['data'][this.fileUUID]["sidecut"][tableId] = this.lastRequest["getData"]['data'][this.fileUUID]["sidecut"][tableId];
    allowedTopcutId = getDataReqOfTable['data'][this.fileUUID]["sidecut"][tableId]["allowed_topcuts"];
    getDataReqOfTable['data'][this.fileUUID]["topcut"].forEach((topcut, index) => {
      if (allowedTopcutId.includes(Number(topcut.id))) {
        allowedTopcuts.push(topcut);
      }
    });
    getDataReqOfTable['data'][this.fileUUID]["topcut"] = allowedTopcuts;
    // if (getDataReqOfTable.trendAnalysis) {
    //   body["data"]['defination_table'] = this.jsonData["sidecut"][tableId]["defination_table"];
    // }
    body["data"]['defination_table'] = this.jsonData["sidecut"][tableId]["defination_table"];
    body["data"]["request"] = JSON.parse(JSON.stringify(this.lastRequest));
    // body["data"]["request"] = {"getData":{}}
    delete body["data"]["request"]['club']
    body["data"]["request"]['getData'] = getDataReqOfTable;
    body["data"]['fileUUID'] = this.fileUUID;
    body["data"]['key'] = tableId;
    return body 
  }

  clubData(body){
    // console.log("this.last 11111", this.lastRequest)
    return this.apiRequest.request('POST','/v2/tableextraction/getclubData',body).toPromise();
    // return this.http.post(environment.apiUrl + '/v2/tableextraction/getclubData', body, this.httpPostOptions).toPromise();
  }

  backgroundBlurredImage(img) {
    return {
      "background-image": `url(${img})`
    }
  }


  getFileTypeArr(Var: any) {
    return Var.map(ob => {

      if (ob.file_type == 'Data Table - ABS') {
        return 'dataTable-abs';
      }
      else if (ob.file_type == 'Data Table - PCT') {
        return 'dataTable-pct';
      } else if (ob.file_type == 'Report - KPI View') {
        return 'kpiViewer';
      }
      else {
        return ob.file_type.toLowerCase();
      }
    });
  }

  submitRequestEmail(uuid) {
    if (this.sharingEmails.length == 0) {
      this.notify.notify('error', 'Please select at least one email')
    }
    else if (!this.inviteEmailMessage) {
      this.notify.notify('error', 'Please fill message field')
    }
    else {
      let body = {};
      body['uuid'] = uuid;
      body['message'] = this.inviteEmailMessage;
      body['emails'] = this.sharingEmails;
      this.inviteMultipleEmail(body).subscribe((result) => {
        if (result['status'] == 1) {
          this.notify.notify('success', 'Request sent to all emails successfully');
          if (this.isFullFileUploadComponent == 'create') {
            this.isInviteFileRequested = true;
            if (this.addStudySubmitProgress == 'request') {
              this.notify.notify('success', 'Study successfully created');
              this.close();
            }
            else this.addStudySubmitProgress = 'upload';
          }
        }
        else {
          this.notify.notify('error', 'Something went wrong, Invite failed');
        }
      }, error => {
        this.notify.notify('error', 'Something went wrong, Invite failed')
      });
      this.isRequestFile = false;
      this.sharingEmails = [];
    }
  }

  checkUploadFile() {
    if (this.MatSelectFileArray[0].file_type != "") return true;
    return false;
  }

  checkRequestFile() {
    if (this.sharingEmails.length != 0 || this.inviteEmailMessage != "") return true;
    return false;
  }

  // validateUploadFileSize(files){

  // }
  initSummary(){
    this.studySummaryInnerHtml=`<body>
    <h2>Key Themes:</h2>
    <ul>
    <li><strong>Education and Work Experience:</strong> The interviewee is currently studying and also working as an intern in a biotech company. This shows a blend of academic knowledge and practical work experience in the biotech field.</li>
    </ul>
     
    <h2>Actionable Insights:</h2>
    <ul>
    <li><strong>Target Audience:</strong> The brand or product being discussed could focus on appealing to young professionals who are both studying and working in the biotech industry, as they represent a potential customer base or talent pool.</li>
    <li><strong>Internship Programs:</strong> Given that the interviewee is an intern, the company could consider developing or enhancing internship programs to attract and nurture talent in the biotech field.</li>
    <li><strong>Professional Development:</strong> Offering opportunities for professional development and career growth could be a selling point for the brand or product, as it would appeal to individuals like the interviewee who are in the early stages of their career in biotech.</li>
    </ul>
    </body>
     `;

     this.initSummaryCustomCSS()
   }

  initEXTtoMIME() {
    let extToMIME = [[".webm", "video/webm"],[".323", "text/h323"], [".3g2", "video/3gpp2"], [".3gp", "video/3gpp"], [".3gp2", "video/3gpp2"], [".3gpp", "video/3gpp"], [".7z", "application/x-7z-compressed"], [".aa", "audio/audible"], [".AAC", "audio/aac"], [".aaf", "application/octet-stream"], [".aax", "audio/vnd.audible.aax"], [".ac3", "audio/ac3"], [".aca", "application/octet-stream"], [".accda", "application/msaccess.addin"], [".accdb", "application/msaccess"], [".accdc", "application/msaccess.cab"], [".accde", "application/msaccess"], [".accdr", "application/msaccess.runtime"], [".accdt", "application/msaccess"], [".accdw", "application/msaccess.webapplication"], [".accft", "application/msaccess.ftemplate"], [".acx", "application/internet-property-stream"], [".AddIn", "text/xml"], [".ade", "application/msaccess"], [".adobebridge", "application/x-bridge-url"], [".adp", "application/msaccess"], [".ADT", "audio/vnd.dlna.adts"], [".ADTS", "audio/aac"], [".afm", "application/octet-stream"], [".ai", "application/postscript"], [".aif", "audio/x-aiff"], [".aifc", "audio/aiff"], [".aiff", "audio/aiff"], [".air", "application/vnd.adobe.air-application-installer-package+zip"], [".amc", "application/x-mpeg"], [".application", "application/x-ms-application"], [".art", "image/x-jg"], [".asa", "application/xml"], [".asax", "application/xml"], [".ascx", "application/xml"], [".asd", "application/octet-stream"], [".asf", "video/x-ms-asf"], [".ashx", "application/xml"], [".asi", "application/octet-stream"], [".asm", "text/plain"], [".asmx", "application/xml"], [".aspx", "application/xml"], [".asr", "video/x-ms-asf"], [".asx", "video/x-ms-asf"], [".atom", "application/atom+xml"], [".au", "audio/basic"], [".avi", "video/x-msvideo"], [".axs", "application/olescript"], [".bas", "text/plain"], [".bcpio", "application/x-bcpio"], [".bin", "application/octet-stream"], [".bmp", "image/bmp"], [".c", "text/plain"], [".cab", "application/octet-stream"], [".caf", "audio/x-caf"], [".calx", "application/vnd.ms-office.calx"], [".cat", "application/vnd.ms-pki.seccat"], [".cc", "text/plain"], [".cd", "text/plain"], [".cdda", "audio/aiff"], [".cdf", "application/x-cdf"], [".cer", "application/x-x509-ca-cert"], [".chm", "application/octet-stream"], [".class", "application/x-java-applet"], [".clp", "application/x-msclip"], [".cmx", "image/x-cmx"], [".cnf", "text/plain"], [".cod", "image/cis-cod"], [".config", "application/xml"], [".contact", "text/x-ms-contact"], [".coverage", "application/xml"], [".cpio", "application/x-cpio"], [".cpp", "text/plain"], [".crd", "application/x-mscardfile"], [".crl", "application/pkix-crl"], [".crt", "application/x-x509-ca-cert"], [".cs", "text/plain"], [".csdproj", "text/plain"], [".csh", "application/x-csh"], [".csproj", "text/plain"], [".css", "text/css"], [".csv", "text/csv"], [".cur", "application/octet-stream"], [".cxx", "text/plain"], [".dat", "application/octet-stream"], [".datasource", "application/xml"], [".dbproj", "text/plain"], [".dcr", "application/x-director"], [".def", "text/plain"], [".deploy", "application/octet-stream"], [".der", "application/x-x509-ca-cert"], [".dgml", "application/xml"], [".dib", "image/bmp"], [".dif", "video/x-dv"], [".dir", "application/x-director"], [".disco", "text/xml"], [".dll", "application/x-msdownload"], [".dll.config", "text/xml"], [".dlm", "text/dlm"], [".doc", "application/msword"], [".docm", "application/vnd.ms-word.document.macroEnabled.12"], [".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"], [".dot", "application/msword"], [".dotm", "application/vnd.ms-word.template.macroEnabled.12"], [".dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"], [".dsp", "application/octet-stream"], [".dsw", "text/plain"], [".dtd", "text/xml"], [".dtsConfig", "text/xml"], [".dv", "video/x-dv"], [".dvi", "application/x-dvi"], [".dwf", "drawing/x-dwf"], [".dwp", "application/octet-stream"], [".dxr", "application/x-director"], [".eml", "message/rfc822"], [".emz", "application/octet-stream"], [".eot", "application/octet-stream"], [".eps", "application/postscript"], [".etl", "application/etl"], [".etx", "text/x-setext"], [".evy", "application/envoy"], [".exe", "application/octet-stream"], [".exe.config", "text/xml"], [".fdf", "application/vnd.fdf"], [".fif", "application/fractals"], [".filters", "Application/xml"], [".fla", "application/octet-stream"], [".flr", "x-world/x-vrml"], [".flv", "video/x-flv"], [".fsscript", "application/fsharp-script"], [".fsx", "application/fsharp-script"], [".generictest", "application/xml"], [".gif", "image/gif"], [".group", "text/x-ms-group"], [".gsm", "audio/x-gsm"], [".gtar", "application/x-gtar"], [".gz", "application/x-gzip"], [".h", "text/plain"], [".hdf", "application/x-hdf"], [".hdml", "text/x-hdml"], [".hhc", "application/x-oleobject"], [".hhk", "application/octet-stream"], [".hhp", "application/octet-stream"], [".hlp", "application/winhlp"], [".hpp", "text/plain"], [".hqx", "application/mac-binhex40"], [".hta", "application/hta"], [".htc", "text/x-component"], [".htm", "text/html"], [".html", "text/html"], [".htt", "text/webviewhtml"], [".hxa", "application/xml"], [".hxc", "application/xml"], [".hxd", "application/octet-stream"], [".hxe", "application/xml"], [".hxf", "application/xml"], [".hxh", "application/octet-stream"], [".hxi", "application/octet-stream"], [".hxk", "application/xml"], [".hxq", "application/octet-stream"], [".hxr", "application/octet-stream"], [".hxs", "application/octet-stream"], [".hxt", "text/html"], [".hxv", "application/xml"], [".hxw", "application/octet-stream"], [".hxx", "text/plain"], [".i", "text/plain"], [".ico", "image/x-icon"], [".ics", "application/octet-stream"], [".idl", "text/plain"], [".ief", "image/ief"], [".iii", "application/x-iphone"], [".inc", "text/plain"], [".inf", "application/octet-stream"], [".inl", "text/plain"], [".ins", "application/x-internet-signup"], [".ipa", "application/x-itunes-ipa"], [".ipg", "application/x-itunes-ipg"], [".ipproj", "text/plain"], [".ipsw", "application/x-itunes-ipsw"], [".iqy", "text/x-ms-iqy"], [".isp", "application/x-internet-signup"], [".ite", "application/x-itunes-ite"], [".itlp", "application/x-itunes-itlp"], [".itms", "application/x-itunes-itms"], [".itpc", "application/x-itunes-itpc"], [".IVF", "video/x-ivf"], [".jar", "application/java-archive"], [".java", "application/octet-stream"], [".jck", "application/liquidmotion"], [".jcz", "application/liquidmotion"], [".jfif", "image/pjpeg"], [".jnlp", "application/x-java-jnlp-file"], [".jpb", "application/octet-stream"], [".jpe", "image/jpeg"], [".jpeg", "image/jpeg"], [".jpg", "image/jpeg"], [".js", "application/x-javascript"], [".json", "application/json"], [".jsx", "text/jscript"], [".jsxbin", "text/plain"], [".latex", "application/x-latex"], [".library-ms", "application/windows-library+xml"], [".lit", "application/x-ms-reader"], [".loadtest", "application/xml"], [".lpk", "application/octet-stream"], [".lsf", "video/x-la-asf"], [".lst", "text/plain"], [".lsx", "video/x-la-asf"], [".lzh", "application/octet-stream"], [".m13", "application/x-msmediaview"], [".m14", "application/x-msmediaview"], [".m1v", "video/mpeg"], [".m2t", "video/vnd.dlna.mpeg-tts"], [".m2ts", "video/vnd.dlna.mpeg-tts"], [".m2v", "video/mpeg"], [".m3u", "audio/x-mpegurl"], [".m3u8", "audio/x-mpegurl"], [".m4a", "audio/m4a"], [".m4b", "audio/m4b"], [".m4p", "audio/m4p"], [".m4r", "audio/x-m4r"], [".m4v", "video/x-m4v"], [".mac", "image/x-macpaint"], [".mak", "text/plain"], [".man", "application/x-troff-man"], [".manifest", "application/x-ms-manifest"], [".map", "text/plain"], [".master", "application/xml"], [".mda", "application/msaccess"], [".mdb", "application/x-msaccess"], [".mde", "application/msaccess"], [".mdp", "application/octet-stream"], [".me", "application/x-troff-me"], [".mfp", "application/x-shockwave-flash"], [".mht", "message/rfc822"], [".mhtml", "message/rfc822"], [".mid", "audio/mid"], [".midi", "audio/mid"], [".mix", "application/octet-stream"], [".mk", "text/plain"], [".mmf", "application/x-smaf"], [".mno", "text/xml"], [".mny", "application/x-msmoney"], [".mod", "video/mpeg"], [".mov", "video/quicktime"], [".movie", "video/x-sgi-movie"], [".mp2", "video/mpeg"], [".mp2v", "video/mpeg"], [".mp3", "audio/mpeg"], [".mp4", "video/mp4"], [".MP4", "video/MP4"], [".mp4v", "video/mp4"], [".mpa", "video/mpeg"], [".mpe", "video/mpeg"], [".mpeg", "video/mpeg"], [".mpf", "application/vnd.ms-mediapackage"], [".mpg", "video/mpeg"], [".mpp", "application/vnd.ms-project"], [".mpv2", "video/mpeg"], [".mqv", "video/quicktime"], [".ms", "application/x-troff-ms"], [".msi", "application/octet-stream"], [".mso", "application/octet-stream"], [".mts", "video/vnd.dlna.mpeg-tts"], [".mtx", "application/xml"], [".mvb", "application/x-msmediaview"], [".mvc", "application/x-miva-compiled"], [".mxp", "application/x-mmxp"], [".nc", "application/x-netcdf"], [".nsc", "video/x-ms-asf"], [".nws", "message/rfc822"], [".ocx", "application/octet-stream"], [".oda", "application/oda"], [".odc", "text/x-ms-odc"], [".odh", "text/plain"], [".odl", "text/plain"], [".odp", "application/vnd.oasis.opendocument.presentation"], [".ods", "application/oleobject"], [".odt", "application/vnd.oasis.opendocument.text"], [".one", "application/onenote"], [".onea", "application/onenote"], [".onepkg", "application/onenote"], [".onetmp", "application/onenote"], [".onetoc", "application/onenote"], [".onetoc2", "application/onenote"], [".orderedtest", "application/xml"], [".osdx", "application/opensearchdescription+xml"], [".p10", "application/pkcs10"], [".p12", "application/x-pkcs12"], [".p7b", "application/x-pkcs7-certificates"], [".p7c", "application/pkcs7-mime"], [".p7m", "application/pkcs7-mime"], [".p7r", "application/x-pkcs7-certreqresp"], [".p7s", "application/pkcs7-signature"], [".pbm", "image/x-portable-bitmap"], [".pcast", "application/x-podcast"], [".pct", "image/pict"], [".pcx", "application/octet-stream"], [".pcz", "application/octet-stream"], [".pdf", "application/pdf"], [".pfb", "application/octet-stream"], [".pfm", "application/octet-stream"], [".pfx", "application/x-pkcs12"], [".pgm", "image/x-portable-graymap"], [".pic", "image/pict"], [".pict", "image/pict"], [".pkgdef", "text/plain"], [".pkgundef", "text/plain"], [".pko", "application/vnd.ms-pki.pko"], [".pls", "audio/scpls"], [".pma", "application/x-perfmon"], [".pmc", "application/x-perfmon"], [".pml", "application/x-perfmon"], [".pmr", "application/x-perfmon"], [".pmw", "application/x-perfmon"], [".png", "image/png"], [".pnm", "image/x-portable-anymap"], [".pnt", "image/x-macpaint"], [".pntg", "image/x-macpaint"], [".pnz", "image/png"], [".pot", "application/vnd.ms-powerpoint"], [".potm", "application/vnd.ms-powerpoint.template.macroEnabled.12"], [".potx", "application/vnd.openxmlformats-officedocument.presentationml.template"], [".ppa", "application/vnd.ms-powerpoint"], [".ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"], [".ppm", "image/x-portable-pixmap"], [".pps", "application/vnd.ms-powerpoint"], [".ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"], [".ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"], [".ppt", "application/vnd.ms-powerpoint"], [".pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"], [".pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"], [".prf", "application/pics-rules"], [".prm", "application/octet-stream"], [".prx", "application/octet-stream"], [".ps", "application/postscript"], [".psc1", "application/PowerShell"], [".psd", "application/octet-stream"], [".psess", "application/xml"], [".psm", "application/octet-stream"], [".psp", "application/octet-stream"], [".pub", "application/x-mspublisher"], [".pwz", "application/vnd.ms-powerpoint"], [".qht", "text/x-html-insertion"], [".qhtm", "text/x-html-insertion"], [".qt", "video/quicktime"], [".qti", "image/x-quicktime"], [".qtif", "image/x-quicktime"], [".qtl", "application/x-quicktimeplayer"], [".qxd", "application/octet-stream"], [".ra", "audio/x-pn-realaudio"], [".ram", "audio/x-pn-realaudio"], [".rar", "application/octet-stream"], [".ras", "image/x-cmu-raster"], [".rat", "application/rat-file"], [".rc", "text/plain"], [".rc2", "text/plain"], [".rct", "text/plain"], [".rdlc", "application/xml"], [".resx", "application/xml"], [".rf", "image/vnd.rn-realflash"], [".rgb", "image/x-rgb"], [".rgs", "text/plain"], [".rm", "application/vnd.rn-realmedia"], [".rmi", "audio/mid"], [".rmp", "application/vnd.rn-rn_music_package"], [".roff", "application/x-troff"], [".rpm", "audio/x-pn-realaudio-plugin"], [".rqy", "text/x-ms-rqy"], [".rtf", "application/rtf"], [".rtx", "text/richtext"], [".ruleset", "application/xml"], [".s", "text/plain"], [".safariextz", "application/x-safari-safariextz"], [".scd", "application/x-msschedule"], [".sct", "text/scriptlet"], [".sd2", "audio/x-sd2"], [".sdp", "application/sdp"], [".sea", "application/octet-stream"], [".searchConnector-ms", "application/windows-search-connector+xml"], [".setpay", "application/set-payment-initiation"], [".setreg", "application/set-registration-initiation"], [".settings", "application/xml"], [".sgimb", "application/x-sgimb"], [".sgml", "text/sgml"], [".sh", "application/x-sh"], [".shar", "application/x-shar"], [".shtml", "text/html"], [".sit", "application/x-stuffit"], [".sitemap", "application/xml"], [".skin", "application/xml"], [".sldm", "application/vnd.ms-powerpoint.slide.macroEnabled.12"], [".sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"], [".slk", "application/vnd.ms-excel"], [".sln", "text/plain"], [".slupkg-ms", "application/x-ms-license"], [".smd", "audio/x-smd"], [".smi", "application/octet-stream"], [".smx", "audio/x-smd"], [".smz", "audio/x-smd"], [".snd", "audio/basic"], [".snippet", "application/xml"], [".snp", "application/octet-stream"], [".sol", "text/plain"], [".sor", "text/plain"], [".spc", "application/x-pkcs7-certificates"], [".spl", "application/futuresplash"], [".src", "application/x-wais-source"], [".srf", "text/plain"], [".SSISDeploymentManifest", "text/xml"], [".ssm", "application/streamingmedia"], [".sst", "application/vnd.ms-pki.certstore"], [".stl", "application/vnd.ms-pki.stl"], [".sv4cpio", "application/x-sv4cpio"], [".sv4crc", "application/x-sv4crc"], [".swf", "application/x-shockwave-flash"], [".t", "application/x-troff"], [".tar", "application/x-tar"], [".tcl", "application/x-tcl"], [".testrunconfig", "application/xml"], [".testsettings", "application/xml"], [".tex", "application/x-tex"], [".texi", "application/x-texinfo"], [".texinfo", "application/x-texinfo"], [".tgz", "application/x-compressed"], [".thmx", "application/vnd.ms-officetheme"], [".thn", "application/octet-stream"], [".tif", "image/tiff"], [".tiff", "image/tiff"], [".tlh", "text/plain"], [".tli", "text/plain"], [".toc", "application/octet-stream"], [".tr", "application/x-troff"], [".trm", "application/x-msterminal"], [".trx", "application/xml"], [".ts", "video/vnd.dlna.mpeg-tts"], [".tsv", "text/tab-separated-values"], [".ttf", "application/octet-stream"], [".tts", "video/vnd.dlna.mpeg-tts"], [".txt", "text/plain"], [".u32", "application/octet-stream"], [".uls", "text/iuls"], [".user", "text/plain"], [".ustar", "application/x-ustar"], [".vb", "text/plain"], [".vbdproj", "text/plain"], [".vbk", "video/mpeg"], [".vbproj", "text/plain"], [".vbs", "text/vbscript"], [".vcf", "text/x-vcard"], [".vcproj", "Application/xml"], [".vcs", "text/plain"], [".vcxproj", "Application/xml"], [".vddproj", "text/plain"], [".vdp", "text/plain"], [".vdproj", "text/plain"], [".vdx", "application/vnd.ms-visio.viewer"], [".vml", "text/xml"], [".vscontent", "application/xml"], [".vsct", "text/xml"], [".vsd", "application/vnd.visio"], [".vsi", "application/ms-vsi"], [".vsix", "application/vsix"], [".vsixlangpack", "text/xml"], [".vsixmanifest", "text/xml"], [".vsmdi", "application/xml"], [".vspscc", "text/plain"], [".vss", "application/vnd.visio"], [".vsscc", "text/plain"], [".vssettings", "text/xml"], [".vssscc", "text/plain"], [".vst", "application/vnd.visio"], [".vstemplate", "text/xml"], [".vsto", "application/x-ms-vsto"], [".vsw", "application/vnd.visio"], [".vsx", "application/vnd.visio"], [".vtx", "application/vnd.visio"], [".wav", "audio/wav"], [".wave", "audio/wav"], [".wax", "audio/x-ms-wax"], [".wbk", "application/msword"], [".wbmp", "image/vnd.wap.wbmp"], [".wcm", "application/vnd.ms-works"], [".wdb", "application/vnd.ms-works"], [".wdp", "image/vnd.ms-photo"], [".webarchive", "application/x-safari-webarchive"], [".webtest", "application/xml"], [".wiq", "application/xml"], [".wiz", "application/msword"], [".wks", "application/vnd.ms-works"], [".WLMP", "application/wlmoviemaker"], [".wlpginstall", "application/x-wlpg-detect"], [".wlpginstall3", "application/x-wlpg3-detect"], [".wm", "video/x-ms-wm"], [".wma", "audio/x-ms-wma"], [".wmd", "application/x-ms-wmd"], [".wmf", "application/x-msmetafile"], [".wml", "text/vnd.wap.wml"], [".wmlc", "application/vnd.wap.wmlc"], [".wmls", "text/vnd.wap.wmlscript"], [".wmlsc", "application/vnd.wap.wmlscriptc"], [".wmp", "video/x-ms-wmp"], [".wmv", "video/x-ms-wmv"], [".wmx", "video/x-ms-wmx"], [".wmz", "application/x-ms-wmz"], [".wpl", "application/vnd.ms-wpl"], [".wps", "application/vnd.ms-works"], [".wri", "application/x-mswrite"], [".wrl", "x-world/x-vrml"], [".wrz", "x-world/x-vrml"], [".wsc", "text/scriptlet"], [".wsdl", "text/xml"], [".wvx", "video/x-ms-wvx"], [".x", "application/directx"], [".xaf", "x-world/x-vrml"], [".xaml", "application/xaml+xml"], [".xap", "application/x-silverlight-app"], [".xbap", "application/x-ms-xbap"], [".xbm", "image/x-xbitmap"], [".xdr", "text/plain"], [".xht", "application/xhtml+xml"], [".xhtml", "application/xhtml+xml"], [".xla", "application/vnd.ms-excel"], [".xlam", "application/vnd.ms-excel.addin.macroEnabled.12"], [".xlc", "application/vnd.ms-excel"], [".xld", "application/vnd.ms-excel"], [".xlk", "application/vnd.ms-excel"], [".xll", "application/vnd.ms-excel"], [".xlm", "application/vnd.ms-excel"], [".xls", "application/vnd.ms-excel"], [".xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"], [".xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"], [".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"], [".xlt", "application/vnd.ms-excel"], [".xltm", "application/vnd.ms-excel.template.macroEnabled.12"], [".xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"], [".xlw", "application/vnd.ms-excel"], [".xml", "text/xml"], [".xmta", "application/xml"], [".xof", "x-world/x-vrml"], [".XOML", "text/plain"], [".xpm", "image/x-xpixmap"], [".xps", "application/vnd.ms-xpsdocument"], [".xrm-ms", "text/xml"], [".xsc", "application/xml"], [".xsd", "text/xml"], [".xsf", "text/xml"], [".xsl", "text/xml"], [".xslt", "text/xml"], [".xsn", "application/octet-stream"], [".xss", "application/xml"], [".xtp", "application/octet-stream"], [".xwd", "image/x-xwindowdump"], [".z", "application/x-compress"], [".zip", "application/x-zip-compressed"]];
    return extToMIME;
  }

  getVideoAnalyzerUUID(){
    
    this.getVideoAccessToken().subscribe((result) =>
    {
      this.videoTokenDetails = result;
      // console.log("videoTokenDetails ====> ",this.videoTokenDetails)
      // this.videoTokenDetails['playerUrl'] = this.trustedUrlMakers(`https://www.videoindexer.ai/embed/player/${this.videoTokenDetails['account_id']}/${this.videoTokenDetails['video_id']}/?autoplay=false&accessToken=${this.videoTokenDetails['access_token']}&location=${this.videoTokenDetails['zone']}&language=en-US`)
      // this.videoTokenDetails['insightUrl'] = this.trustedUrlMakers(`https://www.videoindexer.ai/embed/insights/${this.videoTokenDetails['account_id']}/${this.videoTokenDetails['video_id']}/?preset=all&accessToken=${this.videoTokenDetails['access_token']}&location=${this.videoTokenDetails['zone']}&language=en-US`);
      this.videoTokenDetails['playerUrl'] = this.trustedUrlMakers(this.videoTokenDetails.player_link)
      this.videoTokenDetails['insightUrl'] = this.trustedUrlMakers(this.videoTokenDetails.indexer_link);
      this.isInvalidTranscript = this.videoTokenDetails['invalid_transcript'] ? true : false
      this.summaryInnerHtml= this.isInvalidTranscript ? '' : this.videoTokenDetails['summary'];
      // this.summaryInnerHtml=this.videoTokenDetails['summary'];
      this.initSummaryCustomCSS();
      
    })
  }

  trustedUrlMakers = (video: string) => {
    return this.sanitizer.bypassSecurityTrustResourceUrl(video)
  }
  deleteFile(data){
    return this.apiRequest.request('POST','/v2/repo/deleteFiles',data);
    // return this.http.post(environment.apiUrl + '/v2/repo/deleteFiles', data, this.httpPostOptions);
  }
  openExternalFileUpload(data){
    return this.apiRequest.request('POST','/v2/repo/getUploadedFiles',data);
    // return this.http.post(environment.apiUrl + '/v2/repo/getUploadedFiles', data, this.httpPostOptions);
  }

  getRepositoryDetail(uuid,option?:any){
    this.isLoading = true;
    this.iService.VOCList = null;
    let query = option ? option : null
    this.getRepositoryDetails(uuid,query).subscribe(result => {
      if (result[0].status == 1) {
        this.studyId = result[0].study_id
        // localStorage.setItem('studyId',this.studyId);
        sessionStorage.setItem('studyId',this.studyId);
        this.reportDetails = result[0].result;
        if (this.reportDetails['study_summary'] && this.reportDetails['study_summary'].groups && this.reportDetails['study_summary'].groups.length) {
          let pinnedSummaryGroup = this.reportDetails['study_summary'].groups.find((group) => { return group.pin == true});
          if (pinnedSummaryGroup && pinnedSummaryGroup.summary) {
            this.reportDetails['study_summary']["summary"] = pinnedSummaryGroup.summary;
          }else{
            this.reportDetails['study_summary']["summary"] = this.reportDetails['study_summary'].groups[0].summary
            this.reportDetails['study_summary'].groups[0].pin = true;
          }
          // this.reportDetails['study_summary']["summary"] = pinnedSummaryGroup && pinnedSummaryGroup.summary ? pinnedSummaryGroup.summary : this.reportDetails['study_summary'].groups[0].summary;
        }else{
          // this.reportDetails['study_summary']["status"] = 1;
          this.reportDetails['study_summary']["summary"] = '';
        }
        // used in group summary component to show the group list 
        // this.allGroupList = (this.reportDetails["study_summary"] && this.reportDetails["study_summary"].groups && this.reportDetails["study_summary"].groups.length) ? this.reportDetails["study_summary"].groups : [];
        // this.groupList = JSON.parse(JSON.stringify(this.allGroupList));

        this.researchDetails = result[0].research_details;
        this.SigTestStudyLevelAccess = this.reportDetails['showSign'];
        // console.log(this.SigTestStudyLevelAccess,this.reportDetails['showSign'],'Acces Sign');
        this.checkStudySummaryVisibility(this.reportDetails);
        this.projectDetails = result[0].project_details;
   
        // if (this.projectDetails && this.projectDetails.is_dashboard) {
        //   this.projectDetails['show_dashboard'] = true;
        // }
        if(result[0]['result']['call_recording']){
          this.callRecordingApiSurveyId = result[0]['result']['api_survey_id'];
          this.isCallRecording = true;
          this.callRecordingDataContainer = result[0]['result']['call_recording'];
          this.callDispositionContainer = result[0]['result']['call_Desposition'];

          localStorage.setItem('api_survey_id',result[0]['result']['api_survey_id']);
          localStorage.setItem('callRecordingUserContainer',JSON.stringify(this.callRecordingDataContainer));
          localStorage.setItem('callDispositionContainer',JSON.stringify(this.callDispositionContainer));

        }else{
          localStorage.removeItem('api_survey_id');
          localStorage.removeItem('callRecordingUserContainer');
          localStorage.removeItem('callDispositionContainer');
          
        }
        this.formatProjectDetailsObject(uuid);
        // if (this.reportDetails['files'] && this.reportDetails['files'].length > 0) {
        //   this.reportDetails['files'].map(file => {
        //     if (file['resource']) {
        //       let myString = file['resource'];
        //       const ext = myString.substring(myString.lastIndexOf(".") + 1);
        //       file['type'] = ext;
        //       file['uuid'] = uuid;
        //     }else if(file['file_type'] == "kpiViewer" && file['kpiViewerStatus'] == "complete"){
        //       file['type'] = "xlsx";
        //       file['uuid'] = uuid;
        //     }
        //     if (file['file_type']) {
        //       file['file_type'] = this.formatFileType(file['file_type']);
        //     }
        //   })
        //   localStorage.setItem('reportdetails : ',JSON.stringify(this.projectDetails))
        //   // this.sidePanelService.initSideDrawer('repo');

        //   // console.log(JSON.stringify(this.reportDetails))
        // }
        this.openSubSideDrower()
        // Only emit side drawer event if not already triggered for this UUID
        if (!this.initSidePanelTriggered || this.currentRepoUUID !== uuid) {
          this.currentRepoUUID = uuid;
          this.initSidePanelTriggered = true;
          this.initSideDrawerEvent.emit('repo');
        }
        

        this.setVOCDetails(result);
        this.setResearchDetails();
        this.setClubVocDetails(result[0].clubbed_files);
      }
      if(result[0]['status'] == 4){
        this.notifier.notify('error',result[0]['message']);
        this.redirectUnAuthorizedEvent.emit('unauthorized');
        // this.initSideDrawerEvent.emit('repo');
      }

      this.isLoading = false;
    },error=>{
      this.isLoading = false;
    });
  }

  checkStudySummaryVisibility(reportDetails){
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    // console.log("reportDetails.study_summary ===>",reportDetails.study_summary )
    if (reportDetails.study_summary && reportDetails.study_summary.status !=3  && reportDetails.study_summary.status !=0) {      
      this.studySummaryInnerHtml=reportDetails.study_summary.summary;
      this.isShowStudySummary = true
      this.initSummaryCustomCSS()
    }else{
      this.isShowStudySummary = false
    }
  }
  // getAllRepositoryFilesPagination(uuid,option?:any){
  //   this.isLoading = true;
  //   let query = option ? option : null
  //   this.getAllRepoFiles(uuid,query).subscribe(result => {
  //     if (result[0].status == 1) {
  //       let reportDetails = result[0].result;
  //       // this.ZipTranslationDownloadOptions = result[0].survey_images_report_map || [];
  //       if (reportDetails['files'] && reportDetails['files'].length > 0) {
  //         reportDetails['files'].map(file => {
  //           if (file['resource']) {
  //             let myString = file['resource'];
  //             const ext = myString.substring(myString.lastIndexOf(".") + 1);
  //             file['type'] = ext;
  //             file['uuid'] = uuid;
  //           }else if(file['file_type'] == "kpiViewer" && file['kpiViewerStatus'] == "complete"){
  //             file['type'] = "xlsx";
  //             file['uuid'] = uuid;
  //           }
  //           if (file['file_type']) {
  //             file['file_type'] = this.formatFileType(file['file_type']);
  //           }
  //         })
  //         if (option.page && option.page == 1) {
  //           // this.reportDetails['files'] = reportDetails['files'];
  //           this.allRepoFiles = reportDetails['files']
  //         }else{
  //           // this.reportDetails['files'] = [...this.reportDetails['files'],...reportDetails['files']]
  //           this.allRepoFiles = [...this.allRepoFiles,...reportDetails['files']]
  //         }
  //         console.log("this.allRepoFiles ====> ",this.allRepoFiles)
  //         this.isScroleComleted = false;
  //       }else{
  //         this.isScroleComleted = true;
  //         if (option.page && option.page == 1) {
  //           this.allRepoFiles = []
  //         }
  //       }
  
  //     }
  //     if(result[0]['status'] == 4){
  //       this.notifier.notify('error',result[0]['message']);
  //       this.redirectUnAuthorizedEvent.emit('unauthorized');
  //     }
  //     this.isLoading = false;
  //   },error=>{
  //     this.isLoading = false;
  //   });
  // }

  getAllRepositoryFilesPagination(option?:any){
        this.isLoading = true;
        this.getAllRepositoryFilesPaginationApi(option).subscribe(result => {
          if (result['status'] == 1) {
            this.total_data_in_list = result['total_files']; 
            result['data'].map(file => {
              if (file['resource']) {
                let myString = file['resource'];
                const ext = myString.substring(myString.lastIndexOf(".") + 1);
                file['type'] = ext;
              }else if(file['file_type'] == "kpiViewer" && file['kpiViewerStatus'] == "complete"){
                file['type'] = "xlsx";
              }
              if (file['file_type']) {
                file['file_type'] = this.formatFileType(file['file_type']);
              }
            })
            if (option.page && option.page == 1) {
              if(this.allSelectedFiles && this.allSelectedFiles.length > 0){
                // Create a Set of existing file UUIDs to avoid duplicates
                const existingUUIDs = new Set(this.allSelectedFiles.map(f => f.uuid || f.file_uuid));
                // Filter out files that already exist in allSelectedFiles
                const filteredData = result['data'].filter(file => !existingUUIDs.has(file.uuid || file.file_uuid));
                this.allRepoFiles = [...this.allSelectedFiles,...filteredData];
              }else{
                this.allRepoFiles = result['data']
              }
              if (result['data'] && result['data'].length > 0) {
                this.aFilterService.close()
              }
            }else{
              this.allRepoFiles = [...this.allRepoFiles,...result['data']]
            }
            if (result['data'].length == 0) {
              this.isScroleComleted = true;
            } else {
              this.isScroleComleted = false;
            }

            this.isLoading = false;
            // if(result['data'].length == 0){
            //   this.notifier.notify('warning','No files found');
            // }
          }
        }, error => {
          this.isLoading = false;
        });
  }

  getAllRepositoryFilesPaginationApi(data): Observable<any>{
    // let result = {
    //         "status": 1,
    //         "data": [
    //           {
    //             "name": "File 1",
    //             "type": "Video",
    //             "project_name": "project_1",
    //             "study_name": "study_1",
    //             "uuid": "c005dded-4647-47bd-b0a7-1e0bf0d47970"
    //           },
    //           {
    //             "name": "File 2",
    //             "type": "audio",
    //             "project_name": "project_2",
    //             "study_name": "study_2",
    //             "uuid": "cabf9592-51df-4ddd-9536-65289902e590"
    //           },
    //           {
    //             "name": "File 2",
    //             "type": "Data table",
    //             "project_name": "project_2",
    //             "study_name": "study_2",
    //             "uuid": "e1eef6fa-3ac6-4ab7-94b2-db30fc9c6622"
    //           }
    //         ],
    //         "total_result": 100,
    //         "showning_results": 80,
    //         "page_size": 20,
    //         "page": 1,
    //         "total_page": 5,
    //         "applied_filters": {},
    //         "advance_search": {}
    //       }
    //   return result;
    return this.apiRequest.request('POST','/v2/repo/getrepoallfiles',data);
  }



  getRepositoryFilesPagination(uuid,option?:any){
    this.isLoading = true;
    let query = option ? option : null
    this.getRepoFilesDetails(uuid,query).subscribe(result => {
      if (result[0].status == 1) {
        let reportDetails = result[0].result;
        this.ZipTranslationDownloadOptions = result[0].survey_images_report_map || [];
        if (reportDetails['files'] && reportDetails['files'].length > 0) {
          reportDetails['files'].map(file => {
            if (file['resource']) {
              let myString = file['resource'];
              const ext = myString.substring(myString.lastIndexOf(".") + 1);
              file['type'] = ext;
              file['uuid'] = uuid;
            }else if(file['file_type'] == "kpiViewer" && file['kpiViewerStatus'] == "complete"){
              file['type'] = "xlsx";
              file['uuid'] = uuid;
            }
            if (file['file_type']) {
              file['file_type'] = this.formatFileType(file['file_type']);
            }
          })
          if (option.page && option.page == 1) {
            // this.reportDetails['files'] = reportDetails['files'];
            this.reportDetailFiles = reportDetails['files']
          }else{
            // this.reportDetails['files'] = [...this.reportDetails['files'],...reportDetails['files']]
            this.reportDetailFiles = [...this.reportDetailFiles,...reportDetails['files']]
          }
          // console.log("this.reportDetailFiles ====> ",this.reportDetailFiles)
          this.isScroleComleted = false;
        }else{
          this.isScroleComleted = true;
          if (option.page && option.page == 1) {
            this.reportDetailFiles = []
          }
        }
  
      }
      if(result[0]['status'] == 4){
        this.notifier.notify('error',result[0]['message']);
        this.redirectUnAuthorizedEvent.emit('unauthorized');
      }

      this.isLoading = false;
    },error=>{
      this.isLoading = false;
    });
  }
  
  getRepositoryDetailByFile(uuid,option?:any){
    this.isLoading = true;
    this.iService.VOCList = null;
    this.getRepositoryDetailsByFile(uuid).subscribe(result=>{
      if (result[0].status == 1) {
        this.studyId = result[0].study_id
        this.reportDetails = result[0].result;
        this.researchDetails = result[0].research_details;
        this.projectDetails = result[0].project_details;
        // if (this.reportDetails && this.reportDetails.api_survey_id) {
        //   this.projectDetails['show_dashboard'] = true;
        // }
        this.formatProjectDetailsObject(uuid);
        this.checkStudySummaryVisibility(this.reportDetails);
        if(this.reportDetails['files'] && this.reportDetails['files'].length > 0){
          
          this.reportDetails['files'].map(file => {
            if (file['resource']) {
              let myString = file['resource'];
              const ext = myString.substring(myString.lastIndexOf(".") + 1);
              file['type'] = ext;
              file['uuid'] = uuid;
            }else if(file['file_type'] == "kpiViewer" && file['kpiViewerStatus'] == "complete"){
              file['type'] = "xlsx";
              file['uuid'] = uuid;
            }
            if(file['file_type']){
              file['file_type'] = this.formatFileType(file['file_type']);
            }
          })
          localStorage.setItem('reportdetails : ',JSON.stringify(this.projectDetails))
        }
        this.openSubSideDrower();
        // Only emit side drawer event if not already triggered for this UUID
        if (!this.initSidePanelTriggered || this.currentRepoUUID !== uuid) {
          this.currentRepoUUID = uuid;
          this.initSidePanelTriggered = true;
          this.initSideDrawerEvent.emit('repo');
        }
        let fileObj = this.reportDetails['files'].find((res) => res['file_uuid'] == uuid);
        let type = this.router.url.includes("qual") ? 'qual' : ''
        // this.viewFile(fileObj,type);
        let isCreateTopline = (option && option.createTopline) ? option.createTopline : false;
        if (!isCreateTopline) {
          this.viewFile(fileObj,type);
        }else{
          fileObj["crossTabId"] = option.crossTabId;
          this.emitFileDetails.emit(fileObj)
        }
      }
      if(result[0].status == 4){
        this.notifier.notify('error',result[0]['message']);
        this.redirectUnAuthorizedEvent.emit('unauthorized');
      }
      this.isLoading = false;
    },error=>{
      this.isLoading = false;
    });
  }

  openSubSideDrower(){
    if (!this.router.url.includes("excel-view")) {
      this.homeService.isOpen = true;
    }
  }

  resetSidePanelInitFlag(){
    this.initSidePanelTriggered = false;
    this.currentRepoUUID = '';
    this.lastInsightListFileUUID = '';
    this.lastFileURLUUID = '';
  }

  formatProjectDetailsObject(uuid) {
    this.projectDetails['studies'].forEach(study => {
      if(study['files'] && study['files'].length > 0){
        study['files'].map(file => {
          let myString = file['resource'];
          if(myString){
            const ext = myString.substring(myString.lastIndexOf(".") + 1);
            file['type'] = ext;
            file['uuid'] = uuid;
          }
          if(file['file_type']){
            file['file_type'] = this.formatFileType(file['file_type']);
          }else{
            file['file_type'] = "None";
          }
        })
      }
    });
  }

  setClubVocDetails(clubbed_files) {
    this.iService.VOCClubList = [];
    clubbed_files.forEach((club) => {
      club['isHoverd'] = false;
      // club['edit'] = true;
      if(this.isQual){
        club['isQual'] = true;
      }
      else{
        club['isQual'] = false;
      }
      club['media_type'] = 'video';
      this.iService.VOCClubList.push(club);
    })
  }

  setVOCDetails(result) {
    if (result[0].voc_files && result[0].voc_files.length > 0) {
      // this.iService.formatVOCsData(result[0].voc_files);
      this.formatVOCsData(result[0].voc_files, false);
      setTimeout(() => {
        // this.addFileCategoriesToVoc(this.reportDetails);
        this.addFileCategoriesToVoc(this.reportDetails,'study');
      },1000);
    }
    else{
      this.iService.VOCList=null;
      this.iService.vocStudyLevelArray = null;
    }
  }

  setResearchDetails() {
    if (this.researchDetails) {
      if (this.researchDetails.coverage_details && this.researchDetails.coverage_details.coverageData) {
        let coverageDataKeys = Object.keys(this.researchDetails.coverage_details.coverageData);
        if (coverageDataKeys.length > 0) {
          this.researchDetails.coverage_details.coverageDetailsLength = coverageDataKeys.length;
          this.researchDetails.coverage_details.headerKeys = Object.keys(this.researchDetails.coverage_details.coverageData[coverageDataKeys[0]]);
          if (this.researchDetails.coverage_details.totalPresent) {
            let lastObjKey = coverageDataKeys[coverageDataKeys.length - 1];
            this.researchDetails.coverage_details.totalData = this.researchDetails.coverage_details.coverageData[lastObjKey];
            delete this.researchDetails.coverage_details.coverageData[lastObjKey];
            this.researchDetails.coverage_details.coverageDetailsLength = this.researchDetails.coverage_details.coverageDetailsLength - 1;
          }
        }
        else {
          this.researchDetails.coverage_details.coverageDetailsLength = 0;
        }
      }
      if (this.researchDetails.target_group) {
        let groupKeys = Object.keys(this.researchDetails.target_group);
        let count = 0;
        let methCount = 0;
        groupKeys.forEach(ele => {
          if (this.researchDetails.target_group[ele]) {
            count = count + 1;
          }
        })
        if (this.researchDetails.methodology) {
          this.researchDetails.methodology.forEach(ele => {
            if (ele) {
              count = count + 1;
              methCount = methCount + 1;
            }
          })
        }

        if (methCount > 0) {
          this.isMethodology = true;
        }
        else {
          this.isMethodology = false;
        }

        if (count == 0) {
          this.researchDetails.target_group = null;
        }
      }

      if(this.researchDetails.concepts_details){
        this.researchDetails.concepts_details.forEach((concept,index)=> {
          let kpiKeysArr = Object.keys(concept.kpis);
          kpiKeysArr.forEach((key, ind) => {
            if (!concept.kpis[key]) delete this.researchDetails.concepts_details[index]['kpis'][key];
          })
        })
        let count = 0;
        this.researchDetails.concepts_details.forEach((concept,index)=> {
          let kpiKeysArr = Object.keys(concept.kpis);
          if (kpiKeysArr.length > 6) count++;
          this.researchDetails.concepts_details[index].isKPIExpanded = false;
          this.researchDetails.concepts_details[index].kpiLength = kpiKeysArr.length;
        })
        if(count > 0) this.shouldKPIExpandedVisible = true;
      }
    }
  }

  formatFileType(file_type) {
    switch (file_type) {
      case "report": file_type = 'Report';
        break;
      case "questionnaire": file_type = 'Questionnaire';
        break;
      case "dataTable-abs": file_type = 'Data Table - ABS';
        break;
      case "Data Table - ABS": file_type = 'dataTable-abs';
        break;
      case "dataTable-pct": file_type = 'Data Table - PCT';
        break;
      case "Data Table - PCT": file_type = 'dataTable-pct';
        break;
      case "image": file_type = 'Image';
        break;
      case "video": file_type = 'Video';
        break;
      case "kpiViewer": file_type = 'Topline Report';
        break;
      case "Topline Report": file_type = 'kpiViewer';
        break;
      case "audio": file_type = 'Audio';
        break;
      case "translation": file_type = 'Translation';
        break;
      case "transcript": file_type = 'Transcript';
        break;
      case 'survey_translation_report': file_type = 'Survey Translation Report';
        break;
      case 'zip':
         file_type = 'ZIP File';
        break;  
      default: file_type = 'None';
        break;

    }
    return file_type;
  }

  deleteCurrentFile(file, uuid) {
    this.deleteFile({ uuid: file.file_uuid })
      .subscribe((res) => {
        if (res['status'] == 1) {
          this.notifier.notify('success', 'File deleted successfully');
          var removeIndex = this.reportDetailFiles.map(item => item.file_uuid).indexOf(file.file_uuid);
          if (removeIndex > -1) {
            this.reportDetailFiles.splice(removeIndex, 1);
          }
          this.getRepositoryDetail(uuid); 
          if(file.survey_translation_report){
            this.getRepositoryFilesPagination(uuid,{ page: 1, limit: 20});
          }
        }else if (res['status'] == 2){
          this.notifier.notify('error', "You cannot delete this file as it is used in group summary");
        }
        else {
          this.notifier.notify('error', 'Something went wrong');
        }
      })
  }
  downloadRequestFromService = (type?: string) => {
    this.isLoading = true;
    if (this.router.url.includes("qual")) {
      this.downloadQualFile(type).subscribe(
        (result) => {
          if (result["status"] == 1) {
            if (type == "audio") {
              this.downloadFileFunction(this.isAudioFile?this.isAudioFile:result['url'][0]);
              // this.downloadFileFunction(this.isAudioFile?this.isAudioFile:result['url'][1]);
            } else if(type === 'abs' || type === 'pct' || type === 'both') {
              this.downloadFileFunction(result['url'][0]);
            }
            else if(type === 'translation_original' || type === 'translated_combined' || type === 'translated_split' || type === 'translated_original') {
              this.downloadFileFunction(result['url'][0]);
            }else if(this.ZipTranslationDownloadOptions.some((option) => option.id === type)) {
              this.downloadFileFunction(result['url'][0]);
            }else {
              this.downloadFileFunction(this.isVideoFile?this.isVideoFile:result['url'][0]);
            }
          }
          // this.CloseDialoge();
          this.isLoading = false;
        },
        (error) => {
          // console.log("error : ", error);
          // this.CloseDialoge();
          this.isLoading = false;
        }
      );
    } else {

      this.downloadFile(type).subscribe(
        (result) => {
          if (result["status"] == 1) {
            if (type == "audio") {
              let url = this.isAudioFile?this.isAudioFile:result['url'][0];
              // let url = this.isAudioFile?this.isAudioFile:result['url'][1];
              this.downloadFileFunction(url);
            } 
            else if(type === 'abs' || type === 'pct' || type === 'both') {
              this.downloadFileFunction(result['url'][0]);
            }
            else if(type === 'translation_original' || type === 'translated_combined' || type === 'translated_split' || type === 'translated_original') {
              this.downloadFileFunction(result['url'][0]);
            }else if(this.ZipTranslationDownloadOptions.some((option) => option.id === type)) {
              this.downloadFileFunction(result['url'][0]);
            }else {
              let url = this.isVideoFile?this.isVideoFile:result['url'][0];
              this.downloadFileFunction(url);
            }
          }
          else if(result["status"] == 4){
            this.notifier.notify('error',result['message']);
            this.redirectUnAuthorizedEvent.emit('unauthorized');
          }
          // this.CloseDialoge();
          this.isLoading = false;
        },
        (error) => {
          // console.log("error : ", error);
          // this.CloseDialoge();
          this.isLoading = false;
        }
      );
    }
  }
  downloadICVTranscript(type: string) {
    this.isLoading = true;
    // this.downloadFileOfType("https://research-crownit.s3.ap-southeast-1.amazonaws.com//vi/transcript/Mock_1_1731563088892%20%282%29_copy_1742362297489.pdf?AWSAccessKeyId=AKIAIBN57CG5R3WYJHCQ&Expires=1742365897&Signature=SEDc3%2F1rmB6u6OohZZL5hZvNoEI%3D","doc");
    // this.downloadFileOfType1("https://research-crownit.s3.ap-southeast-1.amazonaws.com//vi/transcript/Mock_1_1731563088892%20%282%29_copy_1742362297489.pdf?AWSAccessKeyId=AKIAIBN57CG5R3WYJHCQ&Expires=1742365897&Signature=SEDc3%2F1rmB6u6OohZZL5hZvNoEI%3D","doc");
    this.downloadICVTranscriptApi(type).subscribe(
      (result) => {
        if (result["status"] == 1) {
          let fileType = type == 'pdf' ? 'pdf' : type == 'word' ? 'doc' : this.fileType;
          this.downloadFileOfType(result['url'],fileType);
          // this.downloadFileFromBlob(result['url'],fileType);
          // this.downloadFileFromBlob(result['url']);
        }
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }
  downloadFileFunction(url) {
    const data = url;
    this.ahref.setAttribute("href", url);
    this.ahref.setAttribute("target", "_blank");
    this.ahref.setAttribute(
      "download",
      this.fileName + "." + this.fileType
    );
    this.ahref.click();
  }

  downloadFileOfType(url,type) {
    const data = url;
    this.ahref.setAttribute("href", url);
    this.ahref.setAttribute("target", "_blank");
    this.ahref.setAttribute(
      "download",
      this.fileName + "." + type
    );
    this.ahref.click();
  }

  
  SignificancePanelClose()
  {
    this.isSignificanceTest = false;
  }
  // onSubmitSignificanceRequest() {
  //   if (this.isData) {
  //     if (this.sigComparetype === 'AmongColumn') {
  //       if (this.sigConfidenceLevel) {
  //         this.OpenSigModal();
  //         this.sigsubmitForm['type'] = this.sigComparetype;
  //         this.sigsubmitForm['confidence'] = this.sigConfidenceLevel;
  //         this.sigfromAmongarr = [{ withRespect: '', toColumn: [] }];
  //         let body = {};
  //         // body['data'] = this.mainJsonDataForSig;
  //         body['data'] = [];
  //         body['request'] = [];
  //         body['significance_test'] = this.sigsubmitForm;
  //         body['file_uuid'] = this.fileUUID;
  //         body['sigType'] = 'crossTab'
  //         body['small_base'] = this.sigSmallBaseToggleButton;
  //         // console.log(body, 'body');
  //         this.getSignificanceTable(body);
  //         this.isSignificanceTest = false;
  //         this.sigsubmitForm = {};
  //         this.sigComparetypeCopy = this.sigComparetype;
  //         this.sigConfidenceLevelCopy = this.sigConfidenceLevel;
  //       }
  //       else {
  //         this.notifier.notify('error', 'Please select confidence level');
  //       }
  //     }
  //     else {
  //       let d = this.sigfromAmongarr.find((va) => !va['withRespect'] && va['withRespect'] == '' || va['toColumn'].length === 0);
  //       if (d) {
  //         this.notifier.notify('error', 'Please select  value')
  //       }
  //       else {
  //         if (this.sigConfidenceLevel) {
  //           this.OpenSigModal();
  //           this.sigsubmitForm['type'] = this.sigComparetype;
  //           this.sigsubmitForm['confidence'] = this.sigConfidenceLevel;
  //           this.sigsubmitForm['significanceValueArray'] = this.sigfromAmongarr;
  //           let body = {};
  //           // body['data'] = this.mainJsonDataForSig;
  //           body['data'] = [];
  //           body['request'] = [];
  //           body['significance_test'] = this.sigsubmitForm;
  //           body['file_uuid'] = this.fileUUID;
  //           body['sigType'] = 'crossTab'
  //           body['small_base'] = this.sigSmallBaseToggleButton;
  //           body['save'] = this.sigSaveResultToggleButton;
  //           // console.log(body,this.reportService.sigfromAmongarr, 'body');
  //           this.getSignificanceTable(body);
  //           this.isSignificanceTest = false;
  //           this.sigsubmitForm = {};
  //           this.sigComparetypeCopy = this.sigComparetype;
  //           this.sigConfidenceLevelCopy = this.sigConfidenceLevel;
  //         }
  //         else {
  //           this.notifier.notify('error', 'Please select confidence level');
  //         }
  //       }
  //     }
  //   }
  //   else {
  //     if (this.sigComparetype === 'AmongColumn') {
  //       if (this.sigConfidenceLevel) {
  //         this.OpenSigModal();
  //         this.sigsubmitForm['type'] = this.sigComparetype;
  //         this.sigsubmitForm['confidence'] = this.sigConfidenceLevel;
  //         this.sigfromAmongarr = [{ withRespect: '', toColumn: '' }];
  //         let body = {};
  //         body['significance_test'] = this.sigsubmitForm;
  //         body['file_uuid'] = this.fileUUID;
  //         body['sigType'] = 'all'
  //         body['small_base'] = this.sigSmallBaseToggleButton;
  //         this.getSignificanceTable(body);
  //         this.isSignificanceTest = false;
  //         this.sigsubmitForm = {};
  //         this.sigComparetypeCopy = this.sigComparetype;
  //         this.sigConfidenceLevelCopy = this.sigConfidenceLevel;
  //       }
  //       else {
  //         this.notifier.notify('error', 'Please select confidence level');
  //       }
  //     }
  //     else {
  //       let d = this.sigfromAmongarr.find((va) => !va['withRespect'] && va['withRespect'] == '' || va['toColumn'].length === 0);
  //       if (d) {
  //         this.notifier.notify('error', 'Please select  value');
  //       }
  //       else {
  //         if (this.sigConfidenceLevel) {
  //           this.OpenSigModal();
  //           this.sigsubmitForm['type'] = this.sigComparetype;
  //           this.sigsubmitForm['confidence'] = this.sigConfidenceLevel;
  //           this.sigsubmitForm['significanceValueArray'] = this.sigfromAmongarr;
  //           let body = {};
  //           body['significance_test'] = this.sigsubmitForm;
  //           body['file_uuid'] = this.fileUUID;
  //           body['sigType'] = 'all'
  //           body['small_base'] = this.sigSmallBaseToggleButton;
  //           body['save'] = this.sigSaveResultToggleButton;
  //           this.getSignificanceTable(body);
  //           this.isSignificanceTest = false;
  //           this.sigsubmitForm = {};
  //           this.sigComparetypeCopy = this.sigComparetype;
  //           this.sigConfidenceLevelCopy = this.sigConfidenceLevel;
  //         }
  //         else {
  //           this.notifier.notify('error', 'Please select confidence level');
  //         }
  //       }
  //     }
      
  //   }
  // }
  onSubmitSignificanceRequest() {
    // this.OpenSigModal();
    // return
    if (this.sigComparetype === 'AmongColumn') {
      if (this.sigConfidenceLevel) {
        this.OpenSigModal();
        this.sigsubmitForm['type'] = this.sigComparetype;
        this.sigsubmitForm['confidence'] = this.sigConfidenceLevel;
        this.sigfromAmongarr = [{ withRespect: '', toColumn: '' }];
        let body = {};
        let lastRequest = JSON.parse(JSON.stringify(this.lastRequest))
        body['data'] = [];
        body['request'] = lastRequest;
        body['significance_test'] = this.sigsubmitForm;
        body['file_uuid'] = this.fileUUID;
        body['sigType'] = this.sigTestingOn === 'FullCrosstab' ? 'all' : 'crossTab'
        body['sigBase'] = this.sigBase;
        body['small_base'] = this.sigSmallBaseToggleButton;
        let tempBody = JSON.parse(JSON.stringify(body));
        tempBody['params'] = {"type":""};
        tempBody['params']['type'] = (this.sigTestingtype && this.sigTestingtype == 'beta') ?'beta':'';
        delete tempBody.request
        this.lastRequest['sig'] = tempBody
        this.getSignificanceTable(body);
        this.isSignificanceTest = false;
        this.sigsubmitForm = {};
        this.sigComparetypeCopy = this.sigComparetype;
        this.sigConfidenceLevelCopy = this.sigConfidenceLevel;
      }
      else {
        this.notifier.notify('error', 'Please select confidence level');
      }
    }
    else {
      let d = this.sigfromAmongarr.find((va) => !va['withRespect'] && va['withRespect'] == '' || va['toColumn'].length === 0);
      if (d) {
        this.notifier.notify('error', 'Please select  value');
      }
      else {
        if (this.sigConfidenceLevel) {
          this.OpenSigModal();
          this.sigsubmitForm['type'] = this.sigComparetype;
          this.sigsubmitForm['confidence'] = this.sigConfidenceLevel;
          this.sigsubmitForm['significanceValueArray'] = this.sigfromAmongarr;
          let body = {};
          let lastRequest = JSON.parse(JSON.stringify(this.lastRequest))
          lastRequest["getData"]['dataValue'] = lastRequest["getData"]['dataValue']=="absolute"?"abs": lastRequest["getData"]['dataValue'] == "percentage"? "pct": lastRequest["getData"]['dataValue']=="both"?"both":lastRequest["getData"]['dataValue'];
          body['data'] = [];
          body['request'] = lastRequest;
          body['significance_test'] = this.sigsubmitForm;
          body['file_uuid'] = this.fileUUID;
          body['sigType'] = this.sigTestingOn === 'FullCrosstab' ? 'all' : 'crossTab'
          body['sigBase'] = this.sigBase;
          body['small_base'] = this.sigSmallBaseToggleButton;
          body['save'] = this.sigSaveResultToggleButton;
          let tempBody = JSON.parse(JSON.stringify(body));
          delete tempBody.request;
          tempBody['params'] = {"type":""};
          tempBody['params']['type'] = (this.sigTestingtype && this.sigTestingtype == 'beta') ?'beta':'';
          this.lastRequest['sig'] = tempBody
          this.getSignificanceTable(body);
          this.isSignificanceTest = false;
          this.sigsubmitForm = {};
          this.sigComparetypeCopy = this.sigComparetype;
          this.sigConfidenceLevelCopy = this.sigConfidenceLevel;
        }
        else {
          this.notifier.notify('error', 'Please select confidence level');
        }
      }
    }      
  }
  sigResultsideTab(){
    this.sigResultTabOpen = true;
    // this.sigResultInit();
  }
  sigResultsideTabCloase(){
    this.sigResultTabOpen = false;
  }
  OpenSigModal() {
    this.dialoge.open(SigTestModalComponent,
    {
      width: "400px",
      height: '270px',
      data:{
        type:'SigTestModal'
      }
    });
    setTimeout(() => {
      this.dialoge.closeAll();
    }, 5000)

  }

  onSignificanceReset() {
    this.sigConfidenceLevel = 95;
    this.sigComparetype = 'AmongColumn';
    this.sigfromAmongarr = [{ withRespect: '', toColumn: [] }];
    this.sigsubmitForm = {};
    // this.sigConfidenceLevelCopy = "";
    // this.sigComparetypeCopy = "";
    this.sigSubmitFormFlag = false;
    this.sigSmallBaseToggleButton = false;
    this.sigResultArr = [];
    // this.SigResultClearOnngDestroy();
    
  }
  sigResultNext(){
    this.sigresultiterateIndex += 1;
    if(this.sigresultsidecutIndex < this.sigResultArr.length)
    {
      let sidekeyvaluearr:any,sidecutresultarr:any;
      sidekeyvaluearr = Object.values(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
      sidecutresultarr = Object.keys(this.sigResultArr[this.sigresultsidecutIndex]['result']).length;
      if(this.sigresultiterateIndex === sidekeyvaluearr.length)
      {
        this.sigresultiterateIndex = 0;
        this.sigresultsidekeyIndex += 1;
        this.sigresultbordersidekey = Object.keys(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
        this.sigresultborderIndex = 0;
        if(this.sigresultsidekeyIndex === sidecutresultarr)
        {
          this.sigresultiterateIndex = 0;
          this.sigresultsidecutIndex += 1;
          this.sigresultsidekeyIndex = 0;
          this.sigresultsidecutIndexContainer = [];
          this.sigresultsidecutIndexContainer.push(this.sigresultsidecutIndex);
          this.sigresultbordersidecut = this.sigResultArr[this.sigresultsidecutIndex]['sidecut'];
          this.sigresultbordersidekey = Object.keys(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
          this.sigresultborderIndex = 0;
        }
      }
      else
      {
        this.sigresultborderIndex = this.sigresultiterateIndex;
      }
      let objvalue = Object.values(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
      // console.log(this.sigresultiterateIndex,this.sigresultsidekeyIndex,'SigresultIterarte');
      this.selectSigResult(objvalue[this.sigresultiterateIndex],this.sigResultArr[this.sigresultsidecutIndex].overallLength,this.sigResultArr[this.sigresultsidecutIndex].sidecut,this.sigResultArr[this.sigresultsidecutIndex].sidecutUUID)
    }
    else
    {
      this.sigresultsidecutIndex = 0;
      this.sigresultsidekeyIndex = 0;
      this.sigresultiterateIndex = 0;
      this.sigresultbordersidecut = this.sigResultArr[this.sigresultsidecutIndex]['sidecut'];
      this.sigresultbordersidekey = Object.keys(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
      this.sigresultborderIndex = 0;
      this.sigresultsidecutIndexContainer = [0];
    }
    let currentBorderResultdiv = <HTMLDivElement>  document.getElementsByClassName("border-result-link")[0];
    // console.log(currentBorderResultdiv,'BorderResult');
    // currentBorderResultdiv.focus();
    currentBorderResultdiv.scrollIntoView();
  }
  sigResultPrev(){
    this.sigresultiterateIndex -= 1;
    if(this.sigresultiterateIndex === -1 && this.sigresultsidekeyIndex === 0 && this.sigresultsidecutIndex === 0)
    {
      this.sigResultInit();
      this.sigresultiterateIndex = 0;
    }
    if(this.sigresultiterateIndex === -1 && this.sigresultsidekeyIndex === 0 && this.sigresultsidecutIndex >= 1)
    {
      this.sigresultsidecutIndex -= 1;
      this.sigresultbordersidecut = this.sigResultArr[this.sigresultsidecutIndex]['sidecut'];
      let resultlength = Object.keys(this.sigResultArr[this.sigresultsidecutIndex]['result']).length -1;
      this.sigresultsidekeyIndex = resultlength;
      this.sigresultbordersidekey = Object.keys(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
      let lastsidekeyreslength:any;
      lastsidekeyreslength = Object.values(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
      this.sigresultiterateIndex = lastsidekeyreslength.length-1;
      this.sigresultsidecutIndexContainer = [];
      this.sigresultsidecutIndexContainer.push(this.sigresultsidecutIndex);
      this.sigresultborderIndex = this.sigresultiterateIndex;
    }
    if(this.sigresultiterateIndex === -1 && this.sigresultsidekeyIndex >= 1)
    {
      this.sigresultsidekeyIndex -= 1;
      let sidekeyvaluearr:any;
      sidekeyvaluearr = Object.values(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
      this.sigresultbordersidekey = Object.keys(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
      this.sigresultiterateIndex = sidekeyvaluearr.length-1;
      this.sigresultborderIndex = this.sigresultiterateIndex;
    }
    else
    {
      this.sigresultborderIndex = this.sigresultiterateIndex;
    }

    let objvalue = Object.values(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
    // console.log(objvalue[this.sigresultiterateIndex],'ELSE');
    // console.log("rrrrrrr ===>",Object.values(this.sigResultArr[this.sigresultsidecutIndex]['result'][this.sigresultsidekeyIndex][this.sigresultiterateIndex]))
    // console.log(this.sigResultArr[this.sigresultsidecutIndex].overallLength,this.sigResultArr[this.sigresultsidecutIndex].sidecut)
    this.selectSigResult(objvalue[this.sigresultiterateIndex],this.sigResultArr[this.sigresultsidecutIndex].overallLength,this.sigResultArr[this.sigresultsidecutIndex].sidecut,this.sigResultArr[this.sigresultsidecutIndex].sidecutUUID);
    setTimeout(() =>
    {
      let currentBorderResultdiv = <HTMLDivElement>  document.getElementsByClassName("border-result-link")[0];
      // console.log(currentBorderResultdiv,'BorderResult Prev');
      currentBorderResultdiv.scrollIntoView();
    },200);
    // currentBorderResultdiv.focus();

  }
  BorderResultLink(sidecutindex,sidekeyindex,index,valueAtIndex,cellDetails)
  {
    this.sigresultsidecutIndex = sidecutindex;
    this.sigresultsidekeyIndex = sidekeyindex;
    this.sigresultbordersidecut = this.sigResultArr[this.sigresultsidecutIndex]['sidecut'];
    this.sigresultbordersidekey = Object.keys(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
    this.sigresultborderIndex = index;
    this.sigresultiterateIndex = this.sigresultborderIndex;
    this.selectSigResult(cellDetails.result,cellDetails.overallLength,cellDetails.cutName,cellDetails.sidecutUUID);
    this.sigHighlightsResultIterateIndex = 0;
    this.findIterateIndexForHighResult(sidecutindex,valueAtIndex);
  }
  findIterateIndexForHighResult(mainIndex,valueAtIndex){
    let indexFind = this.sigResultArr[mainIndex]['sigHighlightResult'].
    findIndex((va:any) => (va['colIndex'] === valueAtIndex['colIndex'] && va['rowIndex'] === valueAtIndex['rowIndex']));
    if(indexFind != -1)
    {
      let result_finder = this.agGridData.find((va:any) => va['sideCut'] === this.sigResultArr[mainIndex]['sidecut']);
      if(result_finder)
      {
        result_finder['IterationSigHighResult'] = indexFind;
      }
      // this.sigHighlightsResulSidecutIndex = mainIndex;
      // console.log('IterPart',this.sigHighlightsResultIterateIndex,this.sigHighlightsResulSidecutIndex);
      // console.log('ValuePart',valueAtIndex);
    }
  }
  sigResultInit(){
    this.sigresultbordersidecut = this.sigResultArr[this.sigresultsidecutIndex]['sidecut'];
    this.sigresultbordersidekey = Object.keys(this.sigResultArr[this.sigresultsidecutIndex]['result'])[this.sigresultsidekeyIndex];
    this.sigresultborderIndex = 0;
  }

  selectSigResult(result,overallLength,cutName,cutUUID){
    result['overallLength'] = overallLength;
    result['cutName'] = cutName;
    result['cutUUID'] = cutUUID;
    this.emitSigResultClick.emit(result)
  }

  slugGenerator(str){
    return str.toLowerCase().replaceAll(' ', '-')
  }

  sigHighResultPrev(event,Tab){
    event.stopPropagation();
    Tab['IterationSigHighResult'] -= 1;
    this.sigHighlightsResultIterateIndex = Tab['IterationSigHighResult'];
    if(this.sigHighlightsResultIterateIndex < 0)
    {
      this.sigHighlightsResultIterateIndex = 0;
      Tab['IterationSigHighResult']  = 0;
      
    }
    let obj = Tab['sigHighlightResult'][this.sigHighlightsResultIterateIndex];
    let overallFind = this.sigResultArr.find((va) => (va['sidecut'] === Tab['sideCut']));
    this.selectSigResult(obj,overallFind.overallLength,Tab['sideCut'],Tab['sideCutKey_UUID']);
    // console.log(this.sigHighlightsResultIterateIndex,'Prev');
  }
  sigHighResultNext(event,Tab){
    event.stopPropagation();
    Tab['IterationSigHighResult'] += 1;
    this.sigHighlightsResultIterateIndex = Tab['IterationSigHighResult'];
    let HighArr = Tab['sigHighlightResult'].length
    if(this.sigHighlightsResultIterateIndex === HighArr)
    {
      this.sigHighlightsResultIterateIndex = HighArr-1;
      Tab['IterationSigHighResult']  = HighArr -1;
    }
    let obj = Tab['sigHighlightResult'][this.sigHighlightsResultIterateIndex];
    let overallFind = this.sigResultArr.find((va) => (va['sidecut'] === Tab['sideCut']));
    this.selectSigResult(obj,overallFind.overallLength,Tab['sideCut'],Tab['sideCutKey_UUID']);
    // console.log(this.sigHighlightsResultIterateIndex,'Next');
  }

  SigResultClearOnngDestroy()
  {
    this.sigresultbordersidecut = null;
    this.sigresultbordersidekey = null;
    this.sigresultborderIndex = 0;
    this.sigresultsidecutIndex = 0;
    this.sigresultsidekeyIndex = 0;
    this.sigresultiterateIndex = 0;
    this.sigresultsidecutIndexContainer = [0];
    this.sigHighlightsResultIterateIndex = 0;
  }


  // cellDetailsRenderer(params) {
  //   if (params.node.data[params.column.colDef.field + ' text'] && params.node.data[params.column.colDef.field + ' text'] != '') {
  //       var description =
  //         '<div style="background-color:#eaeaea"> '+params.node.data[params.column.colDef.field + ' text']+'</div>';
  //       return (
  //         '<div style="cursor: default; padding:unset; margin:unset;">' +
  //         params.value+
  //         `</div><div style="cursor: default; padding-top:10px; margin:unset; ;" [matTooltip]="'hwllo'" >` +
  //         description +
  //         '</div>'
  //       );
  //   }else{
  //       return (
  //         '<div style="cursor: default; padding:unset; margin:unset;">' +
  //         params.value+
  //         ' </div>'
  //       );
  //   }
  // }

  createTopline(){
    this.router.navigate(['topline/report',this.fileUUID]);
    // this.router.navigate(['home/repository-report/topline',this.fileUUID]);
  }
  // openToplineAlias(){
  //   this.router.navigate(['home/repository-report/topline/alias',this.fileUUID]);
  // }

  openDownloadAllFiles(study_id){
    this.isDownloadAllFiles = true;
    this.getAllDownloadableFiles(study_id);
  }

  closeDownloadAllFiles(){
    this.isDownloadAllFiles = false
  }

  destroyDownloadAllFiles(){
    this.isDownloadAllFiles = false
    this.isHideFileListForSpecificStudies = false;
    this.downloadableFileList = [];
    this.allFileListOfRepo = [];
    this.allFileListOfRepoBackup = [];
    this.isDownloadableFileProcessing = false;
  }

  getAllDownloadableFiles(study_id){
    this.downloadableFileList = [];
    this.allFileListOfRepo = [];
    let body = {
      "study_id":study_id
    }
    this.getAllFileListOfRepository(body).subscribe(result=>{
      if (result['status'] == 1) {
        result['files'] = result['files'] || [];
        this.allFileListOfRepo = result['files'];
        this.allFileListOfRepoBackup = JSON.parse(JSON.stringify(result['files']))
      }else{
        // this.notifier.notify("error","Something went wrong!")
      }
    },error =>{
      this.notifier.notify("error","Something went wrong!")
    })
    this.getAllDownloadableZipFiles(study_id)
  }

  getAllDownloadableZipFiles(study_id){
    let body = {
      "study_id":study_id
    }
    this.getAllDownloadableFilesOfRepository(body).subscribe(result=>{
      if (result['status'] == 1) {
        this.downloadableFileList = result['data']
        this.isDownloadableFileProcessing = result['processing'];
        // setTimeout(() => {
        //   this.isDownloadableFileProcessing = false;
        // }, 500);
      }else{
        // this.notifier.notify("error","Something went wrong!")
      }
    },error =>{
      this.notifier.notify("error","Something went wrong!")
    })
  }

  copySummary() {
    const contentDiv = document.querySelector('.summary-body') as HTMLElement;
    // Use the Range API to get the content of the div
    const range = document.createRange();
    range.selectNodeContents(contentDiv);
    // Use a temporary selection to copy the content
    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);
    try {
      // Execute the copy command
      const successful = document.execCommand('copy');
      if (successful) {
        this.notifier.notify('success','Summary copied to clipboard!')
      } else {
        this.notifier.notify('error','Copy summry failed.')
      }
    } catch (err) {
      this.notifier.notify('error','Something went wrong while copying summry')
    }
    // Deselect the content after copying
    selection?.removeAllRanges();
  }

  initSummaryCustomCSS(){
    if (this.summaryInnerHtml && this.summaryInnerHtml != "") {
      this.summaryInnerHtml = this.summaryInnerHtml.replace(/<h1>/g, '<h1 style="font-size:16px !important;">');
      this.summaryInnerHtml = this.summaryInnerHtml.replace(/<h2>/g, '<h2 style="font-size:16px !important;">');
      this.summaryInnerHtml = this.summaryInnerHtml.replace(/<h3>/g, '<h3 style="font-size:16px !important;">');
      this.summaryInnerHtml = this.summaryInnerHtml.replace(/<h4>/g, '<h4 style="font-size:16px !important;">');
      this.summarySafeInnerHtml = this.sanitizer.bypassSecurityTrustHtml(this.summaryInnerHtml);
    }

    if (this.studySummaryInnerHtml && this.studySummaryInnerHtml != "") {
      this.studySummaryInnerHtml = this.studySummaryInnerHtml.replace(/<h1>/g, '<h1 style="font-size:16px !important;">');
      this.studySummaryInnerHtml = this.studySummaryInnerHtml.replace(/<h2>/g, '<h2 style="font-size:16px !important;">');
      this.studySummaryInnerHtml = this.studySummaryInnerHtml.replace(/<h3>/g, '<h3 style="font-size:16px !important;">');
      this.studySummaryInnerHtml = this.studySummaryInnerHtml.replace(/<h4>/g, '<h4 style="font-size:16px !important;">');
      this.studySummarySafeInnerHtml = this.sanitizer.bypassSecurityTrustHtml(this.studySummaryInnerHtml);
    }
  }

  updateFileForVideoAnalyzer(uuid,extraParams){
    let body = {
      data: this.MatSelectFileArray[0],
      uuid: uuid,
    }
    if(extraParams && Object.keys(extraParams).length > 0)body = {...body,...extraParams};
    this.updateFileOfVideoAnalyzerApiCall(body,this.file_repo_id).subscribe(result=>{
      if (result['status'] == 1) {
        this.isFileUpdatePanelOpen = false;
        this.getRepositoryDetail(uuid);
        let query = {"page":1,"page_size":20}
        this.getRepositoryFilesPagination(uuid,query);
        this.notifier.notify("success","File updated successfully!");
      }else{
        this.notifier.notify("error","Something went wrong!")
      }
    },error =>{
      this.notifier.notify("error","Something went wrong!")
      console.error('Error updating file for video analyzer:', error);
    })
  }

  switchRepoAndFileList(switch_to:string){
    if(switch_to === 'repo'){
      this.router.navigate(['/repo']);
    }else if(switch_to === 'fileList'){
      this.router.navigate(['/repo/all-files']);
    }
  }

  getStudySummary(studyId, body){
    return this.apiRequest.request('POST','/v2/summary/'+studyId,body);
  }
  downloadGroupSummary(body){
    return this.apiRequest.request('POST','/v2/download/summary',body);
  }
  
}

